// Game SEO: patterns, gamesSlugMap, optional gameSeo per `/p/{provider}/{game}` (use `{brand}` in copy).
// Keep in sync with libs/content/src/lib/seo/en.json. Slug map names must match catalog API (GameInfo / ProviderInfo).
// Patterns — {game}, {provider}, {brand} substituted at runtime
export const gameSeoPatterns = {
    title: 'Play {game} by {provider} | {brand}',
    description: 'Play {game} by {provider} at {brand}. Crypto deposits, instant withdrawals, demo play, and fast payouts on this online slot.'
};
// slug → game info map — generated from catalog (pnpm sync:catalog-sitemap)
export { gamesSlugMap } from './games-slug-map.generated.js';
const gameSeoBase = {
    '/p/bgaming/alice_wonderluck': {
        title: 'Alice Wonderluck Slot | 10,000x Max Win | {brand}',
        description: 'Play Alice Wonderluck slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/alien_fruits': {
        title: 'Alien Fruits Slot | 15,000x Max Win | {brand}',
        description: 'Play Alien Fruits slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/alien_fruits_2': {
        title: 'Alien Fruits 2 Slot | 5,000x Max Win | {brand}',
        description: 'Play Alien Fruits 2 slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/all_star_fruits': {
        title: 'All Star Fruits Slot | 1,500x Max Win | {brand}',
        description: 'Play All Star Fruits slot with Bitcoin at {brand}. Medium-High volatility, 1,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/aloha_king_elvis': {
        title: 'Aloha King Elvis Slot | 2,000x Max Win | {brand}',
        description: 'Play Aloha King Elvis slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, 5x3 grid. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/arrow_slot': {
        title: 'Arrow Slot Slot | 3,600x Max Win | {brand}',
        description: 'Play Arrow Slot slot with Bitcoin at {brand}. Medium-High volatility, 3,600x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/avalon_the_lost_kingdom': {
        title: 'Avalon The Lost Kingdom Slot | 5,000x Max Win | {brand}',
        description: 'Play Avalon The Lost Kingdom slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/aviamasters': {
        title: 'Aviamasters Slot | 250x Max Win | {brand}',
        description: 'Play Aviamasters slot with Bitcoin at {brand}. Medium-High volatility, 250x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/aviamasters_2': {
        title: 'Aviamasters 2 Slot | 1,000x Max Win | {brand}',
        description: 'Play Aviamasters 2 slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/aztec_clusters': {
        title: 'Aztec Clusters Slot | 10,000x Max Win | {brand}',
        description: 'Play Aztec Clusters slot with Bitcoin at {brand}. Very High volatility, 10,000x max win, cluster pays on 6x8. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/aztec_magic_bonanza': {
        title: 'Aztec Magic Bonanza Slot | 10,200x Max Win | {brand}',
        description: 'Play Aztec Magic Bonanza slot with Bitcoin at {brand}. High volatility, 10,200x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/aztec_magic_deluxe': {
        title: 'Aztec Magic Deluxe Slot | 5,000x Max Win | {brand}',
        description: 'Play Aztec Magic Deluxe slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/aztec_magic_megaways': {
        title: 'Aztec Magic Megaways Slot | 12,960x Max Win | {brand}',
        description: 'Play Aztec Magic Megaways slot with Bitcoin at {brand}. High volatility, 12,960x max win, megaways mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/aztecs_claw_wild_dice': {
        title: "Aztec's Claw Wild Dice Slot | 6,000x Max Win | {brand}",
        description: "Play Aztec's Claw Wild Dice slot with Bitcoin at {brand}. Medium-High volatility, 6,000x max win, dice mechanic. Crypto deposits, instant withdrawals."
    },
    '/p/bgaming/balloon_mania': {
        title: 'Balloon Mania Slot | 64x Max Win | {brand}',
        description: 'Play Balloon Mania slot with Bitcoin at {brand}. Medium-High volatility, 64x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/beast_band': {
        title: 'Beast Band Slot | 7,500x Max Win | {brand}',
        description: 'Play Beast Band slot with Bitcoin at {brand}. Medium-High volatility, 7,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/beer_bonanza': {
        title: 'Beer Bonanza Slot | 15,000x Max Win | {brand}',
        description: 'Play Beer Bonanza slot with Bitcoin at {brand}. High volatility, 15,000x max win, Crypto deposits, instant withdrawals No fees, fast crypto payouts.'
    },
    '/p/bgaming/big_atlantis_frenzy': {
        title: 'Big Atlantis Frenzy Slot | 4,248x Max Win | {brand}',
        description: 'Play Big Atlantis Frenzy slot with Bitcoin at {brand}. Medium-High volatility, 4,248x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/blackbeards_bounty': {
        title: "Blackbeard's Bounty Slot | 20,000x Max Win | {brand}",
        description: "Play Blackbeard's Bounty slot with Bitcoin at {brand}. Medium-High volatility, 20,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/bgaming/blazing_fire_pots_hold_and_spin': {
        title: 'Blazing Fire Pots Hold And Spin Slot | 5,000x Max Win | {brand}',
        description: 'Play Blazing Fire Pots Hold And Spin with crypto at {brand}. Medium-High volatility, 5,000x max win. BTC, ETH, USDT accepted.'
    },
    '/p/bgaming/bonanza_billion': {
        title: 'Bonanza Billion Slot | 15,000x Max Win | {brand}',
        description: 'Play Bonanza Billion slot with Bitcoin at {brand}. High volatility, 15,000x max win, scatter pays mechanic on 6x6 grid. Crypto deposits.'
    },
    '/p/bgaming/bonanza_billion_xtreme': {
        title: 'Bonanza Billion Xtreme Slot | 20,000x Max Win | {brand}',
        description: 'Play Bonanza Billion Xtreme slot with Bitcoin at {brand}. Very High volatility, 20,000x max win, scatter pays. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/bonanza_trillion': {
        title: 'Bonanza Trillion Slot | 5,000x Max Win | {brand}',
        description: 'Play Bonanza Trillion slot with Bitcoin at {brand}. High volatility, 5,000x max win, scatter pays. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/bone_bonanza': {
        title: 'Bone Bonanza Slot | 14,134x Max Win | {brand}',
        description: 'Play Bone Bonanza slot with Bitcoin at {brand}. High volatility, 14,134x max win, Crypto deposits, instant withdrawals No fees, fast crypto payouts.'
    },
    '/p/bgaming/book_of_cats': {
        title: 'Book Of Cats Slot | 10,000x Max Win | {brand}',
        description: 'Play Book Of Cats slot with Bitcoin at {brand}. Very High volatility, 10,000x max win, 6 reels. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/book_of_cats_megaways': {
        title: 'Book Of Cats Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Book Of Cats Megaways slot with Bitcoin at {brand}. Very High volatility, 10,000x max win, megaways on 6 reels. Crypto deposits.'
    },
    '/p/bgaming/book_of_kemet': {
        title: 'Book Of Kemet Slot | 7,791x Max Win | {brand}',
        description: 'Play Book Of Kemet slot with Bitcoin at {brand}. Medium-High volatility, 7,791x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/book_of_panda_megaways': {
        title: 'Book Of Panda Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Book Of Panda Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/book_of_pyramids': {
        title: 'Book Of Pyramids Slot | 9,999x Max Win | {brand}',
        description: 'Play Book Of Pyramids slot with Bitcoin at {brand}. Medium volatility, 9,999x max win, 5x3 grid. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/brave_viking': {
        title: 'Brave Viking Slot | 6,000x Max Win | {brand}',
        description: 'Play Brave Viking slot with Bitcoin at {brand}. Medium-High volatility, 6,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/burning_chilli_243': {
        title: 'Burning Chilli 243 Slot | 500x Max Win | {brand}',
        description: 'Play Burning Chilli 243 slot with Bitcoin at {brand}. Medium-High volatility, 500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/burning_chilli_x': {
        title: 'Burning Chilli X Slot | 850x Max Win | {brand}',
        description: 'Play Burning Chilli X slot with Bitcoin at {brand}. Medium-High volatility, 850x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/candy_monsta': {
        title: 'Candy Monsta Slot | 1,000x Max Win | {brand}',
        description: 'Play Candy Monsta slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/capymania_green': {
        title: 'Capymania Green Slot | 100,000x Max Win | {brand}',
        description: 'Play Capymania Green slot with Bitcoin at {brand}. Medium-High volatility, 100,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/capymania_orange': {
        title: 'Capymania Orange Slot | 100,000x Max Win | {brand}',
        description: 'Play Capymania Orange slot with Bitcoin at {brand}. Medium-High volatility, 100,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/capymania_yellow': {
        title: 'Capymania Yellow Slot | 100,000x Max Win | {brand}',
        description: 'Play Capymania Yellow slot with Bitcoin at {brand}. Medium-High volatility, 100,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/carnival_bonanza': {
        title: 'Carnival Bonanza Slot | 14,134x Max Win | {brand}',
        description: 'Play Carnival Bonanza slot with Bitcoin at {brand}. High volatility, 14,134x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/catch_the_gold_hold_and_win': {
        title: 'Catch The Gold Hold And Win Slot | 2,000x Max Win | {brand}',
        description: 'Play Catch The Gold Hold And Win slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, hold and win respin. Crypto deposits.'
    },
    '/p/bgaming/catdiana': {
        title: 'Catdiana Slot | 2,500x Max Win | {brand}',
        description: 'Play Catdiana slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/bgaming/cats_soup': {
        title: 'Cats Soup Slot | 8,000x Max Win | {brand}',
        description: 'Play Cats Soup slot with Bitcoin at {brand}. Medium-High volatility, 8,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/cherry_fiesta': {
        title: 'Cherry Fiesta Slot | 5,000x Max Win | {brand}',
        description: 'Play Cherry Fiesta slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/chicken_rush': {
        title: 'Chicken Rush Slot | 5,000x Max Win | {brand}',
        description: 'Play Chicken Rush slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/classic_multihand_blackjack': {
        title: 'Classic Multihand Blackjack Slot | 3x Max Win | {brand}',
        description: 'Play Classic Multihand Blackjack slot with Bitcoin at {brand}. Low volatility, 3x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/clover_bonanza': {
        title: 'Clover Bonanza Slot | 15,000x Max Win | {brand}',
        description: 'Play Clover Bonanza slot with Bitcoin at {brand}. High volatility, 15,000x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/bgaming/clucking_hell': {
        title: 'Clucking Hell Slot | 6,666x Max Win | {brand}',
        description: 'Play Clucking Hell slot with Bitcoin at {brand}. Medium-High volatility, 6,666x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/crazy_starter': {
        title: 'Crazy Starter Slot | 5,000x Max Win | {brand}',
        description: 'Play Crazy Starter slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/crystal_clusters': {
        title: 'Crystal Clusters Slot | 5,000x Max Win | {brand}',
        description: 'Play Crystal Clusters slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, cluster pays. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/deep_sea': {
        title: 'Deep Sea Slot | 2,692x Max Win | {brand}',
        description: 'Play Deep Sea slot with Bitcoin at {brand}. Medium-High volatility, 2,692x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/bgaming/desert_treasure': {
        title: 'Desert Treasure Slot | 8,000x Max Win | {brand}',
        description: 'Play Desert Treasure slot with Bitcoin at {brand}. Medium-High volatility, 8,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/diamond_of_jungle': {
        title: 'Diamond Of Jungle Slot | 1,500x Max Win | {brand}',
        description: 'Play Diamond Of Jungle slot with Bitcoin at {brand}. Medium-High volatility, 1,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/dice_bonanza': {
        title: 'Dice Bonanza Slot | 15,000x Max Win | {brand}',
        description: 'Play Dice Bonanza slot with Bitcoin at {brand}. High volatility, 15,000x max win, dice mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/dice_million': {
        title: 'Dice Million Slot | 3,000x Max Win | {brand}',
        description: 'Play Dice Million slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, dice mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/dig_dig_digger': {
        title: 'Dig Dig Digger Slot | 7,791x Max Win | {brand}',
        description: 'Play Dig Dig Digger slot with Bitcoin at {brand}. Medium-High volatility, 7,791x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/disco_party': {
        title: 'Disco Party Slot | 1,500x Max Win | {brand}',
        description: 'Play Disco Party slot with Bitcoin at {brand}. Medium-High volatility, 1,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/divine_queen_heart_of_ice': {
        title: 'Divine Queen Heart Of Ice Slot | 5,000x Max Win | {brand}',
        description: 'Play Divine Queen Heart Of Ice slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/domnitors': {
        title: 'Domnitors Slot | 10,000x Max Win | {brand}',
        description: 'Play Domnitors slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/domnitors_deluxe': {
        title: 'Domnitors Deluxe Slot | 10,000x Max Win | {brand}',
        description: 'Play Domnitors Deluxe slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/domnitors_treasure': {
        title: 'Domnitors Treasure Slot | 2,000x Max Win | {brand}',
        description: 'Play Domnitors Treasure slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/doomsday_saloon': {
        title: 'Doomsday Saloon Slot | 10,000x Max Win | {brand}',
        description: 'Play Doomsday Saloon slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/dragon_age_hold_and_win_dragon_age': {
        title: 'Dragon Age Hold And Win Dragon Age Slot | 5,624x Max Win | {brand}',
        description: 'Play Dragon Age Hold And Win Dragon Age with crypto at {brand}. Medium-High volatility, 5,624x max win. BTC, ETH, USDT accepted.'
    },
    '/p/bgaming/dragon_queens_megaways': {
        title: "Dragon Queen's Megaways Slot | 6,000x Max Win | {brand}",
        description: "Play Dragon Queen's Megaways slot with Bitcoin at {brand}. High volatility, 6,000x max win, megaways mechanic. Crypto deposits, instant withdrawals."
    },
    '/p/bgaming/dragons_gold_100': {
        title: "Dragon's Gold 100 Slot | 3,000x Max Win | {brand}",
        description: "Play Dragon's Gold 100 slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/bgaming/easter_heist': {
        title: 'Easter Heist Slot | 5,624x Max Win | {brand}',
        description: 'Play Easter Heist slot with Bitcoin at {brand}. Medium-High volatility, 5,624x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/elvis_frog_in_vegas': {
        title: 'Elvis Frog In Vegas Slot | 2,500x Max Win | {brand}',
        description: 'Play Elvis Frog In Vegas slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, pays anywhere on 5x3. Crypto deposits.'
    },
    '/p/bgaming/elvis_frog_trueways': {
        title: 'Elvis Frog Trueways Slot | 5,000x Max Win | {brand}',
        description: 'Play Elvis Frog Trueways slot with Bitcoin at {brand}. Very High volatility, 5,000x max win, trueways mechanics. Crypto deposits.'
    },
    '/p/bgaming/face_off': {
        title: 'Face Off Slot | 15,000x Max Win | {brand}',
        description: 'Play Face Off slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/fantasy_park': {
        title: 'Fantasy Park Slot | 5,000x Max Win | {brand}',
        description: 'Play Fantasy Park slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/fiesta_clusters': {
        title: 'Fiesta Clusters Slot | 5,000x Max Win | {brand}',
        description: 'Play Fiesta Clusters slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, cluster pays. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/fire_lightning': {
        title: 'Fire Lightning Slot | 1,706x Max Win | {brand}',
        description: 'Play Fire Lightning slot with Bitcoin at {brand}. Medium-High volatility, 1,706x max win, 5x3 grid. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/fishing_club': {
        title: 'Fishing Club Slot | 3,000x Max Win | {brand}',
        description: 'Play Fishing Club slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/forgotten': {
        title: 'Forgotten Slot | 7,500x Max Win | {brand}',
        description: 'Play Forgotten slot with Bitcoin at {brand}. Medium-High volatility, 7,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/fortuna_trueways': {
        title: 'Fortuna Trueways Slot | 10,000x Max Win | {brand}',
        description: 'Play Fortuna Trueways slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, trueways expanding reels. Crypto deposits.'
    },
    '/p/bgaming/fortune_bells': {
        title: 'Fortune Bells Slot | 4,684x Max Win | {brand}',
        description: 'Play Fortune Bells slot with Bitcoin at {brand}. Medium-High volatility, 4,684x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/fortune_red_packets': {
        title: 'Fortune Red Packets Slot | 14x Max Win | {brand}',
        description: 'Play Fortune Red Packets slot with Bitcoin at {brand}. Medium-High volatility, 14x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/fortune_spin': {
        title: 'Fortune Spin Slot | 10,000x Max Win | {brand}',
        description: 'Play Fortune Spin slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/forty_fruity_million': {
        title: 'Forty Fruity Million Slot | 6,000x Max Win | {brand}',
        description: 'Play Forty Fruity Million slot with Bitcoin at {brand}. Medium-High volatility, 6,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/four_lucky_clover': {
        title: 'Four Lucky Clover Slot | 10,000x Max Win | {brand}',
        description: 'Play Four Lucky Clover slot with Bitcoin at {brand}. Unknown volatility, 10,000x max win, 5x3 grid. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/four_lucky_diamonds': {
        title: 'Four Lucky Diamonds Slot | 2,500x Max Win | {brand}',
        description: 'Play Four Lucky Diamonds slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/fruit_million': {
        title: 'Fruit Million Slot | 3,000x Max Win | {brand}',
        description: 'Play Fruit Million slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/gangsterz': {
        title: 'Gangsterz Slot | 12,000x Max Win | {brand}',
        description: 'Play Gangsterz slot with Bitcoin at {brand}. Medium-High volatility, 12,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/gemhalla': {
        title: 'Gemhalla Slot | 5,000x Max Win | {brand}',
        description: 'Play Gemhalla slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/bgaming/gemza': {
        title: 'Gemza Slot | 5,000x Max Win | {brand}',
        description: 'Play Gemza slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals No fees, fast crypto payouts.'
    },
    '/p/bgaming/gift_rush': {
        title: 'Gift Rush Slot | 559x Max Win | {brand}',
        description: 'Play Gift Rush slot with Bitcoin at {brand}. Medium-High volatility, 559x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/bgaming/god_of_wealth_hold_and_win': {
        title: 'God Of Wealth Hold And Win Slot | 2,000x Max Win | {brand}',
        description: 'Play God Of Wealth Hold And Win slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, hold and win respin. Crypto deposits.'
    },
    '/p/bgaming/gold_magnate': {
        title: 'Gold Magnate Slot | 10,490x Max Win | {brand}',
        description: 'Play Gold Magnate slot with Bitcoin at {brand}. Medium-High volatility, 10,490x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/gold_of_minos': {
        title: 'Gold Of Minos Slot | 15,360x Max Win | {brand}',
        description: 'Play Gold Of Minos slot with Bitcoin at {brand}. Medium-High volatility, 15,360x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/gold_rush_with_johnny_cash': {
        title: 'Gold Rush With Johnny Cash Slot | 5,000x Max Win | {brand}',
        description: 'Play Gold Rush With Johnny Cash slot with Bitcoin at {brand}. High volatility, 5,000x max win, cash collect. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/golden_pinata_hold_and_win': {
        title: 'Golden Pinata Hold And Win Slot | 5,624x Max Win | {brand}',
        description: 'Play Golden Pinata Hold And Win slot with Bitcoin at {brand}. Medium-High volatility, 5,624x max win, hold and win respin. Crypto deposits.'
    },
    '/p/bgaming/golden_pride': {
        title: 'Golden Pride Slot | 15,360x Max Win | {brand}',
        description: 'Play Golden Pride slot with Bitcoin at {brand}. Medium-High volatility, 15,360x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/grand_mustang': {
        title: 'Grand Mustang Slot | 5,624x Max Win | {brand}',
        description: 'Play Grand Mustang slot with Bitcoin at {brand}. Medium-High volatility, 5,624x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/grand_patron': {
        title: 'Grand Patron Slot | 10,000x Max Win | {brand}',
        description: 'Play Grand Patron slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/halloween_bonanza': {
        title: 'Halloween Bonanza Slot | 10,200x Max Win | {brand}',
        description: 'Play Halloween Bonanza slot with Bitcoin at {brand}. High volatility, 10,200x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/haunted_reels': {
        title: 'Haunted Reels Slot | 5,000x Max Win | {brand}',
        description: 'Play Haunted Reels slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/hawaii_cocktails': {
        title: 'Hawaii Cocktails Slot | 5,000x Max Win | {brand}',
        description: 'Play Hawaii Cocktails slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/heads_and_tails': {
        title: 'Heads and Tails Slot | 2x Max Win | {brand}',
        description: 'Play Heads and Tails slot with Bitcoin at {brand}. Medium volatility, 2x max win, Crypto deposits, instant withdrawals No fees, fast crypto payouts.'
    },
    '/p/bgaming/heads_and_tails_xy': {
        title: 'Heads and Tails XY Slot | 2x Max Win | {brand}',
        description: 'Play Heads and Tails XY slot with Bitcoin at {brand}. Medium volatility, 2x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/heart_of_tiki': {
        title: 'Heart Of Tiki Slot | 5,000x Max Win | {brand}',
        description: 'Play Heart Of Tiki slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/hello_easter': {
        title: 'Hello Easter Slot | 9,000x Max Win | {brand}',
        description: 'Play Hello Easter slot with Bitcoin at {brand}. Medium-High volatility, 9,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/hit_the_route': {
        title: 'Hit The Route Slot | 15,000x Max Win | {brand}',
        description: 'Play Hit The Route slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/hot_chilli_bells': {
        title: 'Hot Chilli Bells Slot | 5,000x Max Win | {brand}',
        description: 'Play Hot Chilli Bells slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/hottest_666': {
        title: 'Hottest 666 Slot | 6,600x Max Win | {brand}',
        description: 'Play Hottest 666 slot with Bitcoin at {brand}. Medium-High volatility, 6,600x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/infinity_pull': {
        title: 'Infinity Pull Slot | 100x Max Win | {brand}',
        description: 'Play Infinity Pull slot with Bitcoin at {brand}. Medium-High volatility, 100x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/jogo_do_bicho': {
        title: 'Jogo Do Bicho Slot | 17,000x Max Win | {brand}',
        description: 'Play Jogo Do Bicho slot with Bitcoin at {brand}. High volatility, 17,000x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/bgaming/jogo_do_bicho_simple': {
        title: 'Jogo Do Bicho Simple Slot | 12x Max Win | {brand}',
        description: 'Play Jogo Do Bicho Simple slot with Bitcoin at {brand}. Medium volatility, 12x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/johnny_cash': {
        title: 'Johnny Cash Slot | 1,000x Max Win | {brand}',
        description: 'Play Johnny Cash slot with Bitcoin at {brand}. Medium volatility, 1,000x max win, 5 reels. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/joker_queen': {
        title: 'Joker Queen Slot | 1,172x Max Win | {brand}',
        description: 'Play Joker Queen slot with Bitcoin at {brand}. Medium-High volatility, 1,172x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/joker_vs_joker': {
        title: 'Joker Vs Joker Slot | 7,500x Max Win | {brand}',
        description: 'Play Joker Vs Joker slot with Bitcoin at {brand}. Medium-High volatility, 7,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/joker_x_love': {
        title: 'Joker X Love Slot | 1,059x Max Win | {brand}',
        description: 'Play Joker X Love slot with Bitcoin at {brand}. Medium-High volatility, 1,059x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/jokers_million': {
        title: "Joker's Million Slot | 3,000x Max Win | {brand}",
        description: "Play Joker's Million slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/bgaming/journey_flirt': {
        title: 'Journey Flirt Slot | 15,000x Max Win | {brand}',
        description: 'Play Journey Flirt slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/jungle_queen': {
        title: 'Jungle Queen Slot | 10,000x Max Win | {brand}',
        description: 'Play Jungle Queen slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/keepers_of_the_secret': {
        title: 'Keepers Of The Secret Slot | 10,000x Max Win | {brand}',
        description: 'Play Keepers Of The Secret slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/krakens_hunger': {
        title: 'Krakens Hunger Slot | 5,000x Max Win | {brand}',
        description: 'Play Krakens Hunger slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lady_lucky_gun': {
        title: 'Lady Lucky Gun Slot | 1,000x Max Win | {brand}',
        description: 'Play Lady Lucky Gun slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lady_wolf_moon': {
        title: 'Lady Wolf Moon Slot | Unknown Max Win | {brand}',
        description: 'Play Lady Wolf Moon slot with Bitcoin at {brand}. Medium volatility, Unknown max win, 5x3 grid. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lady_wolf_moon_megaways': {
        title: 'Lady Wolf Moon Megaways Slot | Unknown Max Win | {brand}',
        description: 'Play Lady Wolf Moon Megaways slot with Bitcoin at {brand}. Very High volatility, Unknown max win, megaways on 5 reels. Crypto deposits.'
    },
    '/p/bgaming/loki_loot': {
        title: 'Loki Loot Slot | 5,000x Max Win | {brand}',
        description: 'Play Loki Loot slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/luck_and_magic': {
        title: 'Luck And Magic Slot | 1,000x Max Win | {brand}',
        description: 'Play Luck And Magic slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lucky_8_merge_up': {
        title: 'Lucky 8 Merge Up Slot | 5,000x Max Win | {brand}',
        description: 'Play Lucky 8 Merge Up slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, merge mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lucky_blue': {
        title: 'Lucky Blue Slot | 5,000x Max Win | {brand}',
        description: 'Play Lucky Blue slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lucky_crew': {
        title: 'Lucky Crew Slot | 3,525x Max Win | {brand}',
        description: 'Play Lucky Crew slot with Bitcoin at {brand}. Medium-High volatility, 3,525x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lucky_dama_muerta': {
        title: 'Lucky Dama Muerta Slot | 2,500x Max Win | {brand}',
        description: 'Play Lucky Dama Muerta slot with Bitcoin at {brand}. Medium volatility, 2,500x max win, cluster pays. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lucky_dragon_multidice_x': {
        title: 'Lucky Dragon Multidice X Slot | 7,776x Max Win | {brand}',
        description: 'Play Lucky Dragon Multidice X slot with Bitcoin at {brand}. Medium-High volatility, 7,776x max win, dice mechanic. Crypto deposits.'
    },
    '/p/bgaming/lucky_ducky': {
        title: 'Lucky Ducky Slot | 5,000x Max Win | {brand}',
        description: 'Play Lucky Ducky slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lucky_farm_bonanza': {
        title: 'Lucky Farm Bonanza Slot | 15,000x Max Win | {brand}',
        description: 'Play Lucky Farm Bonanza slot with Bitcoin at {brand}. High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/lucky_ladys_clover': {
        title: "Lucky Lady's Clover Slot | 10,000x Max Win | {brand}",
        description: "Play Lucky Lady's Clover slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/bgaming/lucky_lu': {
        title: 'Lucky Lu Slot | 559x Max Win | {brand}',
        description: 'Play Lucky Lu slot with Bitcoin at {brand}. Medium-High volatility, 559x max win, Crypto deposits, instant withdrawals No fees, fast crypto payouts.'
    },
    '/p/bgaming/lucky_oak': {
        title: 'Lucky Oak Slot | 9,991x Max Win | {brand}',
        description: 'Play Lucky Oak slot with Bitcoin at {brand}. Medium-High volatility, 9,991x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/magic_mummy_megaways': {
        title: 'Magic Mummy Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Magic Mummy Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/maneki_88_fortunes': {
        title: 'Maneki 88 Fortunes Slot | 3,000x Max Win | {brand}',
        description: 'Play Maneki 88 Fortunes slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/maneki_88_gold': {
        title: 'Maneki 88 Gold Slot | 2,614x Max Win | {brand}',
        description: 'Play Maneki 88 Gold slot with Bitcoin at {brand}. Medium-High volatility, 2,614x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/mechanical_clover': {
        title: 'Mechanical Clover Slot | 24,360x Max Win | {brand}',
        description: 'Play Mechanical Clover slot with Bitcoin at {brand}. Medium-High volatility, 24,360x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/merge_up': {
        title: 'Merge Up Slot | 5,000x Max Win | {brand}',
        description: 'Play Merge Up slot with Bitcoin at {brand}. Very High volatility, 5,000x max win, 6x6 cluster-pays. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/merge_up_2': {
        title: 'Merge Up 2 Slot | 10,000x Max Win | {brand}',
        description: 'Play Merge Up 2 slot with Bitcoin at {brand}. High volatility, 10,000x max win, 6x6 cluster-pays. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/mice_and_magic_wonder_spin': {
        title: 'Mice And Magic Wonder Spin Slot | 2,820x Max Win | {brand}',
        description: 'Play Mice And Magic Wonder Spin slot with Bitcoin at {brand}. Medium-High volatility, 2,820x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/miss_cherry_fruits': {
        title: 'Miss Cherry Fruits Slot | 1,000x Max Win | {brand}',
        description: 'Play Miss Cherry Fruits slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/miss_cherry_fruits_jackpot_party': {
        title: 'Miss Cherry Fruits Jackpot Party Slot | 1,299x Max Win | {brand}',
        description: 'Play Miss Cherry Fruits Jackpot Party slot with Bitcoin at {brand}. Medium-High volatility, 1,299x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/monster_hunt': {
        title: 'Monster Hunt Slot | 1,299x Max Win | {brand}',
        description: 'Play Monster Hunt slot with Bitcoin at {brand}. Medium-High volatility, 1,299x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/mummys_gold': {
        title: "Mummy's Gold Slot | 5,000x Max Win | {brand}",
        description: "Play Mummy's Gold slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/bgaming/mystery_garden': {
        title: 'Mystery Garden Slot | 2,000x Max Win | {brand}',
        description: 'Play Mystery Garden slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/mystery_heist': {
        title: 'Mystery Heist Slot | 2,000x Max Win | {brand}',
        description: 'Play Mystery Heist slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/olympus_trueways': {
        title: 'Olympus Trueways Slot | 5,000x Max Win | {brand}',
        description: 'Play Olympus Trueways slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, trueways expanding reels. Crypto deposits.'
    },
    '/p/bgaming/oof_the_goldmine_planet': {
        title: 'Oof The Goldmine Planet Slot | 5,000x Max Win | {brand}',
        description: 'Play Oof The Goldmine Planet slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/panda_fortune_rush': {
        title: 'Panda Fortune Rush Slot | 1,750x Max Win | {brand}',
        description: 'Play Panda Fortune Rush slot with Bitcoin at {brand}. Medium-High volatility, 1,750x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/panda_luck': {
        title: 'Panda Luck Slot | 2,124x Max Win | {brand}',
        description: 'Play Panda Luck slot with Bitcoin at {brand}. Medium-High volatility, 2,124x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/penalty_duel': {
        title: 'Penalty Duel Slot | 4,860x Max Win | {brand}',
        description: 'Play Penalty Duel slot with Bitcoin at {brand}. Medium volatility, 4,860x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/bgaming/penny_pelican': {
        title: 'Penny Pelican Slot | 3,525x Max Win | {brand}',
        description: 'Play Penny Pelican slot with Bitcoin at {brand}. Medium-High volatility, 3,525x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/piggy_bank_hold_and_win': {
        title: 'Piggy Bank Hold And Win Slot | 2,500x Max Win | {brand}',
        description: 'Play Piggy Bank Hold And Win slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, hold and win respin. Crypto deposits.'
    },
    '/p/bgaming/platinum_lightning': {
        title: 'Platinum Lightning Slot | 8,888x Max Win | {brand}',
        description: 'Play Platinum Lightning slot with Bitcoin at {brand}. Medium-High volatility, 8,888x max win, greek mythology theme. Crypto deposits.'
    },
    '/p/bgaming/platinum_lightning_deluxe': {
        title: 'Platinum Lightning Deluxe Slot | 5,000x Max Win | {brand}',
        description: 'Play Platinum Lightning Deluxe slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, scatter pays. Crypto deposits.'
    },
    '/p/bgaming/pop_zen': {
        title: 'Pop Zen Slot | 12,000x Max Win | {brand}',
        description: 'Play Pop Zen slot with Bitcoin at {brand}. Medium-High volatility, 12,000x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/bgaming/potion_spells': {
        title: 'Potion Spells Slot | 12,000x Max Win | {brand}',
        description: 'Play Potion Spells slot with Bitcoin at {brand}. Medium-High volatility, 12,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/princess_of_sky': {
        title: 'Princess Of Sky Slot | 10,000x Max Win | {brand}',
        description: 'Play Princess Of Sky slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/recycle_riches': {
        title: 'Recycle Riches Slot | 10,000x Max Win | {brand}',
        description: 'Play Recycle Riches slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/retro_trader': {
        title: 'Retro Trader Slot | 3x Max Win | {brand}',
        description: 'Play Retro Trader slot with Bitcoin at {brand}. Medium-High volatility, 3x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/bgaming/road_2_riches': {
        title: 'Road 2 Riches Slot | 2,000x Max Win | {brand}',
        description: 'Play Road 2 Riches slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/robospin': {
        title: 'Robospin Slot | 63x Max Win | {brand}',
        description: 'Play Robospin slot with Bitcoin at {brand}. Medium-High volatility, 63x max win, Crypto deposits, instant withdrawals No fees, fast crypto payouts.'
    },
    '/p/bgaming/rocket_eruption_triple_blast': {
        title: 'Rocket Eruption Triple Blast Slot | 5,000x Max Win | {brand}',
        description: 'Play Rocket Eruption Triple Blast slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/rotating_element': {
        title: 'Rotating Element Slot | 5,000x Max Win | {brand}',
        description: 'Play Rotating Element slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/royal_fruits_multilines': {
        title: 'Royal Fruits Multilines Slot | 3,000x Max Win | {brand}',
        description: 'Play Royal Fruits Multilines slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/royal_highroad': {
        title: 'Royal Highroad Slot | 5,624x Max Win | {brand}',
        description: 'Play Royal Highroad slot with Bitcoin at {brand}. Medium-High volatility, 5,624x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/royal_roulette_500x': {
        title: 'Royal Roulette 500x Slot | 500x Max Win | {brand}',
        description: 'Play Royal Roulette 500x slot with Bitcoin at {brand}. Low volatility, 500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/sakura_riches_60': {
        title: 'Sakura Riches 60 Slot | 3,000x Max Win | {brand}',
        description: 'Play Sakura Riches 60 slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/savage_buffalo_spirit': {
        title: 'Savage Buffalo Spirit Slot | 6,000x Max Win | {brand}',
        description: 'Play Savage Buffalo Spirit slot with Bitcoin at {brand}. High volatility, 6,000x max win, 5x3 grid. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/savage_buffalo_spirit_megaways': {
        title: 'Savage Buffalo Spirit Megaways Slot | 6,000x Max Win | {brand}',
        description: 'Play Savage Buffalo Spirit Megaways with crypto at {brand}. Very High volatility, 6,000x max win. BTC, ETH, USDT accepted.'
    },
    '/p/bgaming/secret_bar_multidice_x': {
        title: 'Secret Bar Multidice X Slot | 2,500x Max Win | {brand}',
        description: 'Play Secret Bar Multidice X slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, dice mechanic. Crypto deposits.'
    },
    '/p/bgaming/slot_machine': {
        title: 'Slot Machine Slot | 2,124x Max Win | {brand}',
        description: 'Play Slot Machine slot with Bitcoin at {brand}. Medium-High volatility, 2,124x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/snoop_dogg_dollars': {
        title: 'Snoop Dogg Dollars Slot | 10,000x Max Win | {brand}',
        description: 'Play Snoop Dogg Dollars slot with Bitcoin at {brand}. Very High volatility, 10,000x max win, cluster pays on 6x8. Crypto deposits.'
    },
    '/p/bgaming/soccermania': {
        title: 'Soccermania Slot | 1,039x Max Win | {brand}',
        description: 'Play Soccermania slot with Bitcoin at {brand}. Medium-High volatility, 1,039x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/spin_and_spell': {
        title: 'Spin And Spell Slot | 1,000x Max Win | {brand}',
        description: 'Play Spin And Spell slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/street_power': {
        title: 'Street Power Slot | 100x Max Win | {brand}',
        description: 'Play Street Power slot with Bitcoin at {brand}. Medium-High volatility, 100x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/sugar_mix': {
        title: 'Sugar Mix Slot | 4,000x Max Win | {brand}',
        description: 'Play Sugar Mix slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/sweet_rush_megaways': {
        title: 'Sweet Rush Megaways Slot | 12,960x Max Win | {brand}',
        description: 'Play Sweet Rush Megaways slot with Bitcoin at {brand}. High volatility, 12,960x max win, megaways mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/tile_master': {
        title: 'Tile Master Slot | 100x Max Win | {brand}',
        description: 'Play Tile Master slot with Bitcoin at {brand}. Medium-High volatility, 100x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/train_to_rio_grande': {
        title: 'Train To Rio Grande Slot | 10,490x Max Win | {brand}',
        description: 'Play Train To Rio Grande slot with Bitcoin at {brand}. Medium-High volatility, 10,490x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/tramp_day': {
        title: 'Tramp Day Slot | 5,000x Max Win | {brand}',
        description: 'Play Tramp Day slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/tramp_day_trueways': {
        title: 'Tramp Day Trueways Slot | 5,000x Max Win | {brand}',
        description: 'Play Tramp Day Trueways slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, trueways expanding reels. Crypto deposits.'
    },
    '/p/bgaming/treasure_of_anubis': {
        title: 'Treasure Of Anubis Slot | 1,939x Max Win | {brand}',
        description: 'Play Treasure Of Anubis slot with Bitcoin at {brand}. Medium-High volatility, 1,939x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/ufo_pyramids': {
        title: 'Ufo Pyramids Slot | 5,000x Max Win | {brand}',
        description: 'Play Ufo Pyramids slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/voodoo_people': {
        title: 'Voodoo People Slot | 7,500x Max Win | {brand}',
        description: 'Play Voodoo People slot with Bitcoin at {brand}. Medium-High volatility, 7,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wbc_ring_of_riches': {
        title: 'Wbc Ring Of Riches Slot | 9,200x Max Win | {brand}',
        description: 'Play Wbc Ring Of Riches slot with Bitcoin at {brand}. Medium-High volatility, 9,200x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/west_town': {
        title: 'West Town Slot | 5,000x Max Win | {brand}',
        description: 'Play West Town slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wild_card_gang': {
        title: 'Wild Card Gang Slot | 5,000x Max Win | {brand}',
        description: 'Play Wild Card Gang slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wild_cash': {
        title: 'Wild Cash Slot | 1,039x Max Win | {brand}',
        description: 'Play Wild Cash slot with Bitcoin at {brand}. High volatility, 1,039x max win, simple 3x3 grid. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wild_cash_dice': {
        title: 'Wild Cash Dice Slot | 9,990x Max Win | {brand}',
        description: 'Play Wild Cash Dice slot with Bitcoin at {brand}. Medium-High volatility, 9,990x max win, dice mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wild_cash_x9990': {
        title: 'Wild Cash X9990 Slot | 10,490x Max Win | {brand}',
        description: 'Play Wild Cash X9990 slot with Bitcoin at {brand}. High volatility, 10,490x max win, 5 reels. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wild_chicago': {
        title: 'Wild Chicago Slot | 4,684x Max Win | {brand}',
        description: 'Play Wild Chicago slot with Bitcoin at {brand}. Medium-High volatility, 4,684x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wild_clusters': {
        title: 'Wild Clusters Slot | 5,000x Max Win | {brand}',
        description: 'Play Wild Clusters slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, cluster pays. Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wild_heart': {
        title: 'Wild Heart Slot | 2,820x Max Win | {brand}',
        description: 'Play Wild Heart slot with Bitcoin at {brand}. Medium-High volatility, 2,820x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wild_moon_thieves': {
        title: 'Wild Moon Thieves Slot | 5,000x Max Win | {brand}',
        description: 'Play Wild Moon Thieves slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wild_tiger': {
        title: 'Wild Tiger Slot | 3,000x Max Win | {brand}',
        description: 'Play Wild Tiger slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/wild_west_trueways': {
        title: 'Wild West Trueways Slot | 5,000x Max Win | {brand}',
        description: 'Play Wild West Trueways slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, trueways expanding reels. Crypto deposits.'
    },
    '/p/bgaming/wild_wick': {
        title: 'Wild Wick Slot | 10,000x Max Win | {brand}',
        description: 'Play Wild Wick slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/winter_fishing_club': {
        title: 'Winter Fishing Club Slot | 3,000x Max Win | {brand}',
        description: 'Play Winter Fishing Club slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/bgaming/zeus_goes_wild': {
        title: 'Zeus Goes Wild Slot | 800x Max Win | {brand}',
        description: 'Play Zeus Goes Wild slot with Bitcoin at {brand}. Medium-High volatility, 800x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/hacksaw-gaming/2_wild_2_die': {
        title: '2 Wild 2 Die Slot | 15,000x Max Win | {brand}',
        description: 'Play 2 Wild 2 Die slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/aiko_and_the_wind_spirit': {
        title: 'Aiko and the Wind Spirit Slot | 10,000x Max Win | {brand}',
        description: 'Play Aiko and the Wind Spirit slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees.'
    },
    '/p/hacksaw-gaming/alpha_eagle': {
        title: 'Alpha Eagle Slot | Play Online | {brand}',
        description: 'Play Alpha Eagle by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/aztec_twist': {
        title: 'Aztec Twist Slot | Play Online | {brand}',
        description: 'Play Aztec Twist by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/bash_bros': {
        title: 'Bash Bros Slot | 10,000x Max Win | {brand}',
        description: 'Play Bash Bros slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/beam_boys': {
        title: 'Beam Boys Slot | 12,500x Max Win | {brand}',
        description: 'Play Beam Boys slot with Bitcoin at {brand}. Variable (Volatility Switch) volatility, 12,500x max win. BTC, ETH, USDT accepted.'
    },
    '/p/hacksaw-gaming/beast_below': {
        title: 'Beast Below Slot | 10,000x Max Win | {brand}',
        description: 'Play Beast Below slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/benny_the_beer': {
        title: 'Benny the Beer Slot | 10,000x Max Win | {brand}',
        description: 'Play Benny the Beer slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/bloodthirst': {
        title: 'Bloodthirst Slot | 10,000x Max Win | {brand}',
        description: 'Play Bloodthirst slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/book_of_time': {
        title: 'Book of Time Slot | Play Online | {brand}',
        description: 'Play Book of Time by Hacksaw Gaming at {brand}. High volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/booze_bash': {
        title: 'Booze Bash Slot | 12,500x Max Win | {brand}',
        description: 'Play Booze Bash slot with Bitcoin at {brand}. Medium volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/born_wild': {
        title: 'Born Wild Slot | Play Online | {brand}',
        description: 'Play Born Wild by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/bouncy_bombs': {
        title: 'Bouncy Bombs Slot | 10,000x Max Win | {brand}',
        description: 'Play Bouncy Bombs slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/break_bones': {
        title: 'Break Bones Slot | Play Online | {brand}',
        description: 'Play Break Bones by Hacksaw Gaming at {brand}. High volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/buffalo_stacknsync': {
        title: 'Buffalo StacknSync Slot | Play Online | {brand}',
        description: 'Play Buffalo StacknSync by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/bullets_and_bounty': {
        title: 'Bullets and Bounty Slot | 20,000x Max Win | {brand}',
        description: 'Play Bullets and Bounty slot with Bitcoin at {brand}. High volatility, 20,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/cash_compass': {
        title: 'Cash Compass Slot | Play Online | {brand}',
        description: 'Play Cash Compass by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/cash_crew': {
        title: 'Cash Crew Slot | 10,000x Max Win | {brand}',
        description: 'Play Cash Crew slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/cash_quest': {
        title: 'Cash Quest Slot | Play Online | {brand}',
        description: 'Play Cash Quest by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/chaos_crew': {
        title: 'Chaos Crew Slot | 10,000x Max Win | {brand}',
        description: 'Play Chaos Crew slot with Bitcoin at {brand}. Extreme volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/chaos_crew_2': {
        title: 'Chaos Crew 2 Slot | 20,000x Max Win | {brand}',
        description: 'Play Chaos Crew 2 slot with Bitcoin at {brand}. Extreme volatility, 20,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/chaos_crew_3': {
        title: 'Chaos Crew 3 Slot | 30,000x Max Win | {brand}',
        description: 'Play Chaos Crew 3 slot with Bitcoin at {brand}. Extreme volatility, 30,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/circle_of_life': {
        title: 'Circle of Life Slot | 15,000x Max Win | {brand}',
        description: 'Play Circle of Life slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/cloud_princess': {
        title: 'Cloud Princess Slot | 10,000x Max Win | {brand}',
        description: 'Play Cloud Princess slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/cubes': {
        title: 'Cubes Slot | Play Online | {brand}',
        description: 'Play Cubes by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/cubes_2': {
        title: 'Cubes 2 Slot | Play Online | {brand}',
        description: 'Play Cubes 2 by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/cursed_seas': {
        title: 'Cursed Seas Slot | 12,500x Max Win | {brand}',
        description: 'Play Cursed Seas slot with Bitcoin at {brand}. High volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/danny_dollar': {
        title: 'Danny Dollar Slot | 12,500x Max Win | {brand}',
        description: 'Play Danny Dollar slot with Bitcoin at {brand}. Medium volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/dark_summoning': {
        title: 'Dark Summoning Slot | 10,666x Max Win | {brand}',
        description: 'Play Dark Summoning slot with Bitcoin at {brand}. High volatility, 10,666x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/dawn_of_kings': {
        title: 'Dawn of Kings Slot | 10,000x Max Win | {brand}',
        description: 'Play Dawn of Kings slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/densho': {
        title: 'Densho Slot | 10,000x Max Win | {brand}',
        description: 'Play Densho slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/divine_drop': {
        title: 'Divine Drop Slot | 10,000x Max Win | {brand}',
        description: 'Play Divine Drop slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/donny_and_danny': {
        title: 'Donny and Danny Slot | 12,500x Max Win | {brand}',
        description: 'Play Donny and Danny slot with Bitcoin at {brand}. Medium volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/donut_division': {
        title: 'Donut Division Slot | 12,500x Max Win | {brand}',
        description: 'Play Donut Division slot with Bitcoin at {brand}. Medium volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/dork_unit': {
        title: 'Dork Unit Slot | 10,000x Max Win | {brand}',
        description: 'Play Dork Unit slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/dorks_of_the_deep': {
        title: 'Dorks of the Deep Slot | 10,000x Max Win | {brand}',
        description: 'Play Dorks of the Deep slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/double_rainbow': {
        title: 'Double Rainbow Slot | Play Online | {brand}',
        description: 'Play Double Rainbow by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/dragons_domain': {
        title: 'Dragons Domain Slot | 10,000x Max Win | {brand}',
        description: 'Play Dragons Domain slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/dropem': {
        title: 'DropEm Slot | 10,000x Max Win | {brand}',
        description: 'Play DropEm slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/duel_at_dawn': {
        title: 'Duel at Dawn Slot | 15,000x Max Win | {brand}',
        description: 'Play Duel at Dawn slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/dusk_princess': {
        title: 'Dusk Princess Slot | 10,000x Max Win | {brand}',
        description: 'Play Dusk Princess slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/evil_eyes': {
        title: 'Evil Eyes Slot | 12,500x Max Win | {brand}',
        description: 'Play Evil Eyes slot with Bitcoin at {brand}. High volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/eye_of_medusa': {
        title: 'Eye of Medusa Slot | 10,000x Max Win | {brand}',
        description: 'Play Eye of Medusa slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/eye_of_the_panda': {
        title: 'Eye of the Panda Slot | 10,000x Max Win | {brand}',
        description: 'Play Eye of the Panda slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/fear_the_dark': {
        title: 'Fear the Dark Slot | 5,000x Max Win | {brand}',
        description: 'Play Fear the Dark slot with Bitcoin at {brand}. High volatility, 5,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/feel_the_beat': {
        title: 'Feel the Beat Slot | 10,000x Max Win | {brand}',
        description: 'Play Feel the Beat slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/fighter_pit': {
        title: 'Fighter Pit Slot | 10,000x Max Win | {brand}',
        description: 'Play Fighter Pit slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/fire_my_laser': {
        title: 'Fire My Laser Slot | 15,000x Max Win | {brand}',
        description: 'Play Fire My Laser slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/fist_of_destruction': {
        title: 'Fist of Destruction Slot | 10,000x Max Win | {brand}',
        description: 'Play Fist of Destruction slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees.'
    },
    '/p/hacksaw-gaming/forest_fortune': {
        title: 'Forest Fortune Slot | Play Online | {brand}',
        description: 'Play Forest Fortune by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/franks_farm': {
        title: 'Franks Farm Slot | Play Online | {brand}',
        description: 'Play Franks Farm by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/freds_food_truck': {
        title: 'Freds Food Truck Slot | 10,000x Max Win | {brand}',
        description: 'Play Freds Food Truck slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/fruit_duel': {
        title: 'Fruit Duel Slot | Play Online | {brand}',
        description: 'Play Fruit Duel by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/frutz': {
        title: 'Frutz Slot | Play Online | {brand}',
        description: 'Play Frutz by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/get_the_cheese': {
        title: 'Get the Cheese Slot | 10,000x Max Win | {brand}',
        description: 'Play Get the Cheese slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/gladiator_legends': {
        title: 'Gladiator Legends Slot | 10,000x Max Win | {brand}',
        description: 'Play Gladiator Legends slot with Bitcoin at {brand}. Extreme volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/gronks_gems': {
        title: 'Gronks Gems Slot | Play Online | {brand}',
        description: 'Play Gronks Gems by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/hand_of_anubis': {
        title: 'Hand of Anubis Slot | 10,000x Max Win | {brand}',
        description: 'Play Hand of Anubis slot with Bitcoin at {brand}. Extreme volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/hopnpop': {
        title: 'HopnPop Slot | 10,000x Max Win | {brand}',
        description: 'Play HopnPop slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/hot_ross': {
        title: 'Hot Ross Slot | 15,000x Max Win | {brand}',
        description: 'Play Hot Ross slot with Bitcoin at {brand}. Medium volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/hounds_of_hell': {
        title: 'Hounds of Hell Slot | 20,000x Max Win | {brand}',
        description: 'Play Hounds of Hell slot with Bitcoin at {brand}. High volatility, 20,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/immortal_desire': {
        title: 'Immortal Desire Slot | 10,000x Max Win | {brand}',
        description: 'Play Immortal Desire slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/invictus': {
        title: 'Invictus Slot | 10,000x Max Win | {brand}',
        description: 'Play Invictus slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/itero': {
        title: 'Itero Slot | 10,000x Max Win | {brand}',
        description: 'Play Itero slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/joker_bombs': {
        title: 'Joker Bombs Slot | Play Online | {brand}',
        description: 'Play Joker Bombs by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/keep_em_cool': {
        title: 'Keep Em Cool Slot | 10,000x Max Win | {brand}',
        description: 'Play Keep Em Cool slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/keepem': {
        title: 'KeepEm Slot | 10,000x Max Win | {brand}',
        description: 'Play KeepEm slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/king_carrot': {
        title: 'King Carrot Slot | Play Online | {brand}',
        description: 'Play King Carrot by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/klowns': {
        title: 'Klowns Slot | 10,000x Max Win | {brand}',
        description: 'Play Klowns slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/le_bandit': {
        title: 'Le Bandit Slot | 10,000x Max Win | {brand}',
        description: 'Play Le Bandit slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/le_fisherman': {
        title: 'Le Fisherman Slot | 15,000x Max Win | {brand}',
        description: 'Play Le Fisherman slot with Bitcoin at {brand}. Medium volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/le_king': {
        title: 'Le King Slot | 20,000x Max Win | {brand}',
        description: 'Play Le King slot with Bitcoin at {brand}. Medium volatility, 20,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/le_pharaoh': {
        title: 'Le Pharaoh Slot | 10,000x Max Win | {brand}',
        description: 'Play Le Pharaoh slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/le_viking': {
        title: 'Le Viking Slot | 10,000x Max Win | {brand}',
        description: 'Play Le Viking slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/le_zeus': {
        title: 'Le Zeus Slot | 20,000x Max Win | {brand}',
        description: 'Play Le Zeus slot with Bitcoin at {brand}. Medium volatility, 20,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/let_it_snow': {
        title: 'Let It Snow Slot | Play Online | {brand}',
        description: 'Play Let It Snow by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/life_and_death': {
        title: 'Life and Death Slot | 15,000x Max Win | {brand}',
        description: 'Play Life and Death slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/magic_piggy': {
        title: 'Magic Piggy Slot | Play Online | {brand}',
        description: 'Play Magic Piggy by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/marlin_masters': {
        title: 'Marlin Masters Slot | 7,500x Max Win | {brand}',
        description: 'Play Marlin Masters slot with Bitcoin at {brand}. Medium volatility, 7,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/marlin_masters_the_big_haul': {
        title: 'Marlin Masters The Big Haul Slot | 10,000x Max Win | {brand}',
        description: 'Play Marlin Masters The Big Haul slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win. BTC, ETH, USDT accepted.'
    },
    '/p/hacksaw-gaming/mayan_stackways': {
        title: 'Mayan Stackways Slot | 10,000x Max Win | {brand}',
        description: 'Play Mayan Stackways slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/miami_multiplier': {
        title: 'Miami Multiplier Slot | Play Online | {brand}',
        description: 'Play Miami Multiplier by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/mighty_masks': {
        title: 'Mighty Masks Slot | 10,000x Max Win | {brand}',
        description: 'Play Mighty Masks slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/mystery_motel': {
        title: 'Mystery Motel Slot | Play Online | {brand}',
        description: 'Play Mystery Motel by Hacksaw Gaming at {brand}. High volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/octo_attack': {
        title: 'Octo Attack Slot | 10,000x Max Win | {brand}',
        description: 'Play Octo Attack slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/omnom': {
        title: 'OmNom Slot | 4,800x Max Win | {brand}',
        description: 'Play OmNom slot with Bitcoin at {brand}. Medium volatility, 4,800x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/orb_of_destiny': {
        title: 'Orb of Destiny Slot | 10,000x Max Win | {brand}',
        description: 'Play Orb of Destiny slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/outlaws_inc': {
        title: 'Outlaws Inc Slot | 10,000x Max Win | {brand}',
        description: 'Play Outlaws Inc slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/phoenix_duelreels': {
        title: 'Phoenix DuelReels Slot | 10,000x Max Win | {brand}',
        description: 'Play Phoenix DuelReels slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/pray_for_six': {
        title: 'Pray for Six Slot | 20,000x Max Win | {brand}',
        description: 'Play Pray for Six slot with Bitcoin at {brand}. High volatility, 20,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/pray_for_three': {
        title: 'Pray for Three Slot | 13,333x Max Win | {brand}',
        description: 'Play Pray for Three slot with Bitcoin at {brand}. Medium volatility, 13,333x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/pug_life': {
        title: 'Pug Life Slot | Play Online | {brand}',
        description: 'Play Pug Life by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/rad_maxx': {
        title: 'Rad Maxx Slot | 12,500x Max Win | {brand}',
        description: 'Play Rad Maxx slot with Bitcoin at {brand}. High volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/rainbow_princess': {
        title: 'Rainbow Princess Slot | 10,000x Max Win | {brand}',
        description: 'Play Rainbow Princess slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/reign_of_rome': {
        title: 'Reign of Rome Slot | 15,000x Max Win | {brand}',
        description: 'Play Reign of Rome slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/rip_city': {
        title: 'RIP City Slot | 12,500x Max Win | {brand}',
        description: 'Play RIP City slot with Bitcoin at {brand}. Medium volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/rise_of_ymir': {
        title: 'Rise of Ymir Slot | 15,000x Max Win | {brand}',
        description: 'Play Rise of Ymir slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/rocket_reels': {
        title: 'Rocket Reels Slot | Play Online | {brand}',
        description: 'Play Rocket Reels by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/ronin_stackways': {
        title: 'Ronin Stackways Slot | 5,000x Max Win | {brand}',
        description: 'Play Ronin Stackways slot with Bitcoin at {brand}. Medium volatility, 5,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/rotten': {
        title: 'Rotten Slot | 10,000x Max Win | {brand}',
        description: 'Play Rotten slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/rusty_and_curly': {
        title: 'Rusty and Curly Slot | 10,000x Max Win | {brand}',
        description: 'Play Rusty and Curly slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/shaolin_master': {
        title: 'Shaolin Master Slot | 10,000x Max Win | {brand}',
        description: 'Play Shaolin Master slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/sixsixsix': {
        title: 'SixSixSix Slot | 16,666x Max Win | {brand}',
        description: 'Play SixSixSix slot with Bitcoin at {brand}. High volatility, 16,666x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/slayers_inc': {
        title: 'Slayers Inc Slot | 15,000x Max Win | {brand}',
        description: 'Play Slayers Inc slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/smoking_dragon': {
        title: 'Smoking Dragon Slot | 10,000x Max Win | {brand}',
        description: 'Play Smoking Dragon slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/snow_slingers': {
        title: 'Snow Slingers Slot | 10,000x Max Win | {brand}',
        description: 'Play Snow Slingers slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/spear_of_athena': {
        title: 'Spear of Athena Slot | 15,000x Max Win | {brand}',
        description: 'Play Spear of Athena slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/spinman': {
        title: 'Spinman Slot | 10,000x Max Win | {brand}',
        description: 'Play Spinman slot with Bitcoin at {brand}. Extreme volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/spinman_hv': {
        title: 'Spinman HV Slot | 10,000x Max Win | {brand}',
        description: 'Play Spinman HV slot with Bitcoin at {brand}. Extreme volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/stackem': {
        title: 'StackEm Slot | 10,000x Max Win | {brand}',
        description: 'Play StackEm slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/steamrunners': {
        title: 'Steamrunners Slot | 10,000x Max Win | {brand}',
        description: 'Play Steamrunners slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/stickem': {
        title: 'StickEm Slot | 2,048x (in sticky win spin); 1,000x (bonus wheel) Max Win | {brand}',
        description: 'Play StickEm slot with Bitcoin at {brand}. Medium volatility, 2,048x (in sticky win spin); 1,000x (bonus wheel) max win. BTC, ETH, USDT accepted.'
    },
    '/p/hacksaw-gaming/stormborn': {
        title: 'Stormborn Slot | 10,000x Max Win | {brand}',
        description: 'Play Stormborn slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/strength_of_hercules': {
        title: 'Strength of Hercules Slot | 10,000x Max Win | {brand}',
        description: 'Play Strength of Hercules slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/sun_princess': {
        title: 'Sun Princess Slot | 10,000x Max Win | {brand}',
        description: 'Play Sun Princess slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/superstar_sevens': {
        title: 'Superstar Sevens Slot | 10,000x Max Win | {brand}',
        description: 'Play Superstar Sevens slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/tasty_treats': {
        title: 'Tasty Treats Slot | Play Online | {brand}',
        description: 'Play Tasty Treats by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/temple_of_torment': {
        title: 'Temple of Torment Slot | 10,000x Max Win | {brand}',
        description: 'Play Temple of Torment slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/the_bowery_boys': {
        title: 'The Bowery Boys Slot | 10,000x Max Win | {brand}',
        description: 'Play The Bowery Boys slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/the_count': {
        title: 'The Count Slot | 12,500x Max Win | {brand}',
        description: 'Play The Count slot with Bitcoin at {brand}. High volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/the_respinners': {
        title: 'The Respinners Slot | Play Online | {brand}',
        description: 'Play The Respinners by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/the_wildwood_curse': {
        title: 'The Wildwood Curse Slot | 10,000x Max Win | {brand}',
        description: 'Play The Wildwood Curse slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/tiger_legends': {
        title: 'Tiger Legends Slot | 10,000x Max Win | {brand}',
        description: 'Play Tiger Legends slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/time_spinners': {
        title: 'Time Spinners Slot | Play Online | {brand}',
        description: 'Play Time Spinners by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/toshi_video_club': {
        title: 'Toshi Video Club Slot | Play Online | {brand}',
        description: 'Play Toshi Video Club by Hacksaw Gaming at {brand}. Medium volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/toshi_ways_club': {
        title: 'Toshi Ways Club Slot | 10,000x Max Win | {brand}',
        description: 'Play Toshi Ways Club slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/twisted_lab': {
        title: 'Twisted Lab Slot | 15,000x Max Win | {brand}',
        description: 'Play Twisted Lab slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/ultimate_slot_of_america': {
        title: 'Ultimate Slot of America Slot | 10,000x Max Win | {brand}',
        description: 'Play Ultimate Slot of America slot with Bitcoin at {brand}. High volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/undead_fortune': {
        title: 'Undead Fortune Slot | Play Online | {brand}',
        description: 'Play Undead Fortune by Hacksaw Gaming at {brand}. High volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/vending_machine': {
        title: 'Vending Machine Slot | 5,000x Max Win | {brand}',
        description: 'Play Vending Machine slot with Bitcoin at {brand}. Medium volatility, 5,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/wanted_dead_or_a_wild': {
        title: 'Wanted Dead or a Wild Slot | 12,500x Max Win | {brand}',
        description: 'Play Wanted Dead or a Wild slot with Bitcoin at {brand}. High volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/warrior_ways': {
        title: 'Warrior Ways Slot | Play Online | {brand}',
        description: 'Play Warrior Ways by Hacksaw Gaming at {brand}. High volatility. Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/wings_of_horus': {
        title: 'Wings of Horus Slot | 15,000x Max Win | {brand}',
        description: 'Play Wings of Horus slot with Bitcoin at {brand}. High volatility, 15,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/wishbringer': {
        title: 'Wishbringer Slot | 10,000x Max Win | {brand}',
        description: 'Play Wishbringer slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/xmas_drop': {
        title: 'Xmas Drop Slot | 12,500x Max Win | {brand}',
        description: 'Play Xmas Drop slot with Bitcoin at {brand}. Medium volatility, 12,500x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/xpander': {
        title: 'Xpander Slot | 10,000x Max Win | {brand}',
        description: 'Play Xpander slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/ze_zeus': {
        title: 'Ze Zeus Slot | 10,000x Max Win | {brand}',
        description: 'Play Ze Zeus slot with Bitcoin at {brand}. Medium volatility, 10,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/hacksaw-gaming/zeus_ze_zecond': {
        title: 'Zeus Ze Zecond Slot | 20,000x Max Win | {brand}',
        description: 'Play Zeus Ze Zecond slot with Bitcoin at {brand}. Medium volatility, 20,000x max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/3_buzzing_wilds': {
        title: '3 Buzzing Wilds Slot | 5,000x Max Win | {brand}',
        description: 'Play 3 Buzzing Wilds slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/3_dancing_monkeys': {
        title: '3 Dancing Monkeys Slot | 12,077x Max Win | {brand}',
        description: 'Play 3 Dancing Monkeys slot with Bitcoin at {brand}. Medium-High volatility, 12,077x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/3_genie_wishes': {
        title: '3 Genie Wishes Slot | 519x Max Win | {brand}',
        description: 'Play 3 Genie Wishes slot with Bitcoin at {brand}. Medium-High volatility, 519x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/3_kingdoms_battle_of_red_cliffs': {
        title: '3 Kingdoms Battle Of Red Cliffs Slot | 200x Max Win | {brand}',
        description: 'Play 3 Kingdoms Battle Of Red Cliffs slot with Bitcoin at {brand}. Medium-High volatility, 200x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/3_magic_eggs': {
        title: '3 Magic Eggs Slot | 5,000x Max Win | {brand}',
        description: 'Play 3 Magic Eggs slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/5_frozen_charms_megaways': {
        title: '5 Frozen Charms Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play 5 Frozen Charms Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/5_lions': {
        title: '5 Lions Slot | 3,520x Max Win | {brand}',
        description: 'Play 5 Lions slot with Bitcoin at {brand}. Medium-High volatility, 3,520x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/5_lions_dance': {
        title: '5 Lions Dance Slot | 2,700x Max Win | {brand}',
        description: 'Play 5 Lions Dance slot with Bitcoin at {brand}. Medium-High volatility, 2,700x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/5_lions_gold': {
        title: '5 Lions Gold Slot | 7,342x Max Win | {brand}',
        description: 'Play 5 Lions Gold slot with Bitcoin at {brand}. Medium-High volatility, 7,342x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/5_lions_megaways': {
        title: '5 Lions Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play 5 Lions Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/5_lions_megaways_2': {
        title: '5 Lions Megaways 2 Slot | 8,000x Max Win | {brand}',
        description: 'Play 5 Lions Megaways 2 slot with Bitcoin at {brand}. High volatility, 8,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/5_lions_reborn': {
        title: '5 Lions Reborn Slot | 5,000x Max Win | {brand}',
        description: 'Play 5 Lions Reborn slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/5_rabbits_megaways': {
        title: '5 Rabbits Megaways Slot | Play Online | {brand}',
        description: 'Play 5 Rabbits Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/6_jokers': {
        title: "6 Joker's Slot | 5,000x Max Win | {brand}",
        description: "Play 6 Joker's slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/7_clovers_of_fortune': {
        title: '7 Clovers Of Fortune Slot | 4,454x Max Win | {brand}',
        description: 'Play 7 Clovers Of Fortune slot with Bitcoin at {brand}. Medium-High volatility, 4,454x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/7_monkeys': {
        title: '7 Monkeys Slot | 4,500x Max Win | {brand}',
        description: 'Play 7 Monkeys slot with Bitcoin at {brand}. Medium-High volatility, 4,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/7_monkeys_jp': {
        title: '7 Monkeys Jp Slot | Play Online | {brand}',
        description: 'Play 7 Monkeys Jp by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/7_piggies': {
        title: '7 Piggies Slot | 39,000x Max Win | {brand}',
        description: 'Play 7 Piggies slot with Bitcoin at {brand}. Medium-High volatility, 39,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/888_bonanza': {
        title: '888 Bonanza Slot | Play Online | {brand}',
        description: 'Play 888 Bonanza by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/888_dragons': {
        title: '888 Dragons Slot | 100x Max Win | {brand}',
        description: 'Play 888 Dragons slot with Bitcoin at {brand}. Medium-High volatility, 100x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/888_gold': {
        title: '888 Gold Slot | 2,001x Max Win | {brand}',
        description: 'Play 888 Gold slot with Bitcoin at {brand}. Medium-High volatility, 2,001x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/8_dragons': {
        title: '8 Dragons Slot | 7,500x Max Win | {brand}',
        description: 'Play 8 Dragons slot with Bitcoin at {brand}. Medium-High volatility, 7,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/8_golden_dragon_challenge': {
        title: '8 Golden Dragon Challenge Slot | Pragmatic Play | {brand}',
        description: 'Play 8 Golden Dragon Challenge by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/african_elephant': {
        title: 'African Elephant Slot | 15,000x Max Win | {brand}',
        description: 'Play African Elephant slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/aladdin_and_the_sorcerer': {
        title: 'Aladdin And The Sorcerer Slot | 6,532x Max Win | {brand}',
        description: 'Play Aladdin And The Sorcerer slot with Bitcoin at {brand}. Medium-High volatility, 6,532x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/alien_invaders': {
        title: 'Alien Invaders Slot | 5,000x Max Win | {brand}',
        description: 'Play Alien Invaders slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/anacoda_gold': {
        title: 'Anacoda Gold Slot | 10,000x Max Win | {brand}',
        description: 'Play Anacoda Gold slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/ancient_egypt': {
        title: 'Ancient Egypt Slot | 5,511x Max Win | {brand}',
        description: 'Play Ancient Egypt slot with Bitcoin at {brand}. Medium-High volatility, 5,511x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/ancient_egypt_classic': {
        title: 'Ancient Egypt Classic Slot | 5,015x Max Win | {brand}',
        description: 'Play Ancient Egypt Classic slot with Bitcoin at {brand}. Medium-High volatility, 5,015x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/ancient_island_megaways': {
        title: 'Ancient Island Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Ancient Island Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/angel_vs_sinner': {
        title: 'Angel Vs Sinner Slot | 15,000x Max Win | {brand}',
        description: 'Play Angel Vs Sinner slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/anime_mecha_megaways': {
        title: 'Anime Mecha Megaways Slot | 40,000x Max Win | {brand}',
        description: 'Play Anime Mecha Megaways slot with Bitcoin at {brand}. High volatility, 40,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/argonauts': {
        title: 'Argonauts Slot | 10,000x Max Win | {brand}',
        description: 'Play Argonauts slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/asgard': {
        title: 'Asgard Slot | 500x Max Win | {brand}',
        description: 'Play Asgard slot with Bitcoin at {brand}. Medium-High volatility, 500x max win, Crypto deposits, instant withdrawals No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/aztec_blaze': {
        title: 'Aztec Blaze Slot | 2,000x Max Win | {brand}',
        description: 'Play Aztec Blaze slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/aztec_bonanza': {
        title: 'Aztec Bonanza Slot | 19,440x Max Win | {brand}',
        description: 'Play Aztec Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 19,440x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/aztec_gems': {
        title: 'Aztec Gems Slot | 375x Max Win | {brand}',
        description: 'Play Aztec Gems slot with Bitcoin at {brand}. Medium-High volatility, 375x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/aztec_gems_deluxe': {
        title: 'Aztec Gems Deluxe Slot | 22,519x Max Win | {brand}',
        description: 'Play Aztec Gems Deluxe slot with Bitcoin at {brand}. Medium-High volatility, 22,519x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/aztec_gems_megaways': {
        title: 'Aztec Gems Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Aztec Gems Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/aztec_king': {
        title: 'Aztec King Slot | 10,500x Max Win | {brand}',
        description: 'Play Aztec King slot with Bitcoin at {brand}. Medium-High volatility, 10,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/aztec_king_megaways': {
        title: 'Aztec King Megaways Slot | 20,000x Max Win | {brand}',
        description: 'Play Aztec King Megaways slot with Bitcoin at {brand}. High volatility, 20,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/aztec_powernudge': {
        title: 'Aztec Powernudge Slot | 5,000x Max Win | {brand}',
        description: 'Play Aztec Powernudge slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, powernudge. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/aztec_smash': {
        title: 'Aztec Smash Slot | 9,000x Max Win | {brand}',
        description: 'Play Aztec Smash slot with Bitcoin at {brand}. High volatility, 9,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/aztec_treasure_hunt': {
        title: 'Aztec Treasure Hunt Slot | 5,000x Max Win | {brand}',
        description: 'Play Aztec Treasure Hunt slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/badge_blitz': {
        title: 'Badge Blitz Slot | 3,000x Max Win | {brand}',
        description: 'Play Badge Blitz slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bali_dragon': {
        title: 'Bali Dragon Slot | 1,040x Max Win | {brand}',
        description: 'Play Bali Dragon slot with Bitcoin at {brand}. Medium-High volatility, 1,040x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bandit_megaways': {
        title: 'Bandit Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Bandit Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/barn_festival': {
        title: 'Barn Festival Slot | 20,000x Max Win | {brand}',
        description: 'Play Barn Festival slot with Bitcoin at {brand}. Medium-High volatility, 20,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/barnyard_megahays_megaways': {
        title: 'Barnyard Megahays Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Barnyard Megahays Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bee_keeper': {
        title: 'Bee Keeper Slot | 2,100x Max Win | {brand}',
        description: 'Play Bee Keeper slot with Bitcoin at {brand}. Medium-High volatility, 2,100x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/beware_the_deep_megaways': {
        title: 'Beware The Deep Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Beware The Deep Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/big_bass_amazon_xtreme': {
        title: 'Big Bass Amazon Xtreme Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Amazon Xtreme by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_bonanza': {
        title: 'Big Bass Bonanza Slot | 2,100x Max Win | {brand}',
        description: 'Play Big Bass Bonanza slot with Bitcoin at {brand}. Medium volatility, 2,100x max win, traditional payline mechanics. Crypto deposits.'
    },
    '/p/pragmatic-play/big_bass_bonanza_1000': {
        title: 'Big Bass Bonanza 1000 Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Bonanza 1000 by Pragmatic Play at {brand}. Medium-High volatility, 1000x multiplier. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_bonanza_3_reeler': {
        title: 'Big Bass Bonanza 3 Reeler Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Bonanza 3 Reeler by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_bonanza_hold_and_spinner': {
        title: 'Big Bass Bonanza Hold And Spinner Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Bonanza Hold And Spinner by Pragmatic Play at {brand}. Medium-High volatility, hold and spin. Deposit with BTC, ETH, USDT.'
    },
    '/p/pragmatic-play/big_bass_bonanza_keeping_it_reel': {
        title: 'Big Bass Bonanza Keeping It Reel Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Bonanza Keeping It Reel by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_bonanza_megaways': {
        title: 'Big Bass Bonanza Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Bonanza Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_bonanza_reel_action': {
        title: 'Big Bass Bonanza Reel Action Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Bonanza Reel Action by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_boxing_bonus_round': {
        title: 'Big Bass Boxing Bonus Round Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Boxing Bonus Round by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_christmas_bash': {
        title: 'Big Bass Christmas Bash Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Christmas Bash by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_christmas_frozen_lake': {
        title: 'Big Bass Christmas Frozen Lake Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Christmas Frozen Lake by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_crash': {
        title: 'Big Bass Crash Slot | 5,000x Max Win | {brand}',
        description: 'Play Big Bass Crash slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/big_bass_day_at_the_races': {
        title: 'Big Bass Day At The Races Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Day At The Races by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_floats_my_boat': {
        title: 'Big Bass Floats My Boat Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Floats My Boat by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_halloween': {
        title: 'Big Bass Halloween Slot | 5,000x Max Win | {brand}',
        description: 'Play Big Bass Halloween slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/big_bass_halloween_2': {
        title: 'Big Bass Halloween 2 Slot | 5,000x Max Win | {brand}',
        description: 'Play Big Bass Halloween 2 slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/big_bass_halloween_3': {
        title: 'Big Bass Halloween 3 Slot | 5,000x Max Win | {brand}',
        description: 'Play Big Bass Halloween 3 slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/big_bass_hold_and_spinner_megaways': {
        title: 'Big Bass Hold And Spinner Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Hold And Spinner Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_mission_fishin': {
        title: "Big Bass Mission Fishin' Slot | Pragmatic Play | {brand}",
        description: "Play Big Bass Mission Fishin' by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more."
    },
    '/p/pragmatic-play/big_bass_raceday_repeat': {
        title: 'Big Bass Raceday Repeat Slot | 5,000x Max Win | {brand}',
        description: 'Play Big Bass Raceday Repeat slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/big_bass_reel_repeat': {
        title: 'Big Bass Reel Repeat Slot | 5,000x Max Win | {brand}',
        description: 'Play Big Bass Reel Repeat slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/big_bass_return_to_the_races': {
        title: 'Big Bass Return To The Races Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Return To The Races by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_secrets_of_the_golden_lake': {
        title: 'Big Bass Secrets Of The Golden Lake Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Secrets Of The Golden Lake by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_splash': {
        title: 'Big Bass Splash Slot | 5,000x Max Win | {brand}',
        description: 'Play Big Bass Splash slot with Bitcoin at {brand}. High volatility, 5,000x max win, fisherman collect feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/big_bass_splash_1000': {
        title: 'Big Bass Splash 1000 Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Splash 1000 by Pragmatic Play at {brand}. Medium-High volatility, 1000x multiplier. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_bass_vegas_double_down_deluxe': {
        title: 'Big Bass Vegas Double Down Deluxe Slot | Pragmatic Play | {brand}',
        description: 'Play Big Bass Vegas Double Down Deluxe by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_burger_load_it_up_with_xtra_cheese': {
        title: 'Big Burger Load It Up With Xtra Cheese Slot | Pragmatic Play | {brand}',
        description: 'Play Big Burger Load It Up With Xtra Cheese by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/big_juan': {
        title: 'Big Juan Slot | Play Online | {brand}',
        description: 'Play Big Juan by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/bigger_barn_house_bonanza': {
        title: 'Bigger Barn House Bonanza Slot | 25,000x Max Win | {brand}',
        description: 'Play Bigger Barn House Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 25,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bigger_bass_blizzard_christmas_catch': {
        title: 'Bigger Bass Blizzard Christmas Catch Slot | Pragmatic Play | {brand}',
        description: 'Play Bigger Bass Blizzard Christmas Catch by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/bigger_bass_bonanza': {
        title: 'Bigger Bass Bonanza Slot | 4,000x Max Win | {brand}',
        description: 'Play Bigger Bass Bonanza slot with Bitcoin at {brand}. High volatility, 4,000x max win, fisherman collect feature. Crypto deposits.'
    },
    '/p/pragmatic-play/bigger_bass_splash': {
        title: 'Bigger Bass Splash Slot | Play Online | {brand}',
        description: 'Play Bigger Bass Splash by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees.'
    },
    '/p/pragmatic-play/bingo_mania': {
        title: 'Bingo Mania Slot | 5,000x Max Win | {brand}',
        description: 'Play Bingo Mania slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/black_bull': {
        title: 'Black Bull Slot | 4,500x Max Win | {brand}',
        description: 'Play Black Bull slot with Bitcoin at {brand}. Medium-High volatility, 4,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/blade_and_fangs': {
        title: 'Blade And Fangs Slot | 5,000x Max Win | {brand}',
        description: 'Play Blade And Fangs slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/blazing_wilds_megaways': {
        title: 'Blazing Wilds Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Blazing Wilds Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/blitz_super_wheel': {
        title: 'Blitz Super Wheel Slot | 10,000x Max Win | {brand}',
        description: 'Play Blitz Super Wheel slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bloody_dawn': {
        title: 'Bloody Dawn Slot | 5,000x Max Win | {brand}',
        description: 'Play Bloody Dawn slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bomb_bonanza': {
        title: 'Bomb Bonanza Slot | 2,015x (during free spins) Max Win | {brand}',
        description: 'Play Bomb Bonanza with crypto at {brand}. High volatility, 2,015x (during free spins) max win. BTC, ETH, USDT accepted No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/bonanza_gold': {
        title: 'Bonanza Gold Slot | 21,175x Max Win | {brand}',
        description: 'Play Bonanza Gold slot with Bitcoin at {brand}. Medium-High volatility, 21,175x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/book_of_aztec_king': {
        title: 'Book Of Aztec King Slot | 5,533x Max Win | {brand}',
        description: 'Play Book Of Aztec King slot with Bitcoin at {brand}. Medium-High volatility, 5,533x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/book_of_golden_sands': {
        title: 'Book Of Golden Sands Slot | 10,000x Max Win | {brand}',
        description: 'Play Book Of Golden Sands slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/book_of_kingdoms': {
        title: 'Book Of Kingdoms Slot | 20,000x (combined bonus cap) Max Win | {brand}',
        description: 'Play Book Of Kingdoms with crypto at {brand}. Medium volatility, 20,000x (combined bonus cap) max win. BTC, ETH, USDT accepted.'
    },
    '/p/pragmatic-play/book_of_monsters': {
        title: 'Book Of Monsters Slot | 5,000x Max Win | {brand}',
        description: 'Play Book Of Monsters slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/book_of_the_fallen': {
        title: 'Book Of The Fallen Slot | 5,000x Max Win | {brand}',
        description: 'Play Book Of The Fallen slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bounty_gold': {
        title: 'Bounty Gold Slot | 5,000x Max Win | {brand}',
        description: 'Play Bounty Gold slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bounty_hunter': {
        title: 'Bounty Hunter Slot | 10,000x Max Win | {brand}',
        description: 'Play Bounty Hunter slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bow_of_artemis': {
        title: 'Bow Of Artemis Slot | 10,000x Max Win | {brand}',
        description: 'Play Bow Of Artemis slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/brick_house_bonanza': {
        title: 'Brick House Bonanza Slot | 10,000x Max Win | {brand}',
        description: 'Play Brick House Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bubble_pop': {
        title: 'Bubble Pop Slot | 27,000x Max Win | {brand}',
        description: 'Play Bubble Pop slot with Bitcoin at {brand}. Medium-High volatility, 27,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/buffalo_king': {
        title: 'Buffalo King Slot | 93,750x Max Win | {brand}',
        description: 'Play Buffalo King slot with Bitcoin at {brand}. Medium-High volatility, 93,750x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/buffalo_king_megaways': {
        title: 'Buffalo King Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Buffalo King Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/buffalo_king_untamed_megaways': {
        title: 'Buffalo King Untamed Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Buffalo King Untamed Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/bull_fiesta': {
        title: 'Bull Fiesta Slot | 2,500x Max Win | {brand}',
        description: 'Play Bull Fiesta slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/busy_bees': {
        title: 'Busy Bees Slot | 3,325x Max Win | {brand}',
        description: 'Play Busy Bees slot with Bitcoin at {brand}. Medium-High volatility, 3,325x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/caishens_cash': {
        title: "Caishen's Cash Slot | 21,749x Max Win | {brand}",
        description: "Play Caishen's Cash slot with Bitcoin at {brand}. Medium-High volatility, 21,749x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/caishens_gold': {
        title: "Caishen's Gold Slot | 21,749x Max Win | {brand}",
        description: "Play Caishen's Gold slot with Bitcoin at {brand}. Medium-High volatility, 21,749x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/candy_blitz': {
        title: 'Candy Blitz Slot | 5,000x Max Win | {brand}',
        description: 'Play Candy Blitz slot with Bitcoin at {brand}. High volatility, 5,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/candy_blitz_bombs': {
        title: 'Candy Blitz Bombs Slot | 5,000x Max Win | {brand}',
        description: 'Play Candy Blitz Bombs slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/candy_corner': {
        title: 'Candy Corner Slot | 10,000x Max Win | {brand}',
        description: 'Play Candy Corner slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/candy_jar_cluster': {
        title: 'Candy Jar Cluster Slot | 10,000x Max Win | {brand}',
        description: 'Play Candy Jar Cluster slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, cluster pays. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/candy_stars': {
        title: 'Candy Stars Slot | Play Online | {brand}',
        description: 'Play Candy Stars by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/candy_village': {
        title: 'Candy Village Slot | Play Online | {brand}',
        description: 'Play Candy Village by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/captain_kraken_megaways': {
        title: 'Captain Kraken Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Captain Kraken Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/cash_bonanza': {
        title: 'Cash Bonanza Slot | 5,000x Max Win | {brand}',
        description: 'Play Cash Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/cash_box': {
        title: 'Cash Box Slot | 5,000x Max Win | {brand}',
        description: 'Play Cash Box slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/cash_chips': {
        title: 'Cash Chips Slot | 10,000x Max Win | {brand}',
        description: 'Play Cash Chips slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/cash_elevator': {
        title: 'Cash Elevator Slot | Play Online | {brand}',
        description: 'Play Cash Elevator by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/cash_patrol': {
        title: 'Cash Patrol Slot | 10,500x Max Win | {brand}',
        description: 'Play Cash Patrol slot with Bitcoin at {brand}. Medium-High volatility, 10,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/cash_surge': {
        title: 'Cash Surge Slot | 5,000x Max Win | {brand}',
        description: 'Play Cash Surge slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/casino_heist_megaways': {
        title: 'Casino Heist Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Casino Heist Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/castle_of_fire': {
        title: 'Castle Of Fire Slot | 8,000x Max Win | {brand}',
        description: 'Play Castle Of Fire slot with Bitcoin at {brand}. Medium-High volatility, 8,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/chase_for_glory': {
        title: 'Chase For Glory Slot | 7,887x Max Win | {brand}',
        description: 'Play Chase For Glory slot with Bitcoin at {brand}. Medium-High volatility, 7,887x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/cheeky_emperor': {
        title: 'Cheeky Emperor Slot | 2,500x Max Win | {brand}',
        description: 'Play Cheeky Emperor slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/chests_of_cai_shen': {
        title: 'Chests Of Cai Shen Slot | 10,000x Max Win | {brand}',
        description: 'Play Chests Of Cai Shen slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/chests_of_cai_shen_2': {
        title: 'Chests Of Cai Shen 2 Slot | 15,000x Max Win | {brand}',
        description: 'Play Chests Of Cai Shen 2 slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/chicken_chase': {
        title: 'Chicken Chase Slot | 210x Max Win | {brand}',
        description: 'Play Chicken Chase slot with Bitcoin at {brand}. Medium-High volatility, 210x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/chicken_drop': {
        title: 'Chicken Drop Slot | 5,000x Max Win | {brand}',
        description: 'Play Chicken Drop slot with Bitcoin at {brand}. High volatility, 5,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/chilli_heat': {
        title: 'Chilli Heat Slot | 2,000x Max Win | {brand}',
        description: 'Play Chilli Heat slot with Bitcoin at {brand}. Medium volatility, 2,000x max win, money respin mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/chilli_heat_megaways': {
        title: 'Chilli Heat Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Chilli Heat Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/chilli_heat_spicy_spins': {
        title: 'Chilli Heat Spicy Spins Slot | 10,000x Max Win | {brand}',
        description: 'Play Chilli Heat Spicy Spins slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/christmas_big_bass_bonanza': {
        title: 'Christmas Big Bass Bonanza Slot | Pragmatic Play | {brand}',
        description: 'Play Christmas Big Bass Bonanza by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/christmas_carol_megaways': {
        title: 'Christmas Carol Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Christmas Carol Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/cleocatra': {
        title: 'Cleocatra Slot | 5,000x Max Win | {brand}',
        description: 'Play Cleocatra slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/clover_gold': {
        title: 'Clover Gold Slot | Play Online | {brand}',
        description: 'Play Clover Gold by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/club_tropicana': {
        title: 'Club Tropicana Slot | 5,000x Max Win | {brand}',
        description: 'Play Club Tropicana slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/club_tropicana_happy_hour': {
        title: 'Club Tropicana Happy Hour Slot | 5,000x Max Win | {brand}',
        description: 'Play Club Tropicana Happy Hour slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/coffee_wild': {
        title: 'Coffee Wild Slot | 4,000x Max Win | {brand}',
        description: 'Play Coffee Wild slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/colossal_cash_zone': {
        title: 'Colossal Cash Zone Slot | 5,000x Max Win | {brand}',
        description: 'Play Colossal Cash Zone slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/congo_cash': {
        title: 'Congo Cash Slot | 4,400x Max Win | {brand}',
        description: 'Play Congo Cash slot with Bitcoin at {brand}. Medium-High volatility, 4,400x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/congo_cash_xl': {
        title: 'Congo Cash Xl Slot | 4,400x Max Win | {brand}',
        description: 'Play Congo Cash Xl slot with Bitcoin at {brand}. Medium-High volatility, 4,400x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/cosmic_cash': {
        title: 'Cosmic Cash Slot | 2,650x Max Win | {brand}',
        description: 'Play Cosmic Cash slot with Bitcoin at {brand}. Medium-High volatility, 2,650x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/cowboy_coins': {
        title: 'Cowboy Coins Slot | 30,000x Max Win | {brand}',
        description: 'Play Cowboy Coins slot with Bitcoin at {brand}. Medium-High volatility, 30,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/cowboys_gold': {
        title: 'Cowboys Gold Slot | 5,000x Max Win | {brand}',
        description: 'Play Cowboys Gold slot with Bitcoin at {brand}. High volatility, 5,000x max win, money respin mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/crank_it_up': {
        title: 'Crank It Up Slot | 10,000x Max Win | {brand}',
        description: 'Play Crank It Up slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/crown_of_fire': {
        title: 'Crown Of Fire Slot | 1,000x Max Win | {brand}',
        description: 'Play Crown Of Fire slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/crown_of_fire_jackpot_play': {
        title: 'Crown Of Fire Jackpot Play Slot | 1,000x Max Win | {brand}',
        description: 'Play Crown Of Fire Jackpot Play slot with Bitcoin at {brand}. Medium volatility, 1,000x max win, jackpot play. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/crystal_caverns_megaways': {
        title: 'Crystal Caverns Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Crystal Caverns Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/curse_of_the_werewolf_megaways': {
        title: 'Curse Of The Werewolf Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Curse Of The Werewolf Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/cyber_heist': {
        title: 'Cyber Heist Slot | 5,000x Max Win | {brand}',
        description: 'Play Cyber Heist slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/cyberheist_city': {
        title: 'Cyberheist City Slot | 5,000x Max Win | {brand}',
        description: 'Play Cyberheist City slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/cyclops_smash': {
        title: 'Cyclops Smash Slot | 10,000x Max Win | {brand}',
        description: 'Play Cyclops Smash slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/dance_party': {
        title: 'Dance Party Slot | 36,450x Max Win | {brand}',
        description: 'Play Dance Party slot with Bitcoin at {brand}. Medium-High volatility, 36,450x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/davincis_treasure': {
        title: "Davinci's Treasure Slot | 48,000x Max Win | {brand}",
        description: "Play Davinci's Treasure slot with Bitcoin at {brand}. Medium-High volatility, 48,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/day_of_dead': {
        title: 'Day Of Dead Slot | Play Online | {brand}',
        description: 'Play Day Of Dead by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/demon_pots': {
        title: 'Demon Pots Slot | Play Online | {brand}',
        description: 'Play Demon Pots by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/devilicious': {
        title: 'Devilicious Slot | 10,000x Max Win | {brand}',
        description: 'Play Devilicious slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/devils_13': {
        title: 'Devils 13 Slot | 1,101x Max Win | {brand}',
        description: 'Play Devils 13 slot with Bitcoin at {brand}. Medium-High volatility, 1,101x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/diamond_cascade': {
        title: 'Diamond Cascade Slot | 8,000x Max Win | {brand}',
        description: 'Play Diamond Cascade slot with Bitcoin at {brand}. Medium-High volatility, 8,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/diamond_strike': {
        title: 'Diamond Strike Slot | 1,000x (from jackpot bonus) Max Win | {brand}',
        description: 'Play Diamond Strike with crypto at {brand}. Medium volatility, 1,000x (from jackpot bonus) max win. BTC, ETH, USDT accepted.'
    },
    '/p/pragmatic-play/diamonds_of_egypt': {
        title: 'Diamonds Of Egypt Slot | 2,500x Max Win | {brand}',
        description: 'Play Diamonds Of Egypt slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/ding_dong_christmas_bells': {
        title: 'Ding Dong Christmas Bells Slot | 2,100x Max Win | {brand}',
        description: 'Play Ding Dong Christmas Bells slot with Bitcoin at {brand}. Medium-High volatility, 2,100x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/disco_lady': {
        title: 'Disco Lady Slot | 5,000x Max Win | {brand}',
        description: 'Play Disco Lady slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/down_the_rails': {
        title: 'Down The Rails Slot | 5,000x Max Win | {brand}',
        description: 'Play Down The Rails slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/drago_jewels_of_fortune': {
        title: 'Drago Jewels Of Fortune Slot | 48,000x Max Win | {brand}',
        description: 'Play Drago Jewels Of Fortune slot with Bitcoin at {brand}. Medium-High volatility, 48,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/dragon_gold_88': {
        title: 'Dragon Gold 88 Slot | Play Online | {brand}',
        description: 'Play Dragon Gold 88 by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/dragon_hero': {
        title: 'Dragon Hero Slot | Play Online | {brand}',
        description: 'Play Dragon Hero by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/dragon_hot_hold_and_spin': {
        title: 'Dragon Hot Hold And Spin Slot | Pragmatic Play | {brand}',
        description: 'Play Dragon Hot Hold And Spin by Pragmatic Play at {brand}. Medium-High volatility, hold and spin. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/dragon_king_hot_pots': {
        title: 'Dragon King Hot Pots Slot | Pragmatic Play | {brand}',
        description: 'Play Dragon King Hot Pots by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/dragon_kingdom': {
        title: 'Dragon Kingdom Slot | 400x Max Win | {brand}',
        description: 'Play Dragon Kingdom slot with Bitcoin at {brand}. Medium-High volatility, 400x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/dragon_kingdom_eyes_of_fire': {
        title: 'Dragon Kingdom Eyes Of Fire Slot | 1,250x Max Win | {brand}',
        description: 'Play Dragon Kingdom Eyes Of Fire slot with Bitcoin at {brand}. Medium-High volatility, 1,250x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/dragon_tiger_fortunes': {
        title: 'Dragon Tiger Fortunes Slot | 8,200x Max Win | {brand}',
        description: 'Play Dragon Tiger Fortunes slot with Bitcoin at {brand}. Medium-High volatility, 8,200x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/drill_that_gold': {
        title: 'Drill That Gold Slot | 5,000x Max Win | {brand}',
        description: 'Play Drill That Gold slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/duel_of_night_and_day': {
        title: 'Duel Of Night And Day Slot | 10,000x Max Win | {brand}',
        description: 'Play Duel Of Night And Day slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/dwarf_and_dragon': {
        title: 'Dwarf And Dragon Slot | 14,000x Max Win | {brand}',
        description: 'Play Dwarf And Dragon slot with Bitcoin at {brand}. Medium-High volatility, 14,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/dwarven_gold_deluxe': {
        title: 'Dwarven Gold Deluxe Slot | 1,000x Max Win | {brand}',
        description: 'Play Dwarven Gold Deluxe slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/dynamite_diggin_doug': {
        title: "Dynamite Diggin' Doug Slot | Pragmatic Play | {brand}",
        description: "Play Dynamite Diggin' Doug by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more."
    },
    '/p/pragmatic-play/egg_rush_jackpot_play': {
        title: 'Egg Rush Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Egg Rush Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/egyptian_fortunes': {
        title: 'Egyptian Fortunes Slot | 309x Max Win | {brand}',
        description: 'Play Egyptian Fortunes slot with Bitcoin at {brand}. Medium-High volatility, 309x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/elemental_gems_megaways': {
        title: 'Elemental Gems Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Elemental Gems Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/emerald_king': {
        title: 'Emerald King Slot | Play Online | {brand}',
        description: 'Play Emerald King by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/emerald_king_rainbow_road': {
        title: 'Emerald King Rainbow Road Slot | Pragmatic Play | {brand}',
        description: 'Play Emerald King Rainbow Road by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/emperor_caishen': {
        title: 'Emperor Caishen Slot | Play Online | {brand}',
        description: 'Play Emperor Caishen by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/empty_the_bank': {
        title: 'Empty The Bank Slot | 10,000x Max Win | {brand}',
        description: 'Play Empty The Bank slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/escape_the_pyramid_fire_and_ice': {
        title: 'Escape The Pyramid Fire And Ice Slot | 5,000x Max Win | {brand}',
        description: 'Play Escape The Pyramid Fire And Ice slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/eternal_empress_freeze_time': {
        title: 'Eternal Empress Freeze Time Slot | 4,888x Max Win | {brand}',
        description: 'Play Eternal Empress Freeze Time slot with Bitcoin at {brand}. Medium-High volatility, 4,888x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/excalibur_unleashed': {
        title: 'Excalibur Unleashed Slot | Play Online | {brand}',
        description: 'Play Excalibur Unleashed by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/extra_juicy': {
        title: 'Extra Juicy Slot | 60,000x Max Win | {brand}',
        description: 'Play Extra Juicy slot with Bitcoin at {brand}. Medium-High volatility, 60,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/extra_juicy_megaways': {
        title: 'Extra Juicy Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Extra Juicy Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/eye_of_cleopatra': {
        title: 'Eye Of Cleopatra Slot | 4,000x Max Win | {brand}',
        description: 'Play Eye Of Cleopatra slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/eye_of_spartacus': {
        title: 'Eye Of Spartacus Slot | 10,000x Max Win | {brand}',
        description: 'Play Eye Of Spartacus slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/eye_of_the_storm': {
        title: 'Eye Of The Storm Slot | Play Online | {brand}',
        description: 'Play Eye Of The Storm by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/fairytale_fortune': {
        title: 'Fairytale Fortune Slot | 500x Max Win | {brand}',
        description: 'Play Fairytale Fortune slot with Bitcoin at {brand}. Medium-High volatility, 500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fangtastic_freespins': {
        title: 'Fangtastic Freespins Slot | Pragmatic Play | {brand}',
        description: 'Play Fangtastic Freespins by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/fat_panda': {
        title: 'Fat Panda Slot | 20,000x Max Win | {brand}',
        description: 'Play Fat Panda slot with Bitcoin at {brand}. High volatility, 20,000x max win, top reel mechanic: floating. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fiesta_fortune': {
        title: 'Fiesta Fortune Slot | 5,000x Max Win | {brand}',
        description: 'Play Fiesta Fortune slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/finger_lickn_free_spins': {
        title: "Finger Lick'n Free Spins Slot | 6,000.00x Max Win | {brand}",
        description: "Play Finger Lick'n Free Spins slot with Bitcoin at {brand}. High volatility, 6,000.00x max win, if three or more. Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/fire_88': {
        title: 'Fire 88 Slot | 902x Max Win | {brand}',
        description: 'Play Fire 88 slot with Bitcoin at {brand}. Medium-High volatility, 902x max win, Crypto deposits, instant withdrawals No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/fire_hot_100': {
        title: 'Fire Hot 100 Slot | 2,700x Max Win | {brand}',
        description: 'Play Fire Hot 100 slot with Bitcoin at {brand}. Medium-High volatility, 2,700x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fire_hot_100_jackpot_play': {
        title: 'Fire Hot 100 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Fire Hot 100 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/fire_hot_20': {
        title: 'Fire Hot 20 Slot | 1,234x Max Win | {brand}',
        description: 'Play Fire Hot 20 slot with Bitcoin at {brand}. Medium-High volatility, 1,234x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fire_hot_20_jackpot_play': {
        title: 'Fire Hot 20 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Fire Hot 20 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/fire_hot_40': {
        title: 'Fire Hot 40 Slot | 2,700x Max Win | {brand}',
        description: 'Play Fire Hot 40 slot with Bitcoin at {brand}. Medium-High volatility, 2,700x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fire_hot_40_jackpot_play': {
        title: 'Fire Hot 40 Jackpot Play Slot | 5,000x Max Win | {brand}',
        description: 'Play Fire Hot 40 Jackpot Play slot with Bitcoin at {brand}. Medium volatility, 5,000x max win, jackpot play. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fire_hot_5': {
        title: 'Fire Hot 5 Slot | 1,392x Max Win | {brand}',
        description: 'Play Fire Hot 5 slot with Bitcoin at {brand}. Medium-High volatility, 1,392x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fire_hot_5_jackpot_play': {
        title: 'Fire Hot 5 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Fire Hot 5 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/fire_portals': {
        title: 'Fire Portals Slot | 10,000x Max Win | {brand}',
        description: 'Play Fire Portals slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fire_stampede': {
        title: 'Fire Stampede Slot | 5,000x Max Win | {brand}',
        description: 'Play Fire Stampede slot with Bitcoin at {brand}. High volatility, 5,000x max win, stacked symbols. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fire_stampede_2': {
        title: 'Fire Stampede 2 Slot | 8,300x Max Win | {brand}',
        description: 'Play Fire Stampede 2 slot with Bitcoin at {brand}. Medium-High volatility, 8,300x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fire_stampede_ultimate': {
        title: 'Fire Stampede Ultimate Slot | 12,500x Max Win | {brand}',
        description: 'Play Fire Stampede Ultimate slot with Bitcoin at {brand}. Medium-High volatility, 12,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fire_strike': {
        title: 'Fire Strike Slot | 25,000x (15 wilds jackpot) Max Win | {brand}',
        description: 'Play Fire Strike with crypto at {brand}. Medium-High volatility, 25,000x (15 wilds jackpot) max win. BTC, ETH, USDT accepted.'
    },
    '/p/pragmatic-play/fire_strike_2': {
        title: 'Fire Strike 2 Slot | 25,000x Max Win | {brand}',
        description: 'Play Fire Strike 2 slot with Bitcoin at {brand}. Medium-High volatility, 25,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fish_eye': {
        title: 'Fish Eye Slot | Play Online | {brand}',
        description: 'Play Fish Eye by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/fishin_reels': {
        title: "Fishin' Reels Slot | 1,200x Max Win | {brand}",
        description: "Play Fishin' Reels slot with Bitcoin at {brand}. Medium-High volatility, 1,200x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/floating_dragon': {
        title: 'Floating Dragon Slot | 3,000x Max Win | {brand}',
        description: 'Play Floating Dragon slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, money respin with dragon bonus. Crypto deposits.'
    },
    '/p/pragmatic-play/floating_dragon_dragon_boat_festival': {
        title: 'Floating Dragon Dragon Boat Festival Slot | Pragmatic Play | {brand}',
        description: 'Play Floating Dragon Dragon Boat Festival by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/floating_dragon_hold_and_spin_megaways': {
        title: 'Floating Dragon Hold And Spin Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Floating Dragon Hold And Spin Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/floating_dragon_megaways': {
        title: 'Floating Dragon Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Floating Dragon Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/floating_dragon_new_year_festival_ultra_megaways': {
        title: 'Floating Dragon New Year Festival Ultra Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Floating Dragon New Year Festival Ultra Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT.'
    },
    '/p/pragmatic-play/floating_dragon_wild_horses': {
        title: 'Floating Dragon Wild Horses Slot | Pragmatic Play | {brand}',
        description: 'Play Floating Dragon Wild Horses by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/floating_dragon_year_of_the_snake': {
        title: 'Floating Dragon Year Of The Snake Slot | 5,000x Max Win | {brand}',
        description: 'Play Floating Dragon Year Of The Snake with crypto at {brand}. Very High volatility, 5,000x max win. BTC, ETH, USDT accepted.'
    },
    '/p/pragmatic-play/fonzos_feline_fortunes': {
        title: "Fonzo's Feline Fortunes Slot | Pragmatic Play | {brand}",
        description: "Play Fonzo's Feline Fortunes by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more."
    },
    '/p/pragmatic-play/forge_of_olympus': {
        title: 'Forge Of Olympus Slot | 5,000x Max Win | {brand}',
        description: 'Play Forge Of Olympus slot with Bitcoin at {brand}. High volatility, 5,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/forging_wilds': {
        title: 'Forging Wilds Slot | 10,000x Max Win | {brand}',
        description: 'Play Forging Wilds slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fortune_ace': {
        title: 'Fortune Ace Slot | 5,000x Max Win | {brand}',
        description: 'Play Fortune Ace slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fortune_ace_scatter': {
        title: 'Fortune Ace Scatter Slot | 100,000x Max Win | {brand}',
        description: 'Play Fortune Ace Scatter slot with Bitcoin at {brand}. Medium-High volatility, 100,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fortune_hitn_roll': {
        title: "Fortune Hit'n Roll Slot | 5,000x Max Win | {brand}",
        description: "Play Fortune Hit'n Roll slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/fortune_of_giza': {
        title: 'Fortune Of Giza Slot | 5,000x Max Win | {brand}',
        description: 'Play Fortune Of Giza slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fortune_of_olympus': {
        title: 'Fortune Of Olympus Slot | 10,000x Max Win | {brand}',
        description: 'Play Fortune Of Olympus slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fortunes_of_aztec': {
        title: 'Fortunes Of Aztec Slot | 10,000x Max Win | {brand}',
        description: 'Play Fortunes Of Aztec slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/frightening_frankie': {
        title: 'Frightening Frankie Slot | 2,800x Max Win | {brand}',
        description: 'Play Frightening Frankie slot with Bitcoin at {brand}. Medium-High volatility, 2,800x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/frogs_and_bugs': {
        title: 'Frogs And Bugs Slot | 3,000x Max Win | {brand}',
        description: 'Play Frogs And Bugs slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/front_runner_odds_on': {
        title: 'Front Runner Odds On Slot | Pragmatic Play | {brand}',
        description: 'Play Front Runner Odds On by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/frozen_tropics': {
        title: 'Frozen Tropics Slot | Play Online | {brand}',
        description: 'Play Frozen Tropics by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/fruit_party': {
        title: 'Fruit Party Slot | 5,000x Max Win | {brand}',
        description: 'Play Fruit Party slot with Bitcoin at {brand}. High volatility, 5,000x max win, tumble feature removes winning. Crypto deposits.'
    },
    '/p/pragmatic-play/fruit_party_2': {
        title: 'Fruit Party 2 Slot | 5,000x Max Win | {brand}',
        description: 'Play Fruit Party 2 slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fruit_rainbow': {
        title: 'Fruit Rainbow Slot | 2,000x Max Win | {brand}',
        description: 'Play Fruit Rainbow slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fruity_treats': {
        title: 'Fruity Treats Slot | 5,000x Max Win | {brand}',
        description: 'Play Fruity Treats slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/fu_fu_fu': {
        title: 'Fu Fu Fu Slot | 100x Max Win | {brand}',
        description: 'Play Fu Fu Fu slot with Bitcoin at {brand}. Medium-High volatility, 100x max win, Crypto deposits, instant withdrawals No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/fury_of_odin_megaways': {
        title: 'Fury Of Odin Megaways Slot | 15,000x Max Win | {brand}',
        description: 'Play Fury Of Odin Megaways slot with Bitcoin at {brand}. High volatility, 15,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gameshow_party_jackpot_play': {
        title: 'Gameshow Party Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Gameshow Party Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/gates_of_aztec': {
        title: 'Gates Of Aztec Slot | 5,000x Max Win | {brand}',
        description: 'Play Gates Of Aztec slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gates_of_gatot_kaca': {
        title: 'Gates Of Gatot Kaca Slot | 5,000x Max Win | {brand}',
        description: 'Play Gates Of Gatot Kaca slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gates_of_gatot_kaca_1000': {
        title: 'Gates Of Gatot Kaca 1000 Slot | 15,000x Max Win | {brand}',
        description: 'Play Gates Of Gatot Kaca 1000 slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, 1000x multiplier. Crypto deposits.'
    },
    '/p/pragmatic-play/gates_of_gatot_kaca_super_scatter': {
        title: 'Gates Of Gatot Kaca Super Scatter Slot | 50,000x Max Win | {brand}',
        description: 'Play Gates Of Gatot Kaca Super Scatter slot with Bitcoin at {brand}. Medium-High volatility, 50,000x max win, super scatter. Crypto deposits.'
    },
    '/p/pragmatic-play/gates_of_hades': {
        title: 'Gates Of Hades Slot | 10,000x Max Win | {brand}',
        description: 'Play Gates Of Hades slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gates_of_olympus': {
        title: 'Gates Of Olympus Slot | 5,000x Max Win | {brand}',
        description: 'Play Gates Of Olympus slot with Bitcoin at {brand}. High volatility, 5,000x max win, tumble/cascade mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gates_of_olympus_1000': {
        title: 'Gates Of Olympus 1000 Slot | 15,000x Max Win | {brand}',
        description: 'Play Gates Of Olympus 1000 slot with Bitcoin at {brand}. Very High volatility, 15,000x max win, tumble/cascade mechanic. Crypto deposits.'
    },
    '/p/pragmatic-play/gates_of_olympus_dice': {
        title: 'Gates Of Olympus Dice Slot | 15,000x Max Win | {brand}',
        description: 'Play Gates Of Olympus Dice slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, dice variant. Crypto deposits.'
    },
    '/p/pragmatic-play/gates_of_olympus_super_scatter': {
        title: 'Gates Of Olympus Super Scatter Slot | 50,000x Max Win | {brand}',
        description: 'Play Gates Of Olympus Super Scatter slot with Bitcoin at {brand}. Medium-High volatility, 50,000x max win, super scatter. Crypto deposits.'
    },
    '/p/pragmatic-play/gates_of_olympus_xmas_1000': {
        title: 'Gates Of Olympus Xmas 1000 Slot | 15,000x Max Win | {brand}',
        description: 'Play Gates Of Olympus Xmas 1000 slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, 1000x multiplier. Crypto deposits.'
    },
    '/p/pragmatic-play/gates_of_valhalla': {
        title: 'Gates Of Valhalla Slot | 10,000x Max Win | {brand}',
        description: 'Play Gates Of Valhalla slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gatot_kacas_fury': {
        title: 'Gatot Kacas Fury Slot | 5,000x Max Win | {brand}',
        description: 'Play Gatot Kacas Fury slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gears_of_horus': {
        title: 'Gears Of Horus Slot | 10,000x Max Win | {brand}',
        description: 'Play Gears Of Horus slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gem_elevator': {
        title: 'Gem Elevator Slot | 10,000x Max Win | {brand}',
        description: 'Play Gem Elevator slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gem_fire_fortune': {
        title: 'Gem Fire Fortune Slot | 15,000x Max Win | {brand}',
        description: 'Play Gem Fire Fortune slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gem_trio': {
        title: 'Gem Trio Slot | 20,000x Max Win | {brand}',
        description: 'Play Gem Trio slot with Bitcoin at {brand}. Medium-High volatility, 20,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gems_bonanza': {
        title: 'Gems Bonanza Slot | Not specified Max Win | {brand}',
        description: 'Play Gems Bonanza slot with Bitcoin at {brand}. Very High volatility, Not specified max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gems_of_serengeti': {
        title: 'Gems Of Serengeti Slot | 4,000x Max Win | {brand}',
        description: 'Play Gems Of Serengeti slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gemstone': {
        title: 'Gemstone Slot | Play Online | {brand}',
        description: 'Play Gemstone by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/genies_gem_bonanza': {
        title: 'Genies Gem Bonanza Slot | 10,000x Max Win | {brand}',
        description: 'Play Genies Gem Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/goblin_heist_powernudge': {
        title: 'Goblin Heist Powernudge Slot | 4,000x Max Win | {brand}',
        description: 'Play Goblin Heist Powernudge slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, powernudge. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gods_of_giza': {
        title: 'Gods Of Giza Slot | 5,000x Max Win | {brand}',
        description: 'Play Gods Of Giza slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gold_oasis': {
        title: 'Gold Oasis Slot | 7,260x Max Win | {brand}',
        description: 'Play Gold Oasis slot with Bitcoin at {brand}. Medium-High volatility, 7,260x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gold_party': {
        title: 'Gold Party Slot | 5,163x Max Win | {brand}',
        description: 'Play Gold Party slot with Bitcoin at {brand}. Medium-High volatility, 5,163x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gold_party_2_after_hours': {
        title: 'Gold Party 2 After Hours Slot | 10,312x Max Win | {brand}',
        description: 'Play Gold Party 2 After Hours slot with Bitcoin at {brand}. Medium-High volatility, 10,312x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gold_train': {
        title: 'Gold Train Slot | 513x Max Win | {brand}',
        description: 'Play Gold Train slot with Bitcoin at {brand}. Low volatility, 513x max win, progressive bonus feature triggered. Crypto deposits.'
    },
    '/p/pragmatic-play/golden_ox': {
        title: 'Golden Ox Slot | Play Online | {brand}',
        description: 'Play Golden Ox by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/golden_pig': {
        title: 'Golden Pig Slot | 2,500x Max Win | {brand}',
        description: 'Play Golden Pig slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/good_luck_and_good_fortune': {
        title: 'Good Luck And Good Fortune Slot | Pragmatic Play | {brand}',
        description: 'Play Good Luck And Good Fortune by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/gorilla_mayhem': {
        title: 'Gorilla Mayhem Slot | 5,000x Max Win | {brand}',
        description: 'Play Gorilla Mayhem slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/grace_of_ebisu': {
        title: 'Grace Of Ebisu Slot | 5,000x Max Win | {brand}',
        description: 'Play Grace Of Ebisu slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/gravity_bonanza': {
        title: 'Gravity Bonanza Slot | 10,000x Max Win | {brand}',
        description: 'Play Gravity Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/great_lagoon': {
        title: 'Great Lagoon Slot | Play Online | {brand}',
        description: 'Play Great Lagoon by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/great_reef': {
        title: 'Great Reef Slot | 3,000x Max Win | {brand}',
        description: 'Play Great Reef slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/great_rhino': {
        title: 'Great Rhino Slot | 900x Max Win | {brand}',
        description: 'Play Great Rhino slot with Bitcoin at {brand}. Medium-High volatility, 900x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/great_rhino_deluxe': {
        title: 'Great Rhino Deluxe Slot | 6,242x Max Win | {brand}',
        description: 'Play Great Rhino Deluxe slot with Bitcoin at {brand}. Medium-High volatility, 6,242x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/great_rhino_megaways': {
        title: 'Great Rhino Megaways Slot | 20,000x Max Win | {brand}',
        description: 'Play Great Rhino Megaways slot with Bitcoin at {brand}. High volatility, 20,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/greedy_fortune_pig': {
        title: 'Greedy Fortune Pig Slot | 8,888x Max Win | {brand}',
        description: 'Play Greedy Fortune Pig slot with Bitcoin at {brand}. Medium-High volatility, 8,888x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/greedy_wolf': {
        title: 'Greedy Wolf Slot | 3,000x Max Win | {brand}',
        description: 'Play Greedy Wolf slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/greek_gods': {
        title: 'Greek Gods Slot | 4,320x Max Win | {brand}',
        description: 'Play Greek Gods slot with Bitcoin at {brand}. Medium-High volatility, 4,320x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hammerstorm': {
        title: 'Hammerstorm Slot | 10,000x Max Win | {brand}',
        description: 'Play Hammerstorm slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hand_of_midas_2': {
        title: 'Hand Of Midas 2 Slot | 8,000x Max Win | {brand}',
        description: 'Play Hand Of Midas 2 slot with Bitcoin at {brand}. Medium-High volatility, 8,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/happy_fortune': {
        title: 'Happy Fortune Slot | 5,000x Max Win | {brand}',
        description: 'Play Happy Fortune slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/heart_of_cleopatra': {
        title: 'Heart Of Cleopatra Slot | 10,000x Max Win | {brand}',
        description: 'Play Heart Of Cleopatra slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/heart_of_rio': {
        title: 'Heart Of Rio Slot | 10,500x Max Win | {brand}',
        description: 'Play Heart Of Rio slot with Bitcoin at {brand}. Medium-High volatility, 10,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/heist_for_the_golden_nuggets': {
        title: 'Heist For The Golden Nuggets Slot | Pragmatic Play | {brand}',
        description: 'Play Heist For The Golden Nuggets by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/hellvis_wild': {
        title: 'Hellvis Wild Slot | Play Online | {brand}',
        description: 'Play Hellvis Wild by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/hercules_and_pegasus': {
        title: 'Hercules And Pegasus Slot | 2,000x Max Win | {brand}',
        description: 'Play Hercules And Pegasus slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hercules_son_of_zeus': {
        title: 'Hercules Son Of Zeus Slot | 800x Max Win | {brand}',
        description: 'Play Hercules Son Of Zeus slot with Bitcoin at {brand}. Medium-High volatility, 800x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/heroic_spin': {
        title: 'Heroic Spin Slot | 10,000x Max Win | {brand}',
        description: 'Play Heroic Spin slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/heroic_spins': {
        title: 'Heroic Spins Slot | 10,000x Max Win | {brand}',
        description: 'Play Heroic Spins slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/high_flyer': {
        title: 'High Flyer Slot | 1,000,000x Max Win | {brand}',
        description: 'Play High Flyer slot with Bitcoin at {brand}. Medium-High volatility, 1,000,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/himalayan_wild': {
        title: 'Himalayan Wild Slot | 10,000x Max Win | {brand}',
        description: 'Play Himalayan Wild slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hockey_attack': {
        title: 'Hockey Attack Slot | 2,500x Max Win | {brand}',
        description: 'Play Hockey Attack slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hokkaido_wolf': {
        title: 'Hokkaido Wolf Slot | 4,608x Max Win | {brand}',
        description: 'Play Hokkaido Wolf slot with Bitcoin at {brand}. Medium-High volatility, 4,608x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/holiday_ride': {
        title: 'Holiday Ride Slot | 5,000x Max Win | {brand}',
        description: 'Play Holiday Ride slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/honey_honey_honey': {
        title: 'Honey Honey Honey Slot | 910x Max Win | {brand}',
        description: 'Play Honey Honey Honey slot with Bitcoin at {brand}. Medium-High volatility, 910x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hot_chilli': {
        title: 'Hot Chilli Slot | 888x Max Win | {brand}',
        description: 'Play Hot Chilli slot with Bitcoin at {brand}. Medium-High volatility, 888x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/hot_fiesta': {
        title: 'Hot Fiesta Slot | 5,000x Max Win | {brand}',
        description: 'Play Hot Fiesta slot with Bitcoin at {brand}. High volatility, 5,000x max win, money respin mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hot_pepper': {
        title: 'Hot Pepper Slot | 10,000x Max Win | {brand}',
        description: 'Play Hot Pepper slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hot_safari': {
        title: 'Hot Safari Slot | 4,000x (lion symbol) Max Win | {brand}',
        description: 'Play Hot Safari slot with Bitcoin at {brand}. High volatility, 4,000x (lion symbol) max win, 6th bonus reel spins. Crypto deposits.'
    },
    '/p/pragmatic-play/hot_to_burn': {
        title: 'Hot To Burn Slot | 1,000x Max Win | {brand}',
        description: 'Play Hot To Burn slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hot_to_burn_7_deadly_free_spins': {
        title: 'Hot To Burn 7 Deadly Free Spins Slot | Pragmatic Play | {brand}',
        description: 'Play Hot To Burn 7 Deadly Free Spins by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/hot_to_burn_extreme': {
        title: 'Hot To Burn Extreme Slot | Play Online | {brand}',
        description: 'Play Hot To Burn Extreme by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/hot_to_burn_hold_and_spin': {
        title: 'Hot To Burn Hold And Spin Slot | Pragmatic Play | {brand}',
        description: 'Play Hot To Burn Hold And Spin by Pragmatic Play at {brand}. Medium-High volatility, hold and spin. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/hot_to_burn_jackpot_play': {
        title: 'Hot To Burn Jackpot Play Slot | 1,000x Max Win | {brand}',
        description: 'Play Hot To Burn Jackpot Play slot with Bitcoin at {brand}. Medium volatility, 1,000x max win, jackpot play. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/hot_to_burn_multiplier': {
        title: 'Hot To Burn Multiplier Slot | Pragmatic Play | {brand}',
        description: 'Play Hot To Burn Multiplier by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/hot_tuna': {
        title: 'Hot Tuna Slot | 2,500x Max Win | {brand}',
        description: 'Play Hot Tuna slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/hundreds_and_thousands': {
        title: 'Hundreds And Thousands Slot | Pragmatic Play | {brand}',
        description: 'Play Hundreds And Thousands by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/ice_lobster': {
        title: 'Ice Lobster Slot | 5,000x Max Win | {brand}',
        description: 'Play Ice Lobster slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/ice_mint': {
        title: 'Ice Mint Slot | 10,000x Max Win | {brand}',
        description: 'Play Ice Mint slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/infective_wild': {
        title: 'Infective Wild Slot | 5,000x Max Win | {brand}',
        description: 'Play Infective Wild slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/irish_charms': {
        title: 'Irish Charms Slot | Play Online | {brand}',
        description: 'Play Irish Charms by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/jackpot_blaze': {
        title: 'Jackpot Blaze Slot | 5,000x Max Win | {brand}',
        description: 'Play Jackpot Blaze slot with Bitcoin at {brand}. Medium volatility, 5,000x max win, jackpot play. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/jackpot_hunter': {
        title: 'Jackpot Hunter Slot | 5,000x Max Win | {brand}',
        description: 'Play Jackpot Hunter slot with Bitcoin at {brand}. Medium volatility, 5,000x max win, jackpot play. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/jade_butterfly': {
        title: 'Jade Butterfly Slot | 636x Max Win | {brand}',
        description: 'Play Jade Butterfly slot with Bitcoin at {brand}. Medium-High volatility, 636x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/jane_hunter_and_the_mask_of_montezuma': {
        title: 'Jane Hunter And The Mask Of Montezuma Slot | 5,000x Max Win | {brand}',
        description: 'Play Jane Hunter And The Mask Of Montezuma slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits.'
    },
    '/p/pragmatic-play/jasmine_dreams': {
        title: 'Jasmine Dreams Slot | 2,500x Max Win | {brand}',
        description: 'Play Jasmine Dreams slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/jewel_rush': {
        title: 'Jewel Rush Slot | 5,000x Max Win | {brand}',
        description: 'Play Jewel Rush slot with Bitcoin at {brand}. Very High volatility, 5,000x max win, cascade/tumble feature removes winning. Crypto deposits.'
    },
    '/p/pragmatic-play/john_hunter_and_galileos_secrets': {
        title: "John Hunter And Galileo's Secrets Slot | 5,000x Max Win | {brand}",
        description: "Play John Hunter And Galileo's Secrets slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/john_hunter_and_the_aztec_treasure': {
        title: 'John Hunter And The Aztec Treasure Slot | 10,804x Max Win | {brand}',
        description: 'Play John Hunter And The Aztec Treasure slot with Bitcoin at {brand}. Medium-High volatility, 10,804x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/john_hunter_and_the_book_of_tut': {
        title: 'John Hunter And The Book Of Tut Slot | 5,500x Max Win | {brand}',
        description: 'Play John Hunter And The Book Of Tut slot with Bitcoin at {brand}. Medium-High volatility, 5,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/john_hunter_and_the_book_of_tut_megaways': {
        title: 'John Hunter And The Book Of Tut Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play John Hunter And The Book Of Tut Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits.'
    },
    '/p/pragmatic-play/john_hunter_and_the_book_of_tut_respin': {
        title: 'John Hunter And The Book Of Tut Respin Slot | 4,000x Max Win | {brand}',
        description: 'Play John Hunter And The Book Of Tut Respin slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits.'
    },
    '/p/pragmatic-play/john_hunter_and_the_mayan_gods': {
        title: 'John Hunter And The Mayan Gods Slot | 500x Max Win | {brand}',
        description: 'Play John Hunter And The Mayan Gods slot with Bitcoin at {brand}. Medium-High volatility, 500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/john_hunter_and_the_quest_for_bermuda_riches': {
        title: 'John Hunter And The Quest For Bermuda Riches Slot | 5,000x Max Win | {brand}',
        description: 'Play John Hunter And The Quest For Bermuda Riches slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits.'
    },
    '/p/pragmatic-play/john_hunter_tomb_of_the_scarab_queen': {
        title: 'John Hunter Tomb Of The Scarab Queen Slot | 10,804x Max Win | {brand}',
        description: 'Play John Hunter Tomb Of The Scarab Queen slot with Bitcoin at {brand}. Medium-High volatility, 10,804x max win, Crypto deposits.'
    },
    '/p/pragmatic-play/joker_jewels_dice': {
        title: 'Joker Jewels Dice Slot | 1,040x Max Win | {brand}',
        description: 'Play Joker Jewels Dice slot with Bitcoin at {brand}. Medium-High volatility, 1,040x max win, dice variant. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/joker_king': {
        title: 'Joker King Slot | 5,000x Max Win | {brand}',
        description: 'Play Joker King slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/joker_race': {
        title: 'Joker Race Slot | Play Online | {brand}',
        description: 'Play Joker Race by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/jokers_jewel_hot': {
        title: "Joker's Jewel Hot Slot | 27,000x Max Win | {brand}",
        description: "Play Joker's Jewel Hot slot with Bitcoin at {brand}. Medium-High volatility, 27,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/jokers_jewels': {
        title: "Joker's Jewels Slot | 1,040x Max Win | {brand}",
        description: "Play Joker's Jewels slot with Bitcoin at {brand}. Medium volatility, 1,040x max win, no wild symbols. bonus. Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/jokers_jewels_cash': {
        title: "Joker's Jewels Cash Slot | 5,000x Max Win | {brand}",
        description: "Play Joker's Jewels Cash slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/jokers_jewels_hold_and_spin': {
        title: "Joker's Jewels Hold And Spin Slot | 10,000x Max Win | {brand}",
        description: "Play Joker's Jewels Hold And Spin slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, hold and spin. Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/jokers_jewels_wild': {
        title: "Joker's Jewels Wild Slot | 1,420x Max Win | {brand}",
        description: "Play Joker's Jewels Wild slot with Bitcoin at {brand}. Medium-High volatility, 1,420x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/journey_to_the_west': {
        title: 'Journey To The West Slot | 400x Max Win | {brand}',
        description: 'Play Journey To The West slot with Bitcoin at {brand}. Medium-High volatility, 400x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/juicy_fruits': {
        title: 'Juicy Fruits Slot | 5,000x Max Win | {brand}',
        description: 'Play Juicy Fruits slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/juicy_fruits_multihold': {
        title: 'Juicy Fruits Multihold Slot | 8,000x Max Win | {brand}',
        description: 'Play Juicy Fruits Multihold slot with Bitcoin at {brand}. Medium-High volatility, 8,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/jumbo_safari': {
        title: 'Jumbo Safari Slot | 3,000x Max Win | {brand}',
        description: 'Play Jumbo Safari slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/jungle_gorilla': {
        title: 'Jungle Gorilla Slot | 2,806x Max Win | {brand}',
        description: 'Play Jungle Gorilla slot with Bitcoin at {brand}. Medium-High volatility, 2,806x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/king_of_spear': {
        title: 'King Of Spear Slot | 5,000x Max Win | {brand}',
        description: 'Play King Of Spear slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/kingdom_of_asgard': {
        title: 'Kingdom Of Asgard Slot | 5,000x Max Win | {brand}',
        description: 'Play Kingdom Of Asgard slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/kingdom_of_atlantis_jackpot_play': {
        title: 'Kingdom Of Atlantis Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Kingdom Of Atlantis Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/kingdom_of_the_dead': {
        title: 'Kingdom Of The Dead Slot | 10,000x Max Win | {brand}',
        description: 'Play Kingdom Of The Dead slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/knight_hot_spotz': {
        title: 'Knight Hot Spotz Slot | 2,000x Max Win | {brand}',
        description: 'Play Knight Hot Spotz slot with Bitcoin at {brand}. Very High volatility, 2,000x max win, hot spotz multiplier upgrade. Crypto deposits.'
    },
    '/p/pragmatic-play/knights_vs_barbarians': {
        title: 'Knights Vs Barbarians Slot | 10,000x Max Win | {brand}',
        description: 'Play Knights Vs Barbarians slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/koi_pond': {
        title: 'Koi Pond Slot | 2,500x Max Win | {brand}',
        description: 'Play Koi Pond slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/krakens_sky_bounty': {
        title: "Kraken's Sky Bounty Slot | 5,000x Max Win | {brand}",
        description: "Play Kraken's Sky Bounty slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/lady_godiva': {
        title: 'Lady Godiva Slot | 2,400x Max Win | {brand}',
        description: 'Play Lady Godiva slot with Bitcoin at {brand}. Medium-High volatility, 2,400x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/lamp_of_infinity': {
        title: 'Lamp Of Infinity Slot | 5,000x Max Win | {brand}',
        description: 'Play Lamp Of Infinity slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/lava_balls': {
        title: 'Lava Balls Slot | 4,800x Max Win | {brand}',
        description: 'Play Lava Balls slot with Bitcoin at {brand}. Medium-High volatility, 4,800x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/legend_of_heroes_megaways': {
        title: 'Legend Of Heroes Megaways Slot | 1,250x Max Win | {brand}',
        description: 'Play Legend Of Heroes Megaways slot with Bitcoin at {brand}. High volatility, 1,250x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/leprechaun_carol': {
        title: 'Leprechaun Carol Slot | Play Online | {brand}',
        description: 'Play Leprechaun Carol by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/leprechaun_song': {
        title: 'Leprechaun Song Slot | Play Online | {brand}',
        description: 'Play Leprechaun Song by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/little_gem_hold_and_spin': {
        title: 'Little Gem Hold And Spin Slot | Pragmatic Play | {brand}',
        description: 'Play Little Gem Hold And Spin by Pragmatic Play at {brand}. Medium-High volatility, hold and spin. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/lobster_bobs_crazy_crab_shack': {
        title: 'Lobster Bobs Crazy Crab Shack Slot | 5,000x Max Win | {brand}',
        description: 'Play Lobster Bobs Crazy Crab Shack slot with Bitcoin at {brand}. High volatility, 5,000x max win, tumble. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/lobster_bobs_sea_food_and_win_it': {
        title: 'Lobster Bobs Sea Food And Win It Slot | Pragmatic Play | {brand}',
        description: 'Play Lobster Bobs Sea Food And Win It by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/lobster_house': {
        title: 'Lobster House Slot | 4,000x Max Win | {brand}',
        description: 'Play Lobster House slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/lokis_riches': {
        title: "Loki's Riches Slot | 10,000x Max Win | {brand}",
        description: "Play Loki's Riches slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/lucky_dragon_ball': {
        title: 'Lucky Dragon Ball Slot | 800x Max Win | {brand}',
        description: 'Play Lucky Dragon Ball slot with Bitcoin at {brand}. Medium-High volatility, 800x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/lucky_dragons': {
        title: 'Lucky Dragons Slot | 800x Max Win | {brand}',
        description: 'Play Lucky Dragons slot with Bitcoin at {brand}. Medium-High volatility, 800x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/lucky_fishing_megaways': {
        title: 'Lucky Fishing Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Lucky Fishing Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/lucky_grace_and_charm': {
        title: 'Lucky Grace And Charm Slot | Pragmatic Play | {brand}',
        description: 'Play Lucky Grace And Charm by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/lucky_lightning': {
        title: 'Lucky Lightning Slot | Play Online | {brand}',
        description: 'Play Lucky Lightning by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/lucky_new_year': {
        title: 'Lucky New Year Slot | Play Online | {brand}',
        description: 'Play Lucky New Year by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/lucky_new_year_tiger_treasures': {
        title: 'Lucky New Year Tiger Treasures Slot | Pragmatic Play | {brand}',
        description: 'Play Lucky New Year Tiger Treasures by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/luckys_wild_pub': {
        title: "Lucky's Wild Pub Slot | 10,000x Max Win | {brand}",
        description: "Play Lucky's Wild Pub slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/madame_destiny': {
        title: 'Madame Destiny Slot | Not specified Max Win | {brand}',
        description: 'Play Madame Destiny slot with Bitcoin at {brand}. Medium-High volatility, Not specified max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/madame_destiny_megaways': {
        title: 'Madame Destiny Megaways Slot | 625,000 (mentioned as $625K) Max Win | {brand}',
        description: 'Play Madame Destiny Megaways with crypto at {brand}. High volatility, 625,000 (mentioned as $625K) max win. BTC, ETH, USDT accepted.'
    },
    '/p/pragmatic-play/magic_journey': {
        title: 'Magic Journey Slot | 1,000x Max Win | {brand}',
        description: 'Play Magic Journey slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/magic_money_maze': {
        title: 'Magic Money Maze Slot | Play Online | {brand}',
        description: 'Play Magic Money Maze by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/magicians_secrets': {
        title: 'Magicians Secrets Slot | 5,000x Max Win | {brand}',
        description: 'Play Magicians Secrets slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mahjong_panda': {
        title: 'Mahjong Panda Slot | 5,000x Max Win | {brand}',
        description: 'Play Mahjong Panda slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mahjong_wins': {
        title: 'Mahjong Wins Slot | 5,000x Max Win | {brand}',
        description: 'Play Mahjong Wins slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mahjong_wins_bonus': {
        title: 'Mahjong Wins Bonus Slot | 1,000x Max Win | {brand}',
        description: 'Play Mahjong Wins Bonus slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mahjong_wins_super_scatter': {
        title: 'Mahjong Wins Super Scatter Slot | 100,000x Max Win | {brand}',
        description: 'Play Mahjong Wins Super Scatter slot with Bitcoin at {brand}. Medium-High volatility, 100,000x max win, super scatter. Crypto deposits.'
    },
    '/p/pragmatic-play/mahjong_x': {
        title: 'Mahjong X Slot | 21,175x Max Win | {brand}',
        description: 'Play Mahjong X slot with Bitcoin at {brand}. Medium-High volatility, 21,175x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/majestic_express_gold_run': {
        title: 'Majestic Express Gold Run Slot | 20,000x Max Win | {brand}',
        description: 'Play Majestic Express Gold Run slot with Bitcoin at {brand}. Medium-High volatility, 20,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mammoth_gold_megaways': {
        title: 'Mammoth Gold Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Mammoth Gold Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/master_chens_fortune': {
        title: 'Master Chens Fortune Slot | Pragmatic Play | {brand}',
        description: 'Play Master Chens Fortune by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/master_joker': {
        title: 'Master Joker Slot | 10,000x Max Win | {brand}',
        description: 'Play Master Joker slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/medusas_stone': {
        title: 'Medusas Stone Slot | 7,000x Max Win | {brand}',
        description: 'Play Medusas Stone slot with Bitcoin at {brand}. Medium-High volatility, 7,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mermaids_treasure_love': {
        title: 'Mermaids Treasure Love Slot | 10,000x Max Win | {brand}',
        description: 'Play Mermaids Treasure Love slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/might_of_freya_megaways': {
        title: 'Might Of Freya Megaways Slot | 8,000x Max Win | {brand}',
        description: 'Play Might Of Freya Megaways slot with Bitcoin at {brand}. High volatility, 8,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/might_of_ra': {
        title: 'Might Of Ra Slot | 22,500x Max Win | {brand}',
        description: 'Play Might Of Ra slot with Bitcoin at {brand}. Medium-High volatility, 22,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mighty_kong': {
        title: 'Mighty Kong Slot | 955x Max Win | {brand}',
        description: 'Play Mighty Kong slot with Bitcoin at {brand}. Medium-High volatility, 955x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mighty_munching_melons': {
        title: 'Mighty Munching Melons Slot | Pragmatic Play | {brand}',
        description: 'Play Mighty Munching Melons by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/mining_rush': {
        title: 'Mining Rush Slot | 10,000x Max Win | {brand}',
        description: 'Play Mining Rush slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mochimon': {
        title: 'Mochimon Slot | 5,000x Max Win | {brand}',
        description: 'Play Mochimon slot with Bitcoin at {brand}. High volatility, 5,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/moleionaire': {
        title: 'Moleionaire Slot | 5,000x Max Win | {brand}',
        description: 'Play Moleionaire slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/money_money_money': {
        title: 'Money Money Money Slot | 88x Max Win | {brand}',
        description: 'Play Money Money Money slot with Bitcoin at {brand}. Medium-High volatility, 88x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/money_mouse': {
        title: 'Money Mouse Slot | 2,500x Max Win | {brand}',
        description: 'Play Money Mouse slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/money_roll': {
        title: 'Money Roll Slot | 2,001x Max Win | {brand}',
        description: 'Play Money Roll slot with Bitcoin at {brand}. Medium-High volatility, 2,001x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/money_stacks': {
        title: 'Money Stacks Slot | 5,000x Max Win | {brand}',
        description: 'Play Money Stacks slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/money_stacks_megaways': {
        title: 'Money Stacks Megaways Slot | 1,000x Max Win | {brand}',
        description: 'Play Money Stacks Megaways slot with Bitcoin at {brand}. High volatility, 1,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/monkey_king_rush': {
        title: 'Monkey King Rush Slot | 5,000x Max Win | {brand}',
        description: 'Play Monkey King Rush slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/monkey_madness': {
        title: 'Monkey Madness Slot | 181x Max Win | {brand}',
        description: 'Play Monkey Madness slot with Bitcoin at {brand}. Medium-High volatility, 181x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/monkey_warrior': {
        title: 'Monkey Warrior Slot | 6,080x Max Win | {brand}',
        description: 'Play Monkey Warrior slot with Bitcoin at {brand}. Medium-High volatility, 6,080x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/monster_superlanche': {
        title: 'Monster Superlanche Slot | 5,000x Max Win | {brand}',
        description: 'Play Monster Superlanche slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/moonshot': {
        title: 'Moonshot Slot | Play Online | {brand}',
        description: 'Play Moonshot by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/muertos_multiplier_megaways': {
        title: 'Muertos Multiplier Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Muertos Multiplier Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/multihand_blackjack': {
        title: 'Multihand Blackjack Slot | Play Online | {brand}',
        description: 'Play Multihand Blackjack by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/mummys_jewels': {
        title: "Mummy's Jewels Slot | 10,000x Max Win | {brand}",
        description: "Play Mummy's Jewels slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/mummys_jewels_100': {
        title: "Mummy's Jewels 100 Slot | 30,000x Max Win | {brand}",
        description: "Play Mummy's Jewels 100 slot with Bitcoin at {brand}. Medium-High volatility, 30,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/mustang_gold': {
        title: 'Mustang Gold Slot | 12,000x Max Win | {brand}',
        description: 'Play Mustang Gold slot with Bitcoin at {brand}. Medium-High volatility, 12,000x max win, money collect feature: when. Crypto deposits.'
    },
    '/p/pragmatic-play/mustang_gold_megaways': {
        title: 'Mustang Gold Megaways Slot | Higher than classic version Max Win | {brand}',
        description: 'Play Mustang Gold Megaways with crypto at {brand}. Very High volatility, Higher than classic version max win. BTC, ETH, USDT accepted.'
    },
    '/p/pragmatic-play/mustang_trail': {
        title: 'Mustang Trail Slot | 5,000x Max Win | {brand}',
        description: 'Play Mustang Trail slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mysterious': {
        title: 'Mysterious Slot | 9,648x Max Win | {brand}',
        description: 'Play Mysterious slot with Bitcoin at {brand}. Medium-High volatility, 9,648x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mysterious_egypt': {
        title: 'Mysterious Egypt Slot | 5,533x Max Win | {brand}',
        description: 'Play Mysterious Egypt slot with Bitcoin at {brand}. Very High volatility, 5,533x max win, mystery symbol mechanic: one. Crypto deposits.'
    },
    '/p/pragmatic-play/mystery_mice': {
        title: 'Mystery Mice Slot | 5,000x Max Win | {brand}',
        description: 'Play Mystery Mice slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/mystic_chief': {
        title: 'Mystic Chief Slot | 5,000x Max Win | {brand}',
        description: 'Play Mystic Chief slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/nile_fortune': {
        title: 'Nile Fortune Slot | 2,500x Max Win | {brand}',
        description: 'Play Nile Fortune slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, mystery modifiers on reels. Crypto deposits.'
    },
    '/p/pragmatic-play/north_guardians': {
        title: 'North Guardians Slot | 5,000x Max Win | {brand}',
        description: 'Play North Guardians slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/octobeer_fortunes': {
        title: 'Octobeer Fortunes Slot | 4,500x Max Win | {brand}',
        description: 'Play Octobeer Fortunes slot with Bitcoin at {brand}. Medium-High volatility, 4,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/old_gold_miner_megaways': {
        title: 'Old Gold Miner Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Old Gold Miner Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/oodles_of_noodles': {
        title: 'Oodles Of Noodles Slot | Play Online | {brand}',
        description: 'Play Oodles Of Noodles by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees.'
    },
    '/p/pragmatic-play/oracle_of_gold': {
        title: 'Oracle Of Gold Slot | 10,000x Max Win | {brand}',
        description: 'Play Oracle Of Gold slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pandas_fortune': {
        title: 'Pandas Fortune Slot | 7,272x Max Win | {brand}',
        description: 'Play Pandas Fortune slot with Bitcoin at {brand}. Medium-High volatility, 7,272x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pandas_fortune_2': {
        title: 'Pandas Fortune 2 Slot | 5,000x Max Win | {brand}',
        description: 'Play Pandas Fortune 2 slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pandemic_rising': {
        title: 'Pandemic Rising Slot | 14,000x Max Win | {brand}',
        description: 'Play Pandemic Rising slot with Bitcoin at {brand}. Medium-High volatility, 14,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/peking_luck': {
        title: 'Peking Luck Slot | 180,000x Max Win | {brand}',
        description: 'Play Peking Luck slot with Bitcoin at {brand}. Medium-High volatility, 180,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/penguins_christmas_party_time': {
        title: 'Penguins Christmas Party Time Slot | Pragmatic Play | {brand}',
        description: 'Play Penguins Christmas Party Time by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/peppes_pepperoni_pizza_plaza': {
        title: "Peppe's Pepperoni Pizza Plaza Slot | Pragmatic Play | {brand}",
        description: "Play Peppe's Pepperoni Pizza Plaza by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more."
    },
    '/p/pragmatic-play/phoenix_forge': {
        title: 'Phoenix Forge Slot | 5,000x Max Win | {brand}',
        description: 'Play Phoenix Forge slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/piggy_bank_bills': {
        title: 'Piggy Bank Bills Slot | 5,000x Max Win | {brand}',
        description: 'Play Piggy Bank Bills slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/piggy_bankers': {
        title: 'Piggy Bankers Slot | 10,000x Max Win | {brand}',
        description: 'Play Piggy Bankers slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pinup_girls': {
        title: 'Pinup Girls Slot | 3,000x Max Win | {brand}',
        description: 'Play Pinup Girls slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pirate_gold': {
        title: 'Pirate Gold Slot | 32,270x Max Win | {brand}',
        description: 'Play Pirate Gold slot with Bitcoin at {brand}. High volatility, 32,270x max win, lucky treasure bag feature:. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pirate_gold_deluxe': {
        title: 'Pirate Gold Deluxe Slot | 15,000x Max Win | {brand}',
        description: 'Play Pirate Gold Deluxe slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pirate_golden_age': {
        title: 'Pirate Golden Age Slot | 3,000x Max Win | {brand}',
        description: 'Play Pirate Golden Age slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pirates_pub': {
        title: 'Pirates Pub Slot | 5,000x Max Win | {brand}',
        description: 'Play Pirates Pub slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pixie_wings': {
        title: 'Pixie Wings Slot | 500x Max Win | {brand}',
        description: 'Play Pixie Wings slot with Bitcoin at {brand}. Medium-High volatility, 500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pizza_pizza_pizza': {
        title: 'Pizza Pizza Pizza Slot | Play Online | {brand}',
        description: 'Play Pizza Pizza Pizza by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees.'
    },
    '/p/pragmatic-play/pompeii_megareels_megaways': {
        title: 'Pompeii Megareels Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Pompeii Megareels Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pot_of_fortune': {
        title: 'Pot Of Fortune Slot | 5,000x Max Win | {brand}',
        description: 'Play Pot Of Fortune slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/power_ball_1_min': {
        title: 'Power Ball 1 Min Slot | Play Online | {brand}',
        description: 'Play Power Ball 1 Min by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/power_ball_2_min': {
        title: 'Power Ball 2 Min Slot | Play Online | {brand}',
        description: 'Play Power Ball 2 Min by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/power_ball_3_min': {
        title: 'Power Ball 3 Min Slot | Play Online | {brand}',
        description: 'Play Power Ball 3 Min by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/power_ball_4_min': {
        title: 'Power Ball 4 Min Slot | Play Online | {brand}',
        description: 'Play Power Ball 4 Min by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/power_ball_5_min': {
        title: 'Power Ball 5 Min Slot | Play Online | {brand}',
        description: 'Play Power Ball 5 Min by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/power_of_merlin_megaways': {
        title: 'Power Of Merlin Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Power Of Merlin Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/power_of_ninja': {
        title: 'Power Of Ninja Slot | 5,000x Max Win | {brand}',
        description: 'Play Power Of Ninja slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/power_of_thor_megaways': {
        title: 'Power Of Thor Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Power Of Thor Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, cascading reels (tumble) removes. Crypto deposits.'
    },
    '/p/pragmatic-play/pub_kings': {
        title: 'Pub Kings Slot | 5,000x Max Win | {brand}',
        description: 'Play Pub Kings slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pyramid_bonanza': {
        title: 'Pyramid Bonanza Slot | 21,175x Max Win | {brand}',
        description: 'Play Pyramid Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 21,175x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/pyramid_king': {
        title: 'Pyramid King Slot | 2,500x Max Win | {brand}',
        description: 'Play Pyramid King slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/queen_of_gods': {
        title: 'Queen Of Gods Slot | 1,839x Max Win | {brand}',
        description: 'Play Queen Of Gods slot with Bitcoin at {brand}. Medium-High volatility, 1,839x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/queenie': {
        title: 'Queenie Slot | Play Online | {brand}',
        description: 'Play Queenie by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/raging_bull': {
        title: 'Raging Bull Slot | 7,342x Max Win | {brand}',
        description: 'Play Raging Bull slot with Bitcoin at {brand}. Medium-High volatility, 7,342x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/raging_waterfall_megaways': {
        title: 'Raging Waterfall Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Raging Waterfall Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rainbow_gold': {
        title: 'Rainbow Gold Slot | 5,000x Max Win | {brand}',
        description: 'Play Rainbow Gold slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rainbow_reels': {
        title: 'Rainbow Reels Slot | 5,000x Max Win | {brand}',
        description: 'Play Rainbow Reels slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/reel_banks': {
        title: 'Reel Banks Slot | 5,000x Max Win | {brand}',
        description: 'Play Reel Banks slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/release_the_bison': {
        title: 'Release The Bison Slot | 3,000x Max Win | {brand}',
        description: 'Play Release The Bison slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/release_the_kraken': {
        title: 'Release The Kraken Slot | 10,000x Max Win | {brand}',
        description: 'Play Release The Kraken slot with Bitcoin at {brand}. High volatility, 10,000x max win, random base game features trigger. Crypto deposits.'
    },
    '/p/pragmatic-play/release_the_kraken_2': {
        title: 'Release The Kraken 2 Slot | 5,000x Max Win | {brand}',
        description: 'Play Release The Kraken 2 slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/release_the_kraken_megaways': {
        title: 'Release The Kraken Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Release The Kraken Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/resurrecting_riches': {
        title: 'Resurrecting Riches Slot | 4,000x Max Win | {brand}',
        description: 'Play Resurrecting Riches slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/return_of_the_dead': {
        title: 'Return Of The Dead Slot | Play Online | {brand}',
        description: 'Play Return Of The Dead by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees.'
    },
    '/p/pragmatic-play/revenge_of_loki_megaways': {
        title: 'Revenge Of Loki Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Revenge Of Loki Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/ride_the_lightning': {
        title: 'Ride The Lightning Slot | 10,000x Max Win | {brand}',
        description: 'Play Ride The Lightning slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/ripe_rewards': {
        title: 'Ripe Rewards Slot | 10,000x Max Win | {brand}',
        description: 'Play Ripe Rewards slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rise_of_giza_powernudge': {
        title: 'Rise Of Giza Powernudge Slot | 4,000x Max Win | {brand}',
        description: 'Play Rise Of Giza Powernudge slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, powernudge. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rise_of_pyramids': {
        title: 'Rise Of Pyramids Slot | 5,000x Max Win | {brand}',
        description: 'Play Rise Of Pyramids slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rise_of_samurai': {
        title: 'Rise Of Samurai Slot | 15,000x Max Win | {brand}',
        description: 'Play Rise Of Samurai slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rise_of_samurai_4': {
        title: 'Rise Of Samurai 4 Slot | 15,000x Max Win | {brand}',
        description: 'Play Rise Of Samurai 4 slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rise_of_samurai_iii': {
        title: 'Rise Of Samurai Iii Slot | 15,000x Max Win | {brand}',
        description: 'Play Rise Of Samurai Iii slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rise_of_samurai_megaways': {
        title: 'Rise Of Samurai Megaways Slot | Pragmatic Play | {brand}',
        description: 'Play Rise Of Samurai Megaways by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/robber_strike': {
        title: 'Robber Strike Slot | 5,000x Max Win | {brand}',
        description: 'Play Robber Strike slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rock_vegas': {
        title: 'Rock Vegas Slot | Play Online | {brand}',
        description: 'Play Rock Vegas by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/rocket_blast_megaways': {
        title: 'Rocket Blast Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Rocket Blast Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rolling_in_treasures': {
        title: 'Rolling In Treasures Slot | 5,000x Max Win | {brand}',
        description: 'Play Rolling In Treasures slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/rujak_bonanza': {
        title: 'Rujak Bonanza Slot | 21,175x Max Win | {brand}',
        description: 'Play Rujak Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 21,175x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/running_sushi': {
        title: 'Running Sushi Slot | 3,000x Max Win | {brand}',
        description: 'Play Running Sushi slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/safari_king': {
        title: 'Safari King Slot | 868x Max Win | {brand}',
        description: 'Play Safari King slot with Bitcoin at {brand}. Medium-High volatility, 868x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/saiyan_mania': {
        title: 'Saiyan Mania Slot | 5,000x Max Win | {brand}',
        description: 'Play Saiyan Mania slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/samurai_code': {
        title: 'Samurai Code Slot | Play Online | {brand}',
        description: 'Play Samurai Code by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/santa': {
        title: 'Santa Slot | 2,000x Max Win | {brand}',
        description: 'Play Santa slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, Crypto deposits, instant withdrawals No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/santas_great_gifts': {
        title: "Santa's Great Gifts Slot | Play Online | {brand}",
        description: "Play Santa's Great Gifts by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more."
    },
    '/p/pragmatic-play/santas_slay': {
        title: "Santa's Slay Slot | 2,000x Max Win | {brand}",
        description: "Play Santa's Slay slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/santas_wonderland': {
        title: "Santa's Wonderland Slot | Play Online | {brand}",
        description: "Play Santa's Wonderland by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts, play on"
    },
    '/p/pragmatic-play/santas_xmas_rush': {
        title: "Santa's Xmas Rush Slot | 10,000x Max Win | {brand}",
        description: "Play Santa's Xmas Rush slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/savannah_legend': {
        title: 'Savannah Legend Slot | 10,000x Max Win | {brand}',
        description: 'Play Savannah Legend slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sea_fantasy': {
        title: 'Sea Fantasy Slot | 5,000x Max Win | {brand}',
        description: 'Play Sea Fantasy slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/secret_city_gold': {
        title: 'Secret City Gold Slot | 10,000x Max Win | {brand}',
        description: 'Play Secret City Gold slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/shield_of_sparta': {
        title: 'Shield Of Sparta Slot | 3,000x Max Win | {brand}',
        description: 'Play Shield Of Sparta slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/shining_hot_100': {
        title: 'Shining Hot 100 Slot | 2,500x Max Win | {brand}',
        description: 'Play Shining Hot 100 slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/shining_hot_100_jackpot_play': {
        title: 'Shining Hot 100 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Shining Hot 100 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/shining_hot_20': {
        title: 'Shining Hot 20 Slot | 2,500x Max Win | {brand}',
        description: 'Play Shining Hot 20 slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/shining_hot_20_jackpot_play': {
        title: 'Shining Hot 20 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Shining Hot 20 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/shining_hot_40': {
        title: 'Shining Hot 40 Slot | 2,500x Max Win | {brand}',
        description: 'Play Shining Hot 40 slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/shining_hot_40_jackpot_play': {
        title: 'Shining Hot 40 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Shining Hot 40 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/shining_hot_5': {
        title: 'Shining Hot 5 Slot | 2,500x Max Win | {brand}',
        description: 'Play Shining Hot 5 slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/shining_hot_5_jackpot_play': {
        title: 'Shining Hot 5 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Shining Hot 5 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/sleeping_dragon': {
        title: 'Sleeping Dragon Slot | 15,000x Max Win | {brand}',
        description: 'Play Sleeping Dragon slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/smugglers_cove': {
        title: 'Smugglers Cove Slot | 10,000x Max Win | {brand}',
        description: 'Play Smugglers Cove slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/snakes_and_ladders_megadice': {
        title: 'Snakes And Ladders Megadice Slot | Pragmatic Play | {brand}',
        description: 'Play Snakes And Ladders Megadice by Pragmatic Play at {brand}. Medium-High volatility, dice variant. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/snakes_and_ladders_snake_eyes': {
        title: 'Snakes And Ladders Snake Eyes Slot | Pragmatic Play | {brand}',
        description: 'Play Snakes And Ladders Snake Eyes by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/spartan_king': {
        title: 'Spartan King Slot | 7,494x Max Win | {brand}',
        description: 'Play Spartan King slot with Bitcoin at {brand}. Medium-High volatility, 7,494x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/spellbinding_mystery': {
        title: 'Spellbinding Mystery Slot | Pragmatic Play | {brand}',
        description: 'Play Spellbinding Mystery by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/spellmaster': {
        title: 'Spellmaster Slot | 40,000x Max Win | {brand}',
        description: 'Play Spellmaster slot with Bitcoin at {brand}. Medium-High volatility, 40,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/spin_and_score_megaways': {
        title: 'Spin And Score Megaways Slot | 5,000x Max Win | {brand}',
        description: 'Play Spin And Score Megaways slot with Bitcoin at {brand}. High volatility, 5,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/spirit_of_adventure': {
        title: 'Spirit Of Adventure Slot | Play Online | {brand}',
        description: 'Play Spirit Of Adventure by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/star_bounty': {
        title: 'Star Bounty Slot | 25,920x Max Win | {brand}',
        description: 'Play Star Bounty slot with Bitcoin at {brand}. Medium-High volatility, 25,920x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/star_pirates_code': {
        title: 'Star Pirates Code Slot | Play Online | {brand}',
        description: 'Play Star Pirates Code by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees.'
    },
    '/p/pragmatic-play/starlight_archer_1000': {
        title: 'Starlight Archer 1000 Slot | 15,000x Max Win | {brand}',
        description: 'Play Starlight Archer 1000 slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, 1000x multiplier. Crypto deposits.'
    },
    '/p/pragmatic-play/starlight_christmas': {
        title: 'Starlight Christmas Slot | Play Online | {brand}',
        description: 'Play Starlight Christmas by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/starlight_princess': {
        title: 'Starlight Princess Slot | 5,000x Max Win | {brand}',
        description: 'Play Starlight Princess slot with Bitcoin at {brand}. High volatility, 5,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/starlight_princess_1000': {
        title: 'Starlight Princess 1000 Slot | 15,000x Max Win | {brand}',
        description: 'Play Starlight Princess 1000 slot with Bitcoin at {brand}. Very High volatility, 15,000x max win, tumble feature. Crypto deposits.'
    },
    '/p/pragmatic-play/starlight_princess_pachi': {
        title: 'Starlight Princess Pachi Slot | 500x Max Win | {brand}',
        description: 'Play Starlight Princess Pachi slot with Bitcoin at {brand}. Medium-High volatility, 500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/starlight_princess_super_scatter': {
        title: 'Starlight Princess Super Scatter Slot | 50,000x Max Win | {brand}',
        description: 'Play Starlight Princess Super Scatter slot with Bitcoin at {brand}. Medium-High volatility, 50,000x max win, super scatter. Crypto deposits.'
    },
    '/p/pragmatic-play/starz_megaways': {
        title: 'Starz Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Starz Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sticky_bees': {
        title: 'Sticky Bees Slot | Play Online | {brand}',
        description: 'Play Sticky Bees by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/strawberry_cocktail': {
        title: 'Strawberry Cocktail Slot | 16,000x Max Win | {brand}',
        description: 'Play Strawberry Cocktail slot with Bitcoin at {brand}. Medium-High volatility, 16,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/street_racer': {
        title: 'Street Racer Slot | 2,000x Max Win | {brand}',
        description: 'Play Street Racer slot with Bitcoin at {brand}. Medium-High volatility, 2,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/striking_hot_5': {
        title: 'Striking Hot 5 Slot | 5,000x Max Win | {brand}',
        description: 'Play Striking Hot 5 slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/striking_hot_5_jackpot_play': {
        title: 'Striking Hot 5 Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Striking Hot 5 Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/sugar_rush': {
        title: 'Sugar Rush Slot | 5,000x Max Win | {brand}',
        description: 'Play Sugar Rush slot with Bitcoin at {brand}. High volatility, 5,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sugar_rush_1000': {
        title: 'Sugar Rush 1000 Slot | Higher than original Max Win | {brand}',
        description: 'Play Sugar Rush 1000 slot with Bitcoin at {brand}. Very High volatility, Higher than original max win, tumble feature. Crypto deposits.'
    },
    '/p/pragmatic-play/sugar_rush_super_scatter': {
        title: 'Sugar Rush Super Scatter Slot | 50,000x Max Win | {brand}',
        description: 'Play Sugar Rush Super Scatter slot with Bitcoin at {brand}. Medium-High volatility, 50,000x max win, super scatter. Crypto deposits.'
    },
    '/p/pragmatic-play/sugar_rush_xmas': {
        title: 'Sugar Rush Xmas Slot | 5,000x Max Win | {brand}',
        description: 'Play Sugar Rush Xmas slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sugar_supreme_powernudge': {
        title: 'Sugar Supreme Powernudge Slot | 5,000x Max Win | {brand}',
        description: 'Play Sugar Supreme Powernudge slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, powernudge. Crypto deposits.'
    },
    '/p/pragmatic-play/sumo_supreme_megaways': {
        title: 'Sumo Supreme Megaways Slot | 12,500x Max Win | {brand}',
        description: 'Play Sumo Supreme Megaways slot with Bitcoin at {brand}. High volatility, 12,500x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/super_7s': {
        title: 'Super 7s Slot | 1,000x Max Win | {brand}',
        description: 'Play Super 7s slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/super_joker': {
        title: 'Super Joker Slot | 1,500x Max Win | {brand}',
        description: 'Play Super Joker slot with Bitcoin at {brand}. Medium-High volatility, 1,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/super_tiki_strike': {
        title: 'Super Tiki Strike Slot | 50,000x Max Win | {brand}',
        description: 'Play Super Tiki Strike slot with Bitcoin at {brand}. Medium-High volatility, 50,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/super_x': {
        title: 'Super X Slot | 9,000x Max Win | {brand}',
        description: 'Play Super X slot with Bitcoin at {brand}. Medium-High volatility, 9,000x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/supermania': {
        title: 'Supermania Slot | 5,000x Max Win | {brand}',
        description: 'Play Supermania slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sweet_bonanza': {
        title: 'Sweet Bonanza Slot | 21,175x Max Win | {brand}',
        description: 'Play Sweet Bonanza slot with Bitcoin at {brand}. High volatility, 21,175x max win, tumble/cascade mechanic. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sweet_bonanza_1000': {
        title: 'Sweet Bonanza 1000 Slot | 25,000x Max Win | {brand}',
        description: 'Play Sweet Bonanza 1000 slot with Bitcoin at {brand}. High volatility, 25,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sweet_bonanza_dice': {
        title: 'Sweet Bonanza Dice Slot | 21,175x Max Win | {brand}',
        description: 'Play Sweet Bonanza Dice slot with Bitcoin at {brand}. Medium-High volatility, 21,175x max win, dice variant. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sweet_bonanza_super_scatter': {
        title: 'Sweet Bonanza Super Scatter Slot | 50,000x Max Win | {brand}',
        description: 'Play Sweet Bonanza Super Scatter slot with Bitcoin at {brand}. Medium-High volatility, 50,000x max win, super scatter. Crypto deposits.'
    },
    '/p/pragmatic-play/sweet_bonanza_xmas': {
        title: 'Sweet Bonanza Xmas Slot | 25,000x Max Win | {brand}',
        description: 'Play Sweet Bonanza Xmas slot with Bitcoin at {brand}. Medium-High volatility, 25,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sweet_craze': {
        title: 'Sweet Craze Slot | 10,000x Max Win | {brand}',
        description: 'Play Sweet Craze slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sweet_kingdom': {
        title: 'Sweet Kingdom Slot | 10,000x Max Win | {brand}',
        description: 'Play Sweet Kingdom slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sweet_powernudge': {
        title: 'Sweet Powernudge Slot | 5,000x Max Win | {brand}',
        description: 'Play Sweet Powernudge slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, powernudge. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sweet_rush_bonanza': {
        title: 'Sweet Rush Bonanza Slot | 5,000x Max Win | {brand}',
        description: 'Play Sweet Rush Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/sword_of_ares': {
        title: 'Sword Of Ares Slot | 10,000x Max Win | {brand}',
        description: 'Play Sword Of Ares slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/temple_guardians': {
        title: 'Temple Guardians Slot | 10,000x Max Win | {brand}',
        description: 'Play Temple Guardians slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/temujin_treasures': {
        title: 'Temujin Treasures Slot | 9,000x Max Win | {brand}',
        description: 'Play Temujin Treasures slot with Bitcoin at {brand}. Medium-High volatility, 9,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_alter_ego': {
        title: 'The Alter Ego Slot | 10,000x Max Win | {brand}',
        description: 'Play The Alter Ego slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_amazing_money_machine': {
        title: 'The Amazing Money Machine Slot | 5,100x Max Win | {brand}',
        description: 'Play The Amazing Money Machine slot with Bitcoin at {brand}. Medium-High volatility, 5,100x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_big_dawgs': {
        title: 'The Big Dawgs Slot | 5,000x Max Win | {brand}',
        description: 'Play The Big Dawgs slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_dog_house': {
        title: 'The Dog House Slot | Not specified Max Win | {brand}',
        description: 'Play The Dog House slot with Bitcoin at {brand}. High volatility, Not specified max win, traditional reels. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_dog_house_dice_show': {
        title: 'The Dog House Dice Show Slot | 6,750x Max Win | {brand}',
        description: 'Play The Dog House Dice Show slot with Bitcoin at {brand}. Medium-High volatility, 6,750x max win, dice variant. Crypto deposits.'
    },
    '/p/pragmatic-play/the_dog_house_dog_or_alive': {
        title: 'The Dog House Dog Or Alive Slot | 10,000x Max Win | {brand}',
        description: 'Play The Dog House Dog Or Alive slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_dog_house_megaways': {
        title: 'The Dog House Megaways Slot | 12,305x Max Win | {brand}',
        description: 'Play The Dog House Megaways slot with Bitcoin at {brand}. High volatility, 12,305x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_dog_house_muttley_crew': {
        title: 'The Dog House Muttley Crew Slot | 7,500x Max Win | {brand}',
        description: 'Play The Dog House Muttley Crew slot with Bitcoin at {brand}. Medium-High volatility, 7,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_dog_house_royal_hunt': {
        title: 'The Dog House Royal Hunt Slot | 8,000x Max Win | {brand}',
        description: 'Play The Dog House Royal Hunt slot with Bitcoin at {brand}. Medium-High volatility, 8,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_dragon_tiger': {
        title: 'The Dragon Tiger Slot | 18,125x Max Win | {brand}',
        description: 'Play The Dragon Tiger slot with Bitcoin at {brand}. Medium-High volatility, 18,125x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_great_chicken_escape': {
        title: 'The Great Chicken Escape Slot | 5,500x Max Win | {brand}',
        description: 'Play The Great Chicken Escape slot with Bitcoin at {brand}. Medium-High volatility, 5,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_great_stickup': {
        title: 'The Great Stickup Slot | 5,000x Max Win | {brand}',
        description: 'Play The Great Stickup slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_hand_of_midas': {
        title: 'The Hand Of Midas Slot | 5,000x Max Win | {brand}',
        description: 'Play The Hand Of Midas slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, sticky wilds with multipliers. Crypto deposits.'
    },
    '/p/pragmatic-play/the_magic_cauldron_enchanted_brew': {
        title: 'The Magic Cauldron Enchanted Brew Slot | Pragmatic Play | {brand}',
        description: 'Play The Magic Cauldron Enchanted Brew by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/the_money_men_megaways': {
        title: 'The Money Men Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play The Money Men Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_tiger_warrior': {
        title: 'The Tiger Warrior Slot | 2,500x Max Win | {brand}',
        description: 'Play The Tiger Warrior slot with Bitcoin at {brand}. Medium-High volatility, 2,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_tweety_house': {
        title: 'The Tweety House Slot | 6,750x Max Win | {brand}',
        description: 'Play The Tweety House slot with Bitcoin at {brand}. Medium-High volatility, 6,750x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_ultimate_5': {
        title: 'The Ultimate 5 Slot | 5,000x Max Win | {brand}',
        description: 'Play The Ultimate 5 slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_wild_gang': {
        title: 'The Wild Gang Slot | 10,000x Max Win | {brand}',
        description: 'Play The Wild Gang slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/the_wild_machine': {
        title: 'The Wild Machine Slot | 7,000x Max Win | {brand}',
        description: 'Play The Wild Machine slot with Bitcoin at {brand}. Medium-High volatility, 7,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/three_star_fortune': {
        title: 'Three Star Fortune Slot | 500x Max Win | {brand}',
        description: 'Play Three Star Fortune slot with Bitcoin at {brand}. Medium-High volatility, 500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/tic_tac_take': {
        title: 'Tic Tac Take Slot | Play Online | {brand}',
        description: 'Play Tic Tac Take by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/tiki_hut_megaways_jackpot_play': {
        title: 'Tiki Hut Megaways Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Tiki Hut Megaways Jackpot Play by Pragmatic Play at {brand}. High volatility, megaways. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/timber_stacks': {
        title: 'Timber Stacks Slot | 10,000x Max Win | {brand}',
        description: 'Play Timber Stacks slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/tiny_toads': {
        title: 'Tiny Toads Slot | 4,000x Max Win | {brand}',
        description: 'Play Tiny Toads slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/towering_fortunes': {
        title: 'Towering Fortunes Slot | 6,422x Max Win | {brand}',
        description: 'Play Towering Fortunes slot with Bitcoin at {brand}. Medium-High volatility, 6,422x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/treasure_horse': {
        title: 'Treasure Horse Slot | 6,000x Max Win | {brand}',
        description: 'Play Treasure Horse slot with Bitcoin at {brand}. Medium-High volatility, 6,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/treasure_wild': {
        title: 'Treasure Wild Slot | 10,000x Max Win | {brand}',
        description: 'Play Treasure Wild slot with Bitcoin at {brand}. High volatility, 10,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/treasures_of_osiris': {
        title: 'Treasures Of Osiris Slot | 10,000x Max Win | {brand}',
        description: 'Play Treasures Of Osiris slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/tree_of_riches': {
        title: 'Tree Of Riches Slot | 2,880x Max Win | {brand}',
        description: 'Play Tree Of Riches slot with Bitcoin at {brand}. Medium-High volatility, 2,880x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/trees_of_treasure': {
        title: 'Trees Of Treasure Slot | 15,000x Max Win | {brand}',
        description: 'Play Trees Of Treasure slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/triple_dragons': {
        title: 'Triple Dragons Slot | 1,000x Max Win | {brand}',
        description: 'Play Triple Dragons slot with Bitcoin at {brand}. Medium-High volatility, 1,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/triple_pot_diamond': {
        title: 'Triple Pot Diamond Slot | 10,000x Max Win | {brand}',
        description: 'Play Triple Pot Diamond slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/triple_pot_god': {
        title: 'Triple Pot God Slot | 5,000x Max Win | {brand}',
        description: 'Play Triple Pot God slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/triple_pot_gold': {
        title: 'Triple Pot Gold Slot | 5,000x Max Win | {brand}',
        description: 'Play Triple Pot Gold slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/triple_tigers': {
        title: 'Triple Tigers Slot | 500x Max Win | {brand}',
        description: 'Play Triple Tigers slot with Bitcoin at {brand}. Medium-High volatility, 500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/tropical_pop_jackpot_play': {
        title: 'Tropical Pop Jackpot Play Slot | Pragmatic Play | {brand}',
        description: 'Play Tropical Pop Jackpot Play by Pragmatic Play at {brand}. Medium volatility, jackpot play. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/tropical_tiki': {
        title: 'Tropical Tiki Slot | 3,000x Max Win | {brand}',
        description: 'Play Tropical Tiki slot with Bitcoin at {brand}. Medium-High volatility, 3,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/tundras_fortune': {
        title: 'Tundras Fortune Slot | 12,500x Max Win | {brand}',
        description: 'Play Tundras Fortune slot with Bitcoin at {brand}. Medium-High volatility, 12,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/twilight_princess': {
        title: 'Twilight Princess Slot | 7,500x Max Win | {brand}',
        description: 'Play Twilight Princess slot with Bitcoin at {brand}. Medium-High volatility, 7,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/ultra_burn': {
        title: 'Ultra Burn Slot | Play Online | {brand}',
        description: 'Play Ultra Burn by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/ultra_hold_and_spin': {
        title: 'Ultra Hold And Spin Slot | Play Online | {brand}',
        description: 'Play Ultra Hold And Spin by Pragmatic Play at {brand}. Medium-High volatility, hold and spin. Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/vampires_vs_wolves': {
        title: 'Vampires Vs Wolves Slot | Play Online | {brand}',
        description: 'Play Vampires Vs Wolves by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees.'
    },
    '/p/pragmatic-play/vampy_party': {
        title: 'Vampy Party Slot | 5,000x Max Win | {brand}',
        description: 'Play Vampy Party slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/vegas_magic': {
        title: 'Vegas Magic Slot | 3,549x Max Win | {brand}',
        description: 'Play Vegas Magic slot with Bitcoin at {brand}. Medium-High volatility, 3,549x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/vegas_nights': {
        title: 'Vegas Nights Slot | 3,558x Max Win | {brand}',
        description: 'Play Vegas Nights slot with Bitcoin at {brand}. Medium-High volatility, 3,558x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/viking_forge': {
        title: 'Viking Forge Slot | 10,000x Max Win | {brand}',
        description: 'Play Viking Forge slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/volcano_goddess': {
        title: 'Volcano Goddess Slot | 20,000x Max Win | {brand}',
        description: 'Play Volcano Goddess slot with Bitcoin at {brand}. Medium-High volatility, 20,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/voodoo_magic': {
        title: 'Voodoo Magic Slot | Play Online | {brand}',
        description: 'Play Voodoo Magic by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/waves_of_poseidon': {
        title: 'Waves Of Poseidon Slot | 5,000x Max Win | {brand}',
        description: 'Play Waves Of Poseidon slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wheel_o_gold': {
        title: 'Wheel O Gold Slot | 10,000x Max Win | {brand}',
        description: 'Play Wheel O Gold slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wheel_of_happiness': {
        title: 'Wheel Of Happiness Slot | 4,000x Max Win | {brand}',
        description: 'Play Wheel Of Happiness slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wheel_ogold': {
        title: "Wheel O'Gold Slot | 10,000x Max Win | {brand}",
        description: "Play Wheel O'Gold slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals."
    },
    '/p/pragmatic-play/wild_beach_party': {
        title: 'Wild Beach Party Slot | Play Online | {brand}',
        description: 'Play Wild Beach Party by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/wild_bison_charge': {
        title: 'Wild Bison Charge Slot | Play Online | {brand}',
        description: 'Play Wild Bison Charge by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees.'
    },
    '/p/pragmatic-play/wild_booster': {
        title: 'Wild Booster Slot | 5,000x Max Win | {brand}',
        description: 'Play Wild Booster slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_celebrity_bus_megaways': {
        title: 'Wild Celebrity Bus Megaways Slot | 4,000x Max Win | {brand}',
        description: 'Play Wild Celebrity Bus Megaways slot with Bitcoin at {brand}. High volatility, 4,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_depths': {
        title: 'Wild Depths Slot | 5,000x Max Win | {brand}',
        description: 'Play Wild Depths slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_gladiators': {
        title: 'Wild Gladiators Slot | 4,000x Max Win | {brand}',
        description: 'Play Wild Gladiators slot with Bitcoin at {brand}. Medium-High volatility, 4,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_hop_and_drop': {
        title: 'Wild Hop And Drop Slot | 5,000x Max Win | {brand}',
        description: 'Play Wild Hop And Drop slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_pixies': {
        title: 'Wild Pixies Slot | 261x Max Win | {brand}',
        description: 'Play Wild Pixies slot with Bitcoin at {brand}. Medium-High volatility, 261x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_skullz': {
        title: 'Wild Skullz Slot | 10,000x Max Win | {brand}',
        description: 'Play Wild Skullz slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_spells': {
        title: 'Wild Spells Slot | 1,450x Max Win | {brand}',
        description: 'Play Wild Spells slot with Bitcoin at {brand}. Medium-High volatility, 1,450x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_walker': {
        title: 'Wild Walker Slot | Play Online | {brand}',
        description: 'Play Wild Walker by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/wild_west_gold': {
        title: 'Wild West Gold Slot | 10,000x Max Win | {brand}',
        description: 'Play Wild West Gold slot with Bitcoin at {brand}. High volatility, 10,000x max win, wild multipliers on reels 2. Crypto deposits.'
    },
    '/p/pragmatic-play/wild_west_gold_blazing_bounty': {
        title: 'Wild West Gold Blazing Bounty Slot | 7,500x Max Win | {brand}',
        description: 'Play Wild West Gold Blazing Bounty slot with Bitcoin at {brand}. Medium-High volatility, 7,500x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_west_gold_megaways': {
        title: 'Wild West Gold Megaways Slot | 12,000x Max Win | {brand}',
        description: 'Play Wild West Gold Megaways slot with Bitcoin at {brand}. High volatility, 12,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_wild_bananas': {
        title: 'Wild Wild Bananas Slot | 12,000x Max Win | {brand}',
        description: 'Play Wild Wild Bananas slot with Bitcoin at {brand}. Medium-High volatility, 12,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_wild_joker': {
        title: 'Wild Wild Joker Slot | 5,000x Max Win | {brand}',
        description: 'Play Wild Wild Joker slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_wild_pearls': {
        title: 'Wild Wild Pearls Slot | 5,000x Max Win | {brand}',
        description: 'Play Wild Wild Pearls slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_wild_riches': {
        title: 'Wild Wild Riches Slot | 10,000x Max Win | {brand}',
        description: 'Play Wild Wild Riches slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_wild_riches_returns': {
        title: 'Wild Wild Riches Returns Slot | 10,000x Max Win | {brand}',
        description: 'Play Wild Wild Riches Returns slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wild_wildebeest_wins': {
        title: 'Wild Wildebeest Wins Slot | 10,000x Max Win | {brand}',
        description: 'Play Wild Wildebeest Wins slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wildies': {
        title: 'Wildies Slot | 7,500x Max Win | {brand}',
        description: 'Play Wildies slot with Bitcoin at {brand}. Medium-High volatility, 7,500x max win, Crypto deposits, instant withdrawals No fees.'
    },
    '/p/pragmatic-play/wildman_super_bonanza': {
        title: 'Wildman Super Bonanza Slot | 10,000x Max Win | {brand}',
        description: 'Play Wildman Super Bonanza slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wisdom_of_athena': {
        title: 'Wisdom Of Athena Slot | 5,000x Max Win | {brand}',
        description: 'Play Wisdom Of Athena slot with Bitcoin at {brand}. High volatility, 5,000x max win, tumble feature. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wisdom_of_athena_1000': {
        title: 'Wisdom Of Athena 1000 Slot | 15,000x Max Win | {brand}',
        description: 'Play Wisdom Of Athena 1000 slot with Bitcoin at {brand}. High volatility, 15,000x max win, 1000x multiplier version. Crypto deposits.'
    },
    '/p/pragmatic-play/wisdom_of_athena_1000_xmas': {
        title: 'Wisdom Of Athena 1000 Xmas Slot | 10,000x Max Win | {brand}',
        description: 'Play Wisdom Of Athena 1000 Xmas slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/witch_heart_megaways': {
        title: 'Witch Heart Megaways Slot | 9,000x Max Win | {brand}',
        description: 'Play Witch Heart Megaways slot with Bitcoin at {brand}. High volatility, 9,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wolf_gold': {
        title: 'Wolf Gold Slot | Not specified Max Win | {brand}',
        description: 'Play Wolf Gold slot with Bitcoin at {brand}. Medium volatility, Not specified max win, money respin feature (hold. Crypto deposits.'
    },
    '/p/pragmatic-play/wolf_gold_4_pack': {
        title: 'Wolf Gold 4 Pack Slot | 5,100x Max Win | {brand}',
        description: 'Play Wolf Gold 4 Pack slot with Bitcoin at {brand}. Medium-High volatility, 5,100x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wolf_gold_ultimate': {
        title: 'Wolf Gold Ultimate Slot | 5,000x Max Win | {brand}',
        description: 'Play Wolf Gold Ultimate slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/wukong_rush': {
        title: 'Wukong Rush Slot | Play Online | {brand}',
        description: 'Play Wukong Rush by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more No fees, fast crypto payouts.'
    },
    '/p/pragmatic-play/year_of_the_dragon_king': {
        title: 'Year Of The Dragon King Slot | Pragmatic Play | {brand}',
        description: 'Play Year Of The Dragon King by Pragmatic Play at {brand}. Medium-High volatility, Deposit with BTC, ETH, USDT, DOGE and more.'
    },
    '/p/pragmatic-play/yeti_quest': {
        title: 'Yeti Quest Slot | 5,000x Max Win | {brand}',
        description: 'Play Yeti Quest slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/you_can_piggy_bank_on_it': {
        title: 'You Can Piggy Bank On It Slot | 2,100x Max Win | {brand}',
        description: 'Play You Can Piggy Bank On It slot with Bitcoin at {brand}. Medium-High volatility, 2,100x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/yum_yum_powerways': {
        title: 'Yum Yum Powerways Slot | 5,000x Max Win | {brand}',
        description: 'Play Yum Yum Powerways slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/zeus_vs_hades_gods_of_war': {
        title: 'Zeus Vs Hades Gods Of War Slot | 15,015x Max Win | {brand}',
        description: 'Play Zeus Vs Hades Gods Of War slot with Bitcoin at {brand}. High volatility, 15,015x max win, wild multipliers. Crypto deposits.'
    },
    '/p/pragmatic-play/zeus_vs_hades_gods_of_war_250': {
        title: 'Zeus Vs Hades Gods Of War 250 Slot | 25,000x Max Win | {brand}',
        description: 'Play Zeus Vs Hades Gods Of War 250 slot with Bitcoin at {brand}. Medium-High volatility, 25,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/zeus_vs_typhoon': {
        title: 'Zeus Vs Typhoon Slot | 10,000x Max Win | {brand}',
        description: 'Play Zeus Vs Typhoon slot with Bitcoin at {brand}. Medium-High volatility, 10,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/zombie_carnival': {
        title: 'Zombie Carnival Slot | 5,000x Max Win | {brand}',
        description: 'Play Zombie Carnival slot with Bitcoin at {brand}. Medium-High volatility, 5,000x max win, Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/zombie_school_megaways': {
        title: 'Zombie School Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Zombie School Megaways slot with Bitcoin at {brand}. High volatility, 10,000x max win, megaways. Crypto deposits, instant withdrawals.'
    },
    '/p/pragmatic-play/zombie_train': {
        title: 'Zombie Train Slot | 15,000x Max Win | {brand}',
        description: 'Play Zombie Train slot with Bitcoin at {brand}. Medium-High volatility, 15,000x max win, Crypto deposits, instant withdrawals.'
    }
};
/** AvatarUX, Big Time Gaming, Blueprint, BoomingGames, Fantasma, Nolimit City, Play n GO — copy from utilities/seo exports */
const gameSeoUploaded = {
    '/p/avatarux/7_lucky_gods': {
        title: '7 Lucky Gods Slot | Win Up to 1,200x | {brand}',
        description: 'Deposit BTC and play 7 Lucky Gods at {brand}. 1,200x max win, low volatility, Walking Wilds. 9 cryptos, zero fees.'
    },
    '/p/avatarux/80spop': {
        title: '80sPOP | 20,000x Max Win Crypto Slot | {brand}',
        description: '80sPOP slot at {brand} crypto casino. High volatility, 20,000x max win with PopWins. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/avatarux/animals_strike': {
        title: 'Play Animals Strike | 10,000x Win | {brand}',
        description: 'Animals Strike slot at {brand} crypto casino. High volatility, 10,000x max win with Bonus Game. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/avatarux/arcanapop': {
        title: 'Play ArcanaPop Slot | 20,000x Payout | {brand}',
        description: 'Spin ArcanaPop with Bitcoin at {brand}. 20,000x max win, high volatility, PopWins. Instant payouts, zero platform fees.'
    },
    '/p/avatarux/astropop': {
        title: 'Play AstroPop | 10,000x Max Win | {brand}',
        description: 'AstroPop at {brand} crypto casino. 10,000x max win with Multipop. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/beastly_burglars': {
        title: 'Beastly Burglars | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Beastly Burglars with Bitcoin at {brand}. 10,000x max win, medium volatility, On-Reels Multiplier. Instant payouts, zero platform fees.'
    },
    '/p/avatarux/big_catch_craze': {
        title: 'Play Big Catch Craze | 10,000x Win | {brand}',
        description: "Play Big Catch Craze slot for real money. 10,000x max win, Fisherman's Net. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly."
    },
    '/p/avatarux/big_catch_xmas': {
        title: 'Play Big Catch Xmas | 10,000x Win | {brand}',
        description: "Play Big Catch Xmas at {brand}. High volatility, 10,000x max win. Features Santa's Net. 9 cryptos, instant withdrawals, no fees."
    },
    '/p/avatarux/bounty_pop': {
        title: 'Bounty Pop Slot | 37,910x Win | Play with Bitcoin',
        description: 'Play Bounty Pop by AvatarUX. Medium volatility, 37,910x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/avatarux/canyon_riches': {
        title: 'Canyon Riches Slot | 20,000x Win | Play with Bitcoin',
        description: 'Spin Canyon Riches with Bitcoin at {brand}. 20,000x max win, high volatility, Locked Rows. Instant payouts, zero platform fees.'
    },
    '/p/avatarux/captain_moregain': {
        title: "Play Captain More'gain Slot | 10,000x Payout | {brand}",
        description: "Play Captain More'gain by AvatarUX at {brand}. High volatility, 10,000x max win, Fortune Arrows. 9 cryptos accepted, instant withdrawals."
    },
    '/p/avatarux/cherry_pop': {
        title: 'Cherry Pop Slot | 20,000x Max Win | {brand}',
        description: 'Cherry Pop slot with 20,000x max win. Medium volatility by AvatarUX. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/avatarux/cherry_pop_deluxe': {
        title: 'Cherry Pop Deluxe Slot | 20,000x Max Win | {brand}',
        description: 'Play Cherry Pop Deluxe by AvatarUX. Medium volatility, 20,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/avatarux/cherrypop_burst': {
        title: 'CherryPop Burst Slot | 20,000x Win | Play with Bitcoin',
        description: 'Play CherryPop Burst by AvatarUX at {brand}. High volatility, 20,000x max win, PopWins. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/avatarux/cosmic_jokers': {
        title: 'Play Cosmic Jokers Slot | 10,000x Payout | {brand}',
        description: 'Spin Cosmic Jokers with Bitcoin at {brand}. 10,000x max win, medium volatility, Superspins Mode. Instant payouts, zero platform fees.'
    },
    '/p/avatarux/coyote_gold': {
        title: 'Play Coyote Gold | 10,000x Max Win | {brand}',
        description: 'Play Coyote Gold at {brand}. Medium volatility, 10,000x max win. Features Loot Drop. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/avatarux/critter_pop': {
        title: 'Critter Pop | 20,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Critter Pop by AvatarUX at {brand}. Medium volatility, 20,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/avatarux/crypto_bro': {
        title: 'Crypto Bro | 20,000x Max Win Bitcoin Slot | {brand}',
        description: 'Crypto Bro slot with 20,000x max win and Roaming & Countdown Wilds. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/avatarux/depths_of_fortune': {
        title: 'Depths of Fortune Slot | Win Up to 20,000x | {brand}',
        description: 'Play Depths of Fortune at {brand}. Medium volatility, 20,000x max win. Features Loaded Reel. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/avatarux/donkey_and_the_goats': {
        title: 'Play Donkey And The Goats Online | {brand}',
        description: 'Donkey And The Goats by AvatarUX at {brand} crypto casino. Medium volatility. Play with Bitcoin, ETH, USDT. Fast crypto payouts.'
    },
    '/p/avatarux/duck_hunt_500': {
        title: 'Play Duck Hunt 500 Slot | 10,000x Payout | {brand}',
        description: "Duck Hunt 500 by AvatarUX. High volatility slot with 10,000x max win and The Hunter's Shot. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/avatarux/electric_rush': {
        title: 'Play Electric Rush | 10,000x Max Win | {brand}',
        description: 'Play Electric Rush slot for real money. 10,000x max win, Pay Anywhere. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/avatarux/electro_cubes': {
        title: 'Electro Cubes Slot | 10,000x Max Win | {brand}',
        description: 'Spin Electro Cubes with Bitcoin at {brand}. 10,000x max win, low volatility, Cube Nudge. Instant payouts, zero platform fees.'
    },
    '/p/avatarux/floridaman': {
        title: 'Floridaman | 20,000x Max Win Bitcoin Slot | {brand}',
        description: 'Floridaman slot with 20,000x max win and Floridaman Attack. Medium volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/avatarux/fruitillionaire': {
        title: 'Fruitillionaire | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Fruitillionaire at {brand}. Medium volatility, 10,000x max win. Features Bonus Collectors. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/avatarux/gempops': {
        title: 'Play GemPOPs Online | {brand}',
        description: 'Deposit Bitcoin and play GemPOPs at {brand}. High volatility. 9 cryptos, no fees, instant withdrawals.'
    },
    '/p/avatarux/gods_gone_wild': {
        title: 'Play Gods Gone Wild | 10,000x Max Win | {brand}',
        description: 'Play Gods Gone Wild slot for real money. 10,000x max win, Pay Anywhere. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/avatarux/heliopopolis': {
        title: 'HelioPOPolis Slot | 50,000x Max Win | {brand}',
        description: 'Play HelioPOPolis by AvatarUX at {brand}. Medium volatility, 50,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/avatarux/hiphop_pop': {
        title: 'Play Hip-Hop Pop | 50,000x Max Win | {brand}',
        description: 'Hip-Hop Pop at {brand}. Medium volatility, 50,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/avatarux/hippo_pop': {
        title: 'Hippo Pop Slot | Win Up to 20,000x | {brand}',
        description: 'Deposit Bitcoin and play Hippo Pop at {brand}. 20,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/avatarux/imperial_coins': {
        title: 'Imperial Coins | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Imperial Coins slot for real money. 10,000x max win, Cash Coins Respins. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/avatarux/jinglepop': {
        title: 'JinglePOP Slot | Win Up to 20,000x | {brand}',
        description: 'JinglePOP at {brand} crypto casino. 20,000x max win with GoldenWays. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/juicypop': {
        title: 'JuicyPop Slot | 10,000x Win | Play with Bitcoin',
        description: 'JuicyPop by AvatarUX. Medium volatility slot with 10,000x max win and Multipop. Play with Bitcoin at {brand}. Fast withdrawals.'
    },
    '/p/avatarux/jungle_pop': {
        title: 'Play Jungle Pop Slot | 50,000x Payout | {brand}',
        description: 'Play Jungle Pop by AvatarUX at {brand}. High volatility, 50,000x max win, Free Spins. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/avatarux/king_of_samba': {
        title: 'King of Samba | 1,200x Max Win Crypto Slot | {brand}',
        description: 'Play King of Samba slot for real money at {brand}. 1,200x max win, low volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/avatarux/kittypopins': {
        title: 'KittyPOPins Slot | Win Up to 20,000x | {brand}',
        description: 'KittyPOPins at {brand} crypto casino. 20,000x max win with The King Cat. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/kokeshi_pop': {
        title: 'Kokeshi Pop | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Kokeshi Pop slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/avatarux/lolli_pop': {
        title: 'Lolli Pop Slot | Play with Crypto | {brand}',
        description: 'Play Lolli Pop slot for real money at {brand}. Medium volatility. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/avatarux/looney_pop': {
        title: 'Looney Pop Slot | Win Up to 50,000x | {brand}',
        description: 'Looney Pop at {brand}. Medium volatility, 50,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/avatarux/majestic_meow': {
        title: 'Majestic Meow | 94x Max Win Bitcoin Slot | {brand}',
        description: 'Majestic Meow slot with 94x max win and Bet Over/Under. Low volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/avatarux/midnight_hunt': {
        title: 'Play Midnight Hunt | 5,205x Win | {brand}',
        description: 'Midnight Hunt at {brand} crypto casino. 5,205x max win with Win Lines. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/monkey_pop': {
        title: 'Play Monkey Pop | 20,000x',
        description: 'Play MonkeyPop 2 by AvatarUX at {brand}. High volatility, 10,000x max win, PopWins. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/avatarux/nugget': {
        title: 'Nugget | 25,000x Max Win Crypto Slot | {brand}',
        description: 'Nugget at {brand} crypto casino. 25,000x max win with Golden Ways. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/papaya_pop': {
        title: 'Play Papaya Pop | 10,542x Max Win | {brand}',
        description: 'Papaya Pop slot at {brand} crypto casino. Medium volatility with 10,542x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/avatarux/piggy_pop': {
        title: 'Play Piggy Pop | 20,000x Win | {brand}',
        description: 'Play Piggy Pop slot for real money at {brand}. 20,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/avatarux/piggypop_grand_affair': {
        title: 'Play PiggyPop Grand Affair | 5,000x Max Win | {brand}',
        description: 'PiggyPop Grand Affair at {brand} crypto casino. 5,000x max win with PopWins. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/pixel_paws': {
        title: 'Pixel Paws Slot | Win Up to 20,000x | {brand}',
        description: 'Pixel Paws at {brand} crypto casino. 20,000x max win with Loaded Reel. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/pixiepop': {
        title: 'PixiePop | 20,000x Max Win Crypto Slot | {brand}',
        description: 'Play PixiePop at {brand}. High volatility, 20,000x max win. Features PopWins. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/avatarux/pop_noir': {
        title: 'Pop Noir | 20,000x Max Win Crypto Slot | {brand}',
        description: 'Play Pop Noir slot for real money. 20,000x max win, PopWins. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/avatarux/pop_ogold': {
        title: "Pop O'Gold Slot | 20,000x Win | Play with Bitcoin",
        description: "Pop O'Gold by AvatarUX. High volatility slot with 20,000x max win and StickyPOP. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/avatarux/pop_rocks': {
        title: 'Pop Rocks | 72,188x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Pop Rocks at {brand}. 72,188x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/avatarux/raging_pop': {
        title: 'Play Raging Pop | 20,000x Win | {brand}',
        description: 'Raging Pop at {brand}. Medium volatility, 20,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/avatarux/rebel_paws': {
        title: 'Rebel Paws Slot | Win Up to 10,000x | {brand}',
        description: 'Play Rebel Paws at {brand}. High volatility, 10,000x max win. Features Mystery Symbols. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/avatarux/reef_pop': {
        title: 'ReefPop Slot | Play with Crypto | {brand}',
        description: 'Play ReefPop slot for real money at {brand}. High volatility. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/avatarux/reel_warriors': {
        title: 'Reel Warriors | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Reel Warriors at {brand} crypto casino. 10,000x max win with Hit Collector. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/shippy_d_pop': {
        title: 'Play Shippy D Pop | 50,000x Max Win | {brand}',
        description: 'Shippy D Pop at {brand} crypto casino. 50,000x max win with Zap Reel. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/silicon_spinners': {
        title: 'Play Silicon Spinners | 20,000x Max Win | {brand}',
        description: 'Silicon Spinners at {brand} crypto casino. 20,000x max win with PopWins. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/sphinx_treasure': {
        title: 'Sphinx Treasure | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Sphinx Treasure slot for real money. 10,000x max win, Reward Boosters. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/avatarux/spinfection': {
        title: 'Spinfection Slot | Win Up to 1,365x | {brand}',
        description: 'Play Spinfection at {brand}. Medium volatility, 1,365x max win. Features Magic Spins; Magic Rewind; . 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/avatarux/spinxiety': {
        title: 'Play Spinxiety Slot | 20,000x Payout | {brand}',
        description: 'Play Spinxiety by AvatarUX. 20,000x max win, Progressive Expanding Wilds, high volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/avatarux/sweet_gummy': {
        title: 'Play Sweet Gummy | 10,000x Max Win | {brand}',
        description: 'Sweet Gummy at {brand} crypto casino. 10,000x max win with Wild Reel. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/avatarux/the_vault_chase': {
        title: 'The Vault Chase Slot | 10,000x Max Win | {brand}',
        description: 'The Vault Chase by AvatarUX. Medium volatility slot with 10,000x max win and Key Symbols. Play with Bitcoin at {brand}. Fast withdrawals.'
    },
    '/p/avatarux/tik_talkers': {
        title: 'Tik Talkers | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Tik Talkers by AvatarUX at {brand}. Low volatility, 10,000x max win, Increasing payline levels. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/avatarux/tiki_pop': {
        title: 'Tiki Pop | 32,000x Max Win Bitcoin Slot | {brand}',
        description: 'Tiki Pop slot with 32,000x max win. Medium volatility by AvatarUX. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/avatarux/tikipop_spooky_temples': {
        title: 'TikiPop Spooky Temples Slot | 32,000x Max Win | {brand}',
        description: 'Play TikiPop Spooky Temples by AvatarUX at {brand}. High volatility, 32,000x max win, PopWins. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/avatarux/toads_bounty': {
        title: "Toad's Bounty Slot | 10,000x Win | Play with Bitcoin",
        description: "Toad's Bounty by AvatarUX. Low volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/avatarux/vegas_fortune': {
        title: 'Play Vegas Fortune | 10,000x Win | {brand}',
        description: 'Play Vegas Fortune slot for real money. 10,000x max win, Infinity Stacks. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/avatarux/wild_pops': {
        title: 'Play Wild Pops Online | {brand}',
        description: 'Wild Pops by AvatarUX at {brand} crypto casino. Medium volatility. Play with Bitcoin, ETH, USDT. Fast crypto payouts.'
    },
    '/p/avatarux/witchy_poppins': {
        title: 'Play Witchy POPpins | 20,000x Max Win | {brand}',
        description: 'Play Witchy POPpins slot for real money. 20,000x max win, Popscades. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/avatarux/worms_of_valor': {
        title: 'Worms of Valor Slot | 10,000x Max Win | {brand}',
        description: 'Play Worms of Valor by AvatarUX. 10,000x max win, Popscade, high volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/avatarux/xmas_pop_delight': {
        title: 'Play Xmas Pop Delight Slot | 20,000x Payout | {brand}',
        description: 'Xmas Pop Delight by AvatarUX. High volatility slot with 20,000x max win and PopWins Feature. Play with Bitcoin at {brand}. Fast withdrawals.'
    },
    '/p/avatarux/zombie_apopalypse': {
        title: 'Play Zombie Apopalypse | Crypto Slot | {brand}',
        description: 'Spin Zombie Apopalypse with crypto at {brand}. Medium volatility by AvatarUX. Instant withdrawals, no fees. BTC, ETH, USDT accepted.'
    },
    '/p/big-time-gaming/apollo_pays': {
        title: 'Apollo Pays Slot | 116,030x Max Win | {brand}',
        description: 'Apollo Pays slot with 116,030x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/beef_lightning': {
        title: 'Play Beef Lightning Slot | 56,000x Payout | {brand}',
        description: 'Play Beef Lightning by Big Time Gaming. Medium volatility, 56,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/big_bad_bison': {
        title: 'Play Big Bad Bison | 55,260x Win | {brand}',
        description: 'Big Bad Bison at {brand}. Medium volatility, 55,260x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/big_bucks_deluxe': {
        title: 'Big Bucks Deluxe Slot | 89,600x Win | Play with Bitcoin',
        description: 'Big Bucks Deluxe slot with 89,600x max win and Hold and Spin. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/big-time-gaming/bonanza': {
        title: 'Bonanza Slot | 29,000x Win | Play with Bitcoin',
        description: 'Play Bonanza by Big Time Gaming. Medium volatility, 29,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/bonanza_falls': {
        title: 'Bonanza Falls Slot | Win Up to 10,000x | {brand}',
        description: 'Play Bonanza Falls at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/bonanza_megaways': {
        title: 'Bonanza Megaways | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Bonanza Megaways slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/boo': {
        title: 'Play Boo | 47,050x Win | {brand}',
        description: 'Deposit BTC and play Boo at {brand}. 47,050x max win, medium volatility, Wilds. 9 cryptos, zero fees.'
    },
    '/p/big-time-gaming/book_of_gods': {
        title: 'Book Of Gods Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Book Of Gods by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/burgers': {
        title: 'Burgers Slot | Win Up to 102,840x | {brand}',
        description: 'Burgers at {brand} crypto casino. 102,840x max win with Bonus Buy. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/big-time-gaming/castle_of_terror': {
        title: 'Castle of Terror | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Castle of Terror by Big Time Gaming. Medium volatility, 13,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/chocolates': {
        title: 'Play Chocolates Slot | 13,000x Payout | {brand}',
        description: 'Chocolates slot with 13,000x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/christmas_bonanza': {
        title: 'Christmas Bonanza Slot | Win Up to 13,000x | {brand}',
        description: 'Christmas Bonanza at {brand}. Medium volatility, 13,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/christmas_catch': {
        title: 'Christmas Catch | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Christmas Catch at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/crystal_towers': {
        title: 'Crystal Towers Slot | 10,000x Max Win | {brand}',
        description: 'Crystal Towers slot with 10,000x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/cyberslot_megaclusters': {
        title: 'Cyberslot MegaClusters Slot | 23,960x Max Win | {brand}',
        description: 'Cyberslot MegaClusters by Big Time Gaming. Medium volatility slot with 23,960x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/danger_high_voltage': {
        title: 'Danger High Voltage | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Danger High Voltage by Big Time Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/danger_high_voltage_2': {
        title: 'Danger High Voltage 2 | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Danger High Voltage 2 slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/danger_high_voltage_2_megaways': {
        title: 'Danger High Voltage 2 Megaways Slot | 10,000x Win | {brand}',
        description: 'Play Danger High Voltage 2 Megaways by Big Time Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/diamond_fruits': {
        title: 'Play Diamond Fruits | 13,000x Max Win | {brand}',
        description: 'Diamond Fruits at {brand}. Medium volatility, 13,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/donuts': {
        title: 'Donuts | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'Donuts slot with 13,000x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/dragon_born': {
        title: 'Dragon Born Slot | 13,000x Win | Play with Bitcoin',
        description: 'Spin Dragon Born with Bitcoin at {brand}. 13,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/extra_chilli': {
        title: 'Play Extra Chilli | 32,250x Max Win | {brand}',
        description: 'Deposit Bitcoin and play Extra Chilli at {brand}. 32,250x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/big-time-gaming/extra_chilli_megaways': {
        title: 'Extra Chilli Megaways | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Extra Chilli Megaways by Big Time Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/extra_chilli_nfd': {
        title: 'Extra Chilli (NFD) | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Extra Chilli (NFD) by Big Time Gaming. Medium volatility, 13,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/fireworks_megaways': {
        title: 'Fireworks Megaways Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Fireworks Megaways by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/fizzy_pennyslot': {
        title: 'Fizzy Pennyslot | 10,170x Max Win Bitcoin Slot | {brand}',
        description: 'Fizzy Pennyslot slot with 10,170x max win and Pennyslot. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/big-time-gaming/gifts_of_fortune': {
        title: 'Gifts of Fortune Slot | 13,000x Win | Play with Bitcoin',
        description: 'Spin Gifts of Fortune with Bitcoin at {brand}. 13,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/gold_megaways': {
        title: 'Gold Megaways Slot | 13,000x Win | Play with Bitcoin',
        description: 'Play Gold Megaways by Big Time Gaming. Medium volatility, 13,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/golden_catch': {
        title: 'Golden Catch Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Golden Catch by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/golden_goose_megaways': {
        title: 'Play Golden Goose Megaways | 29,030x Win | {brand}',
        description: 'Golden Goose Megaways slot at {brand} crypto casino. High volatility, 29,030x max win with Cloud Prizes and Bonus Boy. Deposit BTC, ETH, USDT.'
    },
    '/p/big-time-gaming/holy_diver': {
        title: 'Holy Diver Slot | 13,000x Max Win | {brand}',
        description: 'Play Holy Diver by Big Time Gaming. Medium volatility, 13,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/holy_diver_megaways': {
        title: 'Play Holy Diver Megaways | 10,000x Win | {brand}',
        description: 'Holy Diver Megaways at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/king_of_cats': {
        title: 'King of Cats | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play King of Cats by Big Time Gaming. Medium volatility, 13,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/kingmaker': {
        title: 'KingMaker | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'KingMaker by Big Time Gaming. Medium volatility slot with 13,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/kingmaker_fully_loaded': {
        title: 'Play Kingmaker Fully Loaded | 10,000x Win | {brand}',
        description: 'Kingmaker Fully Loaded slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/big-time-gaming/lil_devil': {
        title: 'Lil Devil | 91,300x Max Win Crypto Slot | {brand}',
        description: 'Lil Devil at {brand}. Medium volatility, 91,300x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/big-time-gaming/lucky_streak_mk2': {
        title: 'Play Lucky Streak Mk2 | 13,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Lucky Streak Mk2 at {brand}. 13,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/big-time-gaming/max_megaways': {
        title: 'Max Megaways Slot | 13,000x Win | Play with Bitcoin',
        description: 'Max Megaways slot with 13,000x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/max_megaways_2': {
        title: 'Play Max Megaways 2 | 10,000x Max Win | {brand}',
        description: 'Max Megaways 2 slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/big-time-gaming/max_megaways_3': {
        title: 'Max Megaways 3 | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Max Megaways 3 by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/millionaire': {
        title: 'Play Millionaire Megapots Slot | 3,600x Payout | {brand}',
        description: 'Millionaire Megapots by Big Time Gaming. High volatility slot with 3,600x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/millionaire_mystery_box': {
        title: 'Millionaire Mystery Box Slot | 13,000x Max Win | {brand}',
        description: 'Play Millionaire Mystery Box by Big Time Gaming at {brand}. Medium volatility, 13,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/millionaire_rush': {
        title: 'Millionaire Rush | 13,000x Max Win Crypto Slot | {brand}',
        description: 'Millionaire Rush slot at {brand} crypto casino. Medium volatility with 13,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/big-time-gaming/monopoly_rush_hour': {
        title: 'Monopoly Rush Hour Slot | 10,000x Max Win | {brand}',
        description: 'Monopoly Rush Hour by Big Time Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/more_turkey': {
        title: 'More Turkey Slot | Win Up to 10,000x | {brand}',
        description: 'Play More Turkey at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/opal_fruits': {
        title: 'Play Opal Fruits | 13,000x Win | {brand}',
        description: 'Play Opal Fruits slot for real money at {brand}. 13,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/outlaw': {
        title: 'Play Outlaw | 13,000x Win | {brand}',
        description: 'Outlaw slot at {brand} crypto casino. Medium volatility with 13,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/big-time-gaming/over_the_moon': {
        title: 'Play Over The Moon | 24,070x Max Win | {brand}',
        description: 'Play Over The Moon slot for real money at {brand}. 24,070x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/panda_money': {
        title: 'Panda Money Slot | 10,000x Max Win | {brand}',
        description: 'Play Panda Money by Big Time Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/pirate_pays': {
        title: 'Pirate Pays | 104,400x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Pirate Pays with Bitcoin at {brand}. 104,400x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/pop': {
        title: 'Pop Slot | 13,000x Win | Play with Bitcoin',
        description: 'Spin Pop with Bitcoin at {brand}. 13,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/queen_of_riches': {
        title: 'Queen Of Riches | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Queen Of Riches by Big Time Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/big-time-gaming/rasputin_megaways': {
        title: 'Rasputin Megaways | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Rasputin Megaways with Bitcoin at {brand}. 13,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/royal_mint': {
        title: 'Play Royal Mint | 40,000x Win | {brand}',
        description: 'Play Royal Mint at {brand} crypto casino. Medium volatility, 40,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/sanctuary': {
        title: 'Play Sanctuary | 10,000x Win | {brand}',
        description: 'Play Sanctuary at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/slot_vegas': {
        title: 'Slot Vegas | 22,700x Max Win Bitcoin Slot | {brand}',
        description: 'Play Slot Vegas by Big Time Gaming at {brand}. Medium volatility, 22,700x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/slot_vegas_fully_loaded': {
        title: 'Slot Vegas Fully Loaded Slot | Win Up to 10,000x | {brand}',
        description: 'Play Slot Vegas Fully Loaded at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/spicy_meatballs': {
        title: 'Play Spicy Meatballs | 55,210x Win | {brand}',
        description: 'Play Spicy Meatballs slot for real money at {brand}. 55,210x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/star_clusters': {
        title: 'Star Clusters | 16,708x Max Win Crypto Slot | {brand}',
        description: 'Play Star Clusters slot for real money at {brand}. 16,708x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/temple_quest_spinfinity': {
        title: 'Play Temple Quest Spinfinity | 13,000x Win | {brand}',
        description: 'Play Temple Quest Spinfinity at {brand} crypto casino. Medium volatility, 13,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/the_final_countdown': {
        title: 'Play The Final Countdown | 13,000x Max Win | {brand}',
        description: 'Play The Final Countdown at {brand} crypto casino. Medium volatility, 13,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/big-time-gaming/the_golden_catch': {
        title: 'The Golden Catch Slot | 10,000x Max Win | {brand}',
        description: 'Play The Golden Catch by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/the_race': {
        title: 'Play The Race Slot | 13,960x Payout | {brand}',
        description: 'The Race by Big Time Gaming. Medium volatility slot with 13,960x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/trigger_happy': {
        title: 'Trigger Happy | 50,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Trigger Happy with Bitcoin at {brand}. 50,000x max win, high volatility, Target Wild. Instant payouts, zero platform fees.'
    },
    '/p/big-time-gaming/vegas_megaways': {
        title: 'Vegas MegaWays Slot | 13,000x Max Win | {brand}',
        description: 'Vegas MegaWays by Big Time Gaming. Medium volatility slot with 13,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/vegas_rush': {
        title: 'Vegas Rush | 13,570x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Vegas Rush with Bitcoin at {brand}. 13,570x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/big-time-gaming/white_rabbit': {
        title: 'White Rabbit | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play White Rabbit at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/big-time-gaming/white_rabbit_2': {
        title: 'White Rabbit 2 Slot | 10,000x Max Win | {brand}',
        description: 'Play White Rabbit 2 by Big Time Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/big-time-gaming/white_rabbit_megaways': {
        title: 'White Rabbit Megaways Slot | 10,000x Win | Play with Bitcoin',
        description: 'White Rabbit Megaways slot with 10,000x max win. Medium volatility by Big Time Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/white_rabbit_nfd': {
        title: 'White Rabbit (NFD) | 13,000x Max Win Bitcoin Slot | {brand}',
        description: 'White Rabbit (NFD) by Big Time Gaming. Medium volatility slot with 13,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/big-time-gaming/wild_flower': {
        title: 'Wild Flower | 13,000x Max Win Crypto Slot | {brand}',
        description: 'Wild Flower slot at {brand} crypto casino. Medium volatility with 13,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/big-time-gaming/wild_portals': {
        title: 'Play Wild Portals | 13,000x Max Win | {brand}',
        description: 'Play Wild Portals slot for real money at {brand}. 13,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/big-time-gaming/wild_unicorns': {
        title: 'Wild Unicorns | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Wild Unicorns at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/blueprint-gaming/777_deluxe': {
        title: 'Play 777 Deluxe Slot | 50,000x Payout | {brand}',
        description: 'Play 777 Deluxe by Blueprint Gaming. 50,000x max win, Wild Seven Substitutes, high volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/almighty_bear_megaways': {
        title: 'Play Almighty Bear Megaways Slot | 10,000x Payout | {brand}',
        description: 'Almighty Bear Megaways slot with 10,000x max win and Free Spins. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/blueprint-gaming/bankin_bacon': {
        title: 'Bankin Bacon Slot | 10,000x Win | Play with Bitcoin',
        description: 'Bankin Bacon slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/bankin_more_bacon': {
        title: "Play Bankin' More Bacon Slot | 10,000x Payout | {brand}",
        description: "Bankin' More Bacon slot with 10,000x max win and Cash Collect and free spins. Medium/High volatility. Play with Bitcoin at {brand}. Instant crypto payouts."
    },
    '/p/blueprint-gaming/barx_safecracker_megaways': {
        title: 'Barx Safecracker Megaways | {brand}',
        description: 'Barx Safecracker Megaways by Blueprint Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/big_catch_bass_fishing_megaways': {
        title: 'Big Catch Bass Fishing Megaways Slot | Win Up to 200x | {brand}',
        description: 'Big Catch Bass Fishing Megaways slot at {brand} crypto casino. Medium/High volatility, 200x max win with Wild Symbols. Deposit BTC, ETH, USDT.'
    },
    '/p/blueprint-gaming/big_catch_even_bigger_bass_2': {
        title: 'Big Catch Even Bigger Bass 2 Slot | 10,000x Max Win | {brand}',
        description: 'Spin Big Catch Even Bigger Bass 2 with Bitcoin at {brand}. 10,000x max win, medium volatility, Free spins. Instant payouts, zero platform fees.'
    },
    '/p/blueprint-gaming/big_catch_even_bigger_bass_3_megaways': {
        title: 'Big Catch Even Bigger Bass 3 Megaways | {brand}',
        description: 'Play Big Catch Even Bigger Bass 3 Megaways by Blueprint Gaming at {brand}. High volatility, 10,000x max win, Money Collect.'
    },
    '/p/blueprint-gaming/big_money_frenzy_cash_gains': {
        title: 'Big Money Frenzy Cash Gains Slot | 5,000x Win | {brand}',
        description: 'Big Money Frenzy Cash Gains slot with 5,000x max win and Free spins. Medium volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/blueprint-gaming/big_money_megaways': {
        title: 'Play Big Money Megaways | 10,000x Win | {brand}',
        description: 'Play Big Money Megaways at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/blueprint-gaming/bigger_catch_bass_fishing': {
        title: 'Bigger Catch Bass Fishing | 200x Max Win Bitcoin Slot | {brand}',
        description: 'Play Bigger Catch Bass Fishing by Blueprint Gaming. 200x max win, Free Spins, n/a volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/bison_bonanza': {
        title: 'Bison Bonanza Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Bison Bonanza by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/bison_rising_gold_strike': {
        title: 'Play Bison Rising Gold Strike | 10,000x Max Win | {brand}',
        description: 'Deposit BTC and play Bison Rising Gold Strike at {brand}. 10,000x max win, medium/high volatility, Free spins. 9 cryptos, zero fees.'
    },
    '/p/blueprint-gaming/bison_rising_megaways': {
        title: 'Bison Rising Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Bison Rising Megaways by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/bison_rising_reloaded_megaways': {
        title: 'Bison Rising Reloaded Megaways Slot | Win Up to 10,000x | {brand}',
        description: 'Bison Rising Reloaded Megaways at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/blueprint-gaming/blazing_cash': {
        title: 'Blazing Cash Slot | 500x Max Win | {brand}',
        description: 'Play Blazing Cash by Blueprint Gaming at {brand}. Medium volatility, 500x max win, Free Spins. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/blueprint-gaming/bounty_hunter_unchained': {
        title: 'Play Bounty Hunter Unchained | 10,000x Max Win | {brand}',
        description: 'Play Bounty Hunter Unchained at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/blueprint-gaming/bullion_blitz_power_play': {
        title: 'Play Bullion Blitz Power Play | 10,000x Max Win | {brand}',
        description: 'Bullion Blitz Power Play slot at {brand} crypto casino. Medium volatility, 10,000x max win with Free spins. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/blueprint-gaming/cash_strike': {
        title: 'Cash Strike X-Cash | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Cash Strike X-Cash slot at {brand} crypto casino. Medium volatility, 10,000x max win with Free spins. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/blueprint-gaming/cash_strike_hotstepper': {
        title: 'Cash Strike Hotstepper Slot | 50x Win | Play with Bitcoin',
        description: 'Play Cash Strike Hotstepper by Blueprint Gaming. 50x max win, Powerplay, high volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/cash_strike_hotstepper_megaways': {
        title: 'Cash Strike Hotstepper Megaways | {brand}',
        description: 'Deposit BTC and play Cash Strike Hotstepper Megaways at {brand}. 50,000x max win, medium / high volatility, Scatters Collect 1 and 2. 9 cryptos.'
    },
    '/p/blueprint-gaming/cash_strike_power_5': {
        title: 'Play Cash Strike Power 5 | 10,000x Win | {brand}',
        description: 'Play Cash Strike Power 5 at {brand}. High volatility, 10,000x max win. Features Random Cash Add. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/blueprint-gaming/cash_strike_power_up': {
        title: 'Cash Strike Power Up | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Cash Strike Power Up slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/blueprint-gaming/cash_strike_win_boost': {
        title: 'Play Cash Strike Win Boost Slot | 50,000x Payout | {brand}',
        description: 'Cash Strike Win Boost by Blueprint Gaming. High volatility slot with 50,000x max win and Wild symbol. Play with Bitcoin at {brand}.'
    },
    '/p/blueprint-gaming/cashpots_blazinator': {
        title: 'Play Cashpots Blazinator | 5,000x Win | {brand}',
        description: 'Play Cashpots Blazinator slot for real money. 5,000x max win, Fixed Pots. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/blueprint-gaming/chilli_picante_megaways': {
        title: 'Play Chilli Picante Megaways Slot | 10,000x Payout | {brand}',
        description: 'Play Chilli Picante Megaways by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/cop_the_lot_megaways_power_play': {
        title: 'Cop the Lot Megaways Power Play | {brand}',
        description: 'Play Cop the Lot Megaways Power Play at {brand}. Medium volatility, 10,000x max win. Features Cash Collect. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/blueprint-gaming/crabbin_for_cash_extra_big_splash': {
        title: 'Crabbin For Cash Extra Big Splash Slot | {brand}',
        description: 'Crabbin For Cash Extra Big Splash by Blueprint Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}.'
    },
    '/p/blueprint-gaming/crabbin_for_cash_megaways': {
        title: "Play Crabbin' For Cash Megaways | 50,000x Max Win | {brand}",
        description: "Play Crabbin' For Cash Megaways slot for real money. 50,000x max win, Free Spins. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly."
    },
    '/p/blueprint-gaming/crabbin_for_christmas': {
        title: 'Play Crabbin For Christmas | 10,000x Win | {brand}',
        description: 'Crabbin For Christmas slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/blueprint-gaming/diamond_mine_extra_gold': {
        title: 'Diamond Mine Extra Gold Slot | Win Up to 10,000x | {brand}',
        description: 'Diamond Mine Extra Gold at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/blueprint-gaming/diamond_mine_megaways': {
        title: 'Play Diamond Mine Megaways Slot | 10,000x Payout | {brand}',
        description: 'Diamond Mine Megaways slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/divine_links': {
        title: 'Divine Links | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Divine Links with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/blueprint-gaming/dragonfall': {
        title: 'Dragonfall Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit Bitcoin and play Dragonfall at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/blueprint-gaming/eagle_storm': {
        title: 'Eagle Storm | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Eagle Storm at {brand} crypto casino. 10,000x max win with Multiplier. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/el_jackpotto': {
        title: 'El Jackpotto | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'El Jackpotto by Blueprint Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/eternal_phoenix_megaways': {
        title: 'Eternal Phoenix Megaways | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Eternal Phoenix Megaways at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/blueprint-gaming/eye_of_horus_megaways': {
        title: 'Eye Of Horus Megaways | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Eye Of Horus Megaways slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/blueprint-gaming/eye_of_horus_rise_of_egypt': {
        title: 'Eye Of Horus Rise Of Egypt Slot | 10,000x Win | {brand}',
        description: 'Eye Of Horus Rise Of Egypt slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/eye_of_horus_tablets_of_destiny': {
        title: 'Play Eye of Horus Tablets of Destiny Megaways | {brand}',
        description: 'Play Eye of Horus Tablets of Destiny Megaways at {brand}. High volatility, 10,000x max win. Features Expanding Wilds. 9 cryptos.'
    },
    '/p/blueprint-gaming/fat_stacks_miami_cash': {
        title: 'Play Fat Stacks Miami Cash Slot | 10,000x Payout | {brand}',
        description: 'Fat Stacks Miami Cash by Blueprint Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/fishin_frenzy_big_catch_megaways': {
        title: 'Play Fishin Frenzy Big Catch Megaways | 10,000x Max Win | {brand}',
        description: 'Fishin Frenzy Big Catch Megaways slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more.'
    },
    '/p/blueprint-gaming/fishin_frenzy_megaways': {
        title: 'Play Fishin Frenzy Megaways Slot | 10,000x Payout | {brand}',
        description: 'Play Fishin Frenzy Megaways by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/fishin_frenzy_power_4_slots': {
        title: 'Play Fishin Frenzy Power 4 Slots Slot | 10,000x Payout | {brand}',
        description: 'Fishin Frenzy Power 4 Slots slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/frankensteins_fortune': {
        title: "Play Frankenstein's Fortune Slot | 2,000x Payout | {brand}",
        description: "Frankenstein's Fortune slot with 2,000x max win and Free spins. Medium volatility. Play with Bitcoin at {brand}. Instant crypto payouts."
    },
    '/p/blueprint-gaming/fruitopolis_fortune_play': {
        title: 'Fruitopolis Fortune Play Slot | 50,000x Win | {brand}',
        description: 'Fruitopolis Fortune Play slot with 50,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/full_moon_fever': {
        title: 'Full Moon Fever Slot | Win Up to 50,000x | {brand}',
        description: 'Full Moon Fever slot at {brand} crypto casino. High volatility, 50,000x max win with Expanding Wilds. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/blueprint-gaming/funky_buddha': {
        title: 'Funky Buddha | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Funky Buddha slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/blueprint-gaming/genie_jackpot_combo_frenzy': {
        title: 'Genie Jackpot Combo Frenzy Slot | 2,000x Win | {brand}',
        description: 'Genie Jackpot Combo Frenzy slot with 2,000x max win and Free Spins Bonus. Medium volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/blueprint-gaming/genie_jackpots_wishmaker': {
        title: 'Genie Jackpots Wishmaker | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Genie Jackpots Wishmaker at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/blueprint-gaming/gold_strike': {
        title: 'Gold Strike | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Gold Strike slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/gold_strike_2': {
        title: 'Play Gold Strike 2 | 10,000x Win | {brand}',
        description: 'Gold Strike 2 at {brand} crypto casino. 10,000x max win with Free Spins. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/gold_strike_bonanza': {
        title: 'Play Gold Strike Bonanza Slot | 10,000x Payout | {brand}',
        description: 'Play Gold Strike Bonanza by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/gold_strike_express': {
        title: 'Play Gold Strike Express | 7,000x Max Win | {brand}',
        description: 'Gold Strike Express at {brand} crypto casino. 7,000x max win with Free spins. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/blueprint-gaming/gorilla_gold_megaways_power_4_slots': {
        title: 'Gorilla Gold Megaways Power 4 Slots | {brand}',
        description: 'Play Gorilla Gold Megaways Power 4 Slots by Blueprint Gaming. Medium volatility, 10,000x max win.'
    },
    '/p/blueprint-gaming/hope_diamond': {
        title: 'Hope Diamond Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Hope Diamond by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/jungle_fortune_build_your_bonus': {
        title: 'Play Jungle Fortune Build Your Bonus | 10,000x Win | {brand}',
        description: 'Jungle Fortune Build Your Bonus slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more.'
    },
    '/p/blueprint-gaming/king_kong_cash': {
        title: 'King Kong Cash Full House Slot | 10,000x Win | {brand}',
        description: 'King Kong Cash Full House by Blueprint Gaming. Medium volatility slot with 10,000x max win and Decommissioned. Play with Bitcoin at {brand}.'
    },
    '/p/blueprint-gaming/king_kong_cash_dj_prime8': {
        title: 'King Kong Cash Dj Prime8 | 10,000x Max Win Crypto Slot | {brand}',
        description: 'King Kong Cash Dj Prime8 slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/blueprint-gaming/king_kong_cash_even_bigger_bananas': {
        title: 'King Kong Cash Even Bigger Bananas Slot | {brand}',
        description: 'Play King Kong Cash Even Bigger Bananas at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees.'
    },
    '/p/blueprint-gaming/king_kong_cash_even_bigger_bananas_2': {
        title: 'King Kong Cash Even Bigger Bananas 2 Slot | 10,000x Win | {brand}',
        description: 'Play King Kong Cash Even Bigger Bananas 2 by Blueprint Gaming at {brand}. Medium volatility, 10,000x max win, Free spins.'
    },
    '/p/blueprint-gaming/king_kong_cash_even_bigger_bananas_4': {
        title: 'King Kong Cash Even Bigger Bananas 4 Slot | {brand}',
        description: 'Play King Kong Cash Even Bigger Bananas 4 by Blueprint Gaming. 10,000x max win, Unlock trail, medium volatility.'
    },
    '/p/blueprint-gaming/king_kong_splash': {
        title: 'King Kong Splash | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play King Kong Splash by Blueprint Gaming at {brand}. Medium volatility, 10,000x max win, Free spins. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/blueprint-gaming/king_of_the_west': {
        title: 'King Of The West Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play King Of The West by Blueprint Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/blueprint-gaming/kong_3_even_bigger_bonus': {
        title: 'Kong 3 Even Bigger Bonus Slot | 10,000x Max Win | {brand}',
        description: 'Kong 3 Even Bigger Bonus by Blueprint Gaming. Medium volatility slot with 10,000x max win and Free spins. Play with Bitcoin at {brand}.'
    },
    '/p/blueprint-gaming/legacy_of_gods_megaways': {
        title: 'Play Legacy Of Gods Megaways | 10,000x Max Win | {brand}',
        description: 'Legacy Of Gods Megaways at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/blueprint-gaming/legacy_of_ra_megaways': {
        title: 'Play Legacy Of Ra Megaways | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Legacy Of Ra Megaways at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/blueprint-gaming/lion_thunder': {
        title: 'Lion Thunder | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Lion Thunder by Blueprint Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/loti_fortune_spins': {
        title: 'Play Loti Fortune Spins | 10,000x Win | {brand}',
        description: 'Loti Fortune Spins at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/blueprint-gaming/loti_gold_spins': {
        title: 'Loti Gold Spins Slot | 10,000x Win | Play with Bitcoin',
        description: 'Loti Gold Spins slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/lucky_pharaoh': {
        title: 'Play Lucky Pharaoh | 10,000x Win | {brand}',
        description: 'Play Lucky Pharaoh slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/blueprint-gaming/majestic_fury_megaways': {
        title: 'Play Majestic Fury Megaways | 10,000x Win | {brand}',
        description: 'Majestic Fury Megaways slot at {brand} crypto casino. Medium volatility, 10,000x max win with Free Spins. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/blueprint-gaming/majestic_fury_megaways_unleashed': {
        title: 'Majestic Fury Megaways Unleashed | {brand}',
        description: 'Deposit BTC and play Majestic Fury Megaways Unleashed at {brand}. 10,000x max win, medium volatility, Unlock trail. 9 cryptos, zero fees.'
    },
    '/p/blueprint-gaming/majestic_fury_win_stepper': {
        title: 'Play Majestic Fury Win Stepper | 10,000x Win | {brand}',
        description: 'Deposit BTC and play Majestic Fury Win Stepper at {brand}. 10,000x max win, medium volatility, Free spins. 9 cryptos, zero fees.'
    },
    '/p/blueprint-gaming/maradona': {
        title: 'Maradona Slot | 10,000x Win | Play with Bitcoin',
        description: 'Maradona by Blueprint Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/maradona_el_diez': {
        title: 'Play Maradona El Diez | 50,000x Max Win | {brand}',
        description: 'Play Maradona El Diez slot for real money. 50,000x max win, Free Spins. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/blueprint-gaming/maradona_el_pibe_de_oro': {
        title: 'Play Maradona El Pibe De Oro Slot | 10,000x Payout | {brand}',
        description: 'Play Maradona El Pibe De Oro by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/midas_king_of_gold': {
        title: 'Midas King Of Gold | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Midas King Of Gold slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/napoleon_2_fat_stacks': {
        title: 'Napoleon 2 Fat Stacks Slot | 10,000x Max Win | {brand}',
        description: 'Play Napoleon 2 Fat Stacks by Blueprint Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/blueprint-gaming/napoleon_deluxe': {
        title: 'Play Napoleon Deluxe | 20,000x Win | {brand}',
        description: 'Play Napoleon Deluxe at {brand}. Medium volatility, 20,000x max win. Features Free Spins. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/blueprint-gaming/napoleon_megaways': {
        title: 'Napoleon Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Play Napoleon Megaways by Blueprint Gaming. 10,000x max win, Free Spins, high volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/napoleon_rise_of_an_empire': {
        title: 'Play Napoleon Rise Of An Empire Slot | 10,000x Payout | {brand}',
        description: 'Play Napoleon Rise Of An Empire by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/plenty_o_fish': {
        title: "Plenty o' Fish Slot | 10,000x Win | Play with Bitcoin",
        description: "Play Plenty o' Fish by Blueprint Gaming. Medium/High volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/blueprint-gaming/primal_megaways': {
        title: 'Play Primal Megaways | 10,000x Max Win | {brand}',
        description: 'Play Primal Megaways slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/blueprint-gaming/red_hot_chilli': {
        title: 'Red Hot Chilli Slot | 10,000x Win | Play with Bitcoin',
        description: 'Spin Red Hot Chilli with Bitcoin at {brand}. 10,000x max win, medium volatility, Chilli Collect. Instant payouts, zero platform fees.'
    },
    '/p/blueprint-gaming/red_hot_eruption': {
        title: 'Play Red Hot Eruption | 8,000x Win | {brand}',
        description: 'Deposit BTC and play Red Hot Eruption at {brand}. 8,000x max win, medium volatility, Free spins. 9 cryptos, zero fees.'
    },
    '/p/blueprint-gaming/return_of_kong_megaways': {
        title: 'Play Return Of Kong Megaways Slot | 10,000x Payout | {brand}',
        description: 'Play Return Of Kong Megaways by Blueprint Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/blueprint-gaming/rhino_rampage': {
        title: 'Play Rhino Rampage | 10,000x Win | {brand}',
        description: 'Rhino Rampage slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/blueprint-gaming/rise_of_atlantis': {
        title: 'Play Rise of Atlantis Legacy | 10,000x Max Win | {brand}',
        description: 'Play Rise of Atlantis Legacy slot for real money. 10,000x max win, Rising Multiplier. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/blueprint-gaming/rise_of_atlantis_2': {
        title: 'Rise Of Atlantis 2 Slot | 10,000x Win | Play with Bitcoin',
        description: 'Rise Of Atlantis 2 slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/safari_gold_megaways': {
        title: 'Safari Gold Megaways | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Safari Gold Megaways slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/blueprint-gaming/saint_nicked_2': {
        title: 'Saint Nicked 2 Slot | 10,000x Max Win | {brand}',
        description: 'Saint Nicked 2 slot with 10,000x max win and Cash Collect. Medium/High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/blueprint-gaming/spirit_wolf_wins': {
        title: 'Spirit Wolf Wins Slot | Win Up to 50,000x | {brand}',
        description: 'Spirit Wolf Wins slot at {brand} crypto casino. Medium volatility, 50,000x max win with Free Spins. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/blueprint-gaming/stickermania_wild_rumble': {
        title: 'Play Stickermania Wild Rumble | 10,000x Win | {brand}',
        description: 'Play Stickermania Wild Rumble slot for real money. 10,000x max win, Wilds. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/blueprint-gaming/super_7_winner': {
        title: 'Super 7 Winner Slot | 10,000x Max Win | {brand}',
        description: 'Play Super 7 Winner by Blueprint Gaming at {brand}. Medium volatility, 10,000x max win, Wild Symbol. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/blueprint-gaming/super_wild_diamonds': {
        title: 'Super Wild Diamonds | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Super Wild Diamonds at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/blueprint-gaming/sweet_success_megaways': {
        title: 'Sweet Success Megaways | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Sweet Success Megaways by Blueprint Gaming. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/tasty_trailz': {
        title: 'Tasty Trailz Slot | Win Up to 10,000x | {brand}',
        description: 'Tasty Trailz at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/blueprint-gaming/temple_of_treasures_megaways': {
        title: 'Play Temple Of Treasures Megaways Slot | 10,000x Payout | {brand}',
        description: 'Spin Temple Of Treasures Megaways with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/blueprint-gaming/the_goat': {
        title: 'The Goat Slot | 10,000x Win | Play with Bitcoin',
        description: 'The Goat slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/tomb_of_dead_power_4_slots': {
        title: 'Tomb Of Dead Power 4 Slots Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit Bitcoin and play Tomb Of Dead Power 4 Slots at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/blueprint-gaming/trailblazer': {
        title: 'Trailblazer | 5,000x Max Win Crypto Slot | {brand}',
        description: 'Play Trailblazer slot for real money. 5,000x max win, Free Spins. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/blueprint-gaming/treasures_of_the_dead': {
        title: 'Play Treasures Of The Dead Slot | 10,000x Payout | {brand}',
        description: 'Treasures Of The Dead slot with 10,000x max win. Medium volatility by Blueprint Gaming. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/blueprint-gaming/valletta_megaways': {
        title: 'Valletta Megaways Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit Bitcoin and play Valletta Megaways at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/blueprint-gaming/viking_fall': {
        title: 'Viking Fall Slot | Win Up to 10,000x | {brand}',
        description: 'Play Viking Fall slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/blueprint-gaming/vikings_unleashed_megaways': {
        title: 'Vikings Unleashed Megaways Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit Bitcoin and play Vikings Unleashed Megaways at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/blueprint-gaming/vikings_unleashed_reloaded_megaways': {
        title: 'Vikings Unleashed Reloaded Megaways Slot | {brand}',
        description: 'Play Vikings Unleashed Reloaded Megaways by Blueprint Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted.'
    },
    '/p/blueprint-gaming/way_of_the_tiger': {
        title: 'Way Of The Tiger | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Way Of The Tiger by Blueprint Gaming at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/blueprint-gaming/wish_upon_a_cashpot': {
        title: 'Play Wish Upon A Cashpot Slot | 10,000x Payout | {brand}',
        description: 'Play Wish Upon A Cashpot by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/wish_upon_a_jackpot': {
        title: 'Wish Upon A Jackpot Slot | 10,000x Max Win | {brand}',
        description: 'Play Wish Upon A Jackpot by Blueprint Gaming. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/blueprint-gaming/wish_upon_a_jackpot_megaways': {
        title: 'Play Wish Upon A Jackpot Megaways | 10,000x Max Win | {brand}',
        description: 'Play Wish Upon A Jackpot Megaways at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/blueprint-gaming/wolf_legend_megaways': {
        title: 'Wolf Legend Megaways Slot | 10,000x Max Win | {brand}',
        description: 'Spin Wolf Legend Megaways with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/blueprint-gaming/wolf_legend_spinboost': {
        title: 'Play Wolf Legend Spinboost | 10,000x Win | {brand}',
        description: 'Play Wolf Legend Spinboost at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/boominggames/64_gold_coins_hold_and_win': {
        title: 'Play 64 Gold Coins Hold and Win Slot | 10,000x Payout | {brand}',
        description: 'Spin 64 Gold Coins Hold and Win with Bitcoin at {brand}. 10,000x max win, medium volatility, Flaming Re-Spins. Instant payouts, zero platform fees.'
    },
    '/p/boominggames/64_gold_coins_hold_and_win_20000': {
        title: 'Play 64 Gold Coins Hold and Win 20000 | 20,000x Max Win | {brand}',
        description: 'Play 64 Gold Coins Hold and Win 20000 slot for real money. 20,000x max win, Flaming Re-Spins. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/boominggames/arabian_spins': {
        title: 'Arabian Spins Slot | Play with Bitcoin | {brand}',
        description: 'Play Arabian Spins at {brand}. Medium volatility slot by Booming Games. 9 cryptos accepted, instant withdrawals, zero fees.'
    },
    '/p/boominggames/bamboo_wilds': {
        title: 'Bamboo Wilds Slot | Win Up to 7,000x | {brand}',
        description: 'Bamboo Wilds at {brand} crypto casino. 7,000x max win with Wild Multipliers. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/boominggames/bang_bang': {
        title: 'Play Bang Bang Slot | 2,000x Payout | {brand}',
        description: 'Bang Bang by Booming Games. Medium volatility slot with 2,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/boominggames/bang_bang_reloaded': {
        title: 'Bang Bang Reloaded Slot | Win Up to 5,200x | {brand}',
        description: 'Play Bang Bang Reloaded at {brand}. High volatility, 5,200x max win. Features Perma 2 Way Pay. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/boominggames/big_apple_wins': {
        title: 'Big Apple Wins Slot | 1,200x Max Win | {brand}',
        description: 'Big Apple Wins slot with 1,200x max win. Medium volatility by Booming Games. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/boominggames/blockchain_megaways': {
        title: 'Blockchain Megaways Slot | 40,320x Win | Play with Bitcoin',
        description: 'Play Blockchain Megaways by Booming Games at {brand}. Medium volatility, 40,320x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/boominggames/bonza_bucks_hold_and_win_extreme_10000': {
        title: 'Bonza Bucks Hold and Win Extreme 10000 | {brand}',
        description: 'Play Bonza Bucks Hold and Win Extreme 10000 by Booming Games at {brand}. Medium volatility, 12,000x max win, Roo Bonus with Wheel of For.'
    },
    '/p/boominggames/boogie_boom': {
        title: 'Boogie Boom | 4,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Boogie Boom with Bitcoin at {brand}. 4,000x max win, high volatility, Spotlight Wilds. Instant payouts, zero platform fees.'
    },
    '/p/boominggames/book_of_tombs': {
        title: 'Book of Tombs | 1,200x Max Win Bitcoin Slot | {brand}',
        description: 'Play Book of Tombs by Booming Games. Medium volatility, 1,200x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/boominggames/booming_seven_deluxe': {
        title: 'Play Booming Seven Deluxe | Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Booming Seven Deluxe at {brand}. Medium volatility. 9 cryptos, no fees, instant withdrawals.'
    },
    '/p/boominggames/booming_seven_deluxe_legacy': {
        title: 'Play Booming Seven Deluxe Legacy Slot | 304x Payout | {brand}',
        description: 'Booming Seven Deluxe Legacy slot with 304x max win and Both Ways Pay. Low volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/boominggames/buffalo_hold_and_win': {
        title: 'Play Buffalo Hold and Win with Bitcoin | 1,200x of your bet',
        description: 'Play Ultra Buffalo Hold and Win slot for real money. 5,000x max win, Wild Buffalo Herd. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/boominggames/buffalo_hold_and_win_extreme': {
        title: 'Play Buffalo Hold and Win Extreme Slot | 4,000x Payout | {brand}',
        description: 'Play Buffalo Hold and Win Extreme by Booming Games at {brand}. Medium volatility, 4,000x max win, Buffalo Bonus with Wheel of.'
    },
    '/p/boominggames/buffalo_hold_and_win_extreme_10000': {
        title: 'Buffalo Hold and Win Extreme 10000 | {brand}',
        description: 'Buffalo Hold and Win Extreme 10000 slot with 12,000x max win and Buffalo Bonus with Wheel of. Medium volatility. Play with Bitcoin at {brand}.'
    },
    '/p/boominggames/burning_classic_2': {
        title: 'Burning Classic 2 | 5,100x Max Win Bitcoin Slot | {brand}',
        description: 'Burning Classic 2 slot with 5,100x max win and Stacked Symbols. Medium volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/boominggames/burning_classics': {
        title: 'Burning Classics Slot | 2,000x Win | Play with Bitcoin',
        description: 'Burning Classics by Booming Games. Medium volatility slot with 2,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/boominggames/burning_classics_5000': {
        title: 'Burning Classics 5000 Slot | 5,100x Win | Play with Bitcoin',
        description: 'Spin Burning Classics 5000 with Bitcoin at {brand}. 5,100x max win, medium volatility, Free Spins. Instant payouts, zero platform fees.'
    },
    '/p/boominggames/burning_classics_royal_edition': {
        title: 'Play Burning Classics Royal Edition | 2,000x Win | {brand}',
        description: 'Deposit BTC and play Burning Classics Royal Edition at {brand}. 2,000x max win, medium volatility, Free Spins. 9 cryptos, zero fees.'
    },
    '/p/boominggames/burning_love': {
        title: 'Burning Love | 10,645x Max Win Crypto Slot | {brand}',
        description: 'Deposit BTC and play Burning Love at {brand}. 10,645x max win, medium volatility, Free Spins. 9 cryptos, zero fees.'
    },
    '/p/boominggames/cash_pig': {
        title: 'Cash Pig | Play Online Slot | {brand}',
        description: 'Cash Pig slot at {brand} crypto casino. Medium volatility. Deposit BTC, ETH, USDT and more. Fast payouts, zero platform fees.'
    },
    '/p/boominggames/cash_pig_2': {
        title: 'Cash Pig 2 Slot | 8,000x Win | Play with Bitcoin',
        description: 'Cash Pig 2 slot with 8,000x max win and Piggy Bank Cash Collect. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/boominggames/cash_pig_2_15000': {
        title: 'Play Cash Pig 2 15000 | 15,000x Max Win | {brand}',
        description: 'Play Cash Pig 2 15000 slot for real money. 15,000x max win, Cash Collection. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/boominggames/chief_hawks_spirit_walk': {
        title: 'Play Chief Hawks Spirit Walk | 5,000x Max Win | {brand}',
        description: 'Play Chief Hawks Spirit Walk at {brand}. Medium volatility, 5,000x max win. Features Cascading reels. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/boominggames/classic_coins': {
        title: 'Classic Coins | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Classic Coins with Bitcoin at {brand}. 10,000x max win, medium volatility, Perma 2-Way Pay. Instant payouts, zero platform fees.'
    },
    '/p/boominggames/classic_fantastic': {
        title: 'Classic Fantastic Slot | Win Up to 7,063x | {brand}',
        description: 'Classic Fantastic at {brand} crypto casino. 7,063x max win with Perma 2-Way Pay. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/boominggames/coin_crusher_hold_and_win': {
        title: 'Coin Crusher Hold and Win Slot | 2,000x Win | {brand}',
        description: 'Play Coin Crusher Hold and Win by Booming Games at {brand}. High volatility, 2,000x max win, Feeding Frenzy Random Wilds.'
    },
    '/p/boominggames/crack_the_bank_hold_and_win': {
        title: 'Play Crack the Bank Hold and Win | 1,200x Win | {brand}',
        description: 'Deposit Bitcoin and play Crack the Bank Hold and Win at {brand}. 1,200x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/boominggames/diamond_hits': {
        title: 'Diamond Hits Slot | 2,150x Max Win | {brand}',
        description: 'Play Diamond Hits by Booming Games at {brand}. Medium volatility, 2,150x max win, Diamond Hits. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/boominggames/diamond_hits_trio_instastrike': {
        title: 'Diamond Hits Trio Instastrike | {brand}',
        description: 'Play Diamond Hits Trio Instastrike slot for real money. 12,500x max win, InstaStrike. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/boominggames/diamond_riches': {
        title: 'Diamond Riches | 1,200x Max Win Bitcoin Slot | {brand}',
        description: 'Diamond Riches by Booming Games. Medium volatility slot with 1,200x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/boominggames/diamonds_diamonds_diamonds_hold_and_win': {
        title: 'Play Diamonds Diamonds Diamonds Hold and Win | {brand}',
        description: 'Deposit BTC and play Diamonds Diamonds Diamonds Hold and Win at {brand}. 5,000x max win, high volatility, Stacked Wild. 9 cryptos, zero fees.'
    },
    '/p/boominggames/diamonds_of_liberty': {
        title: 'Play Diamonds of Liberty Slot | 2,150x Payout | {brand}',
        description: 'Diamonds of Liberty by Booming Games. Medium volatility slot with 2,150x max win and Diamond Hits. Play with Bitcoin at {brand}. Fast withdrawals.'
    },
    '/p/boominggames/dynamite_trio': {
        title: 'Dynamite Trio Slot | Win Up to 10,000x | {brand}',
        description: 'Play Dynamite Trio slot for real money. 10,000x max win, Grid Expand. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/boominggames/easter_classics': {
        title: 'Easter Classics | 2,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit BTC and play Easter Classics at {brand}. 2,000x max win, low volatility, Free Spins. 9 cryptos, zero fees.'
    },
    '/p/boominggames/fish_tales_colossal_catch_link_and_loot': {
        title: 'Fish Tales Colossal Catch Link and Loot Slot | {brand}',
        description: 'Fish Tales Colossal Catch Link and Loot slot with 10,000x max win and Barrel Boost. High volatility. Play with Bitcoin at {brand}.'
    },
    '/p/boominggames/fish_tales_double_catch': {
        title: 'Fish Tales Double Catch | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Fish Tales Double Catch slot for real money. 10,000x max win, Barrel Boost. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/boominggames/fish_tales_halloween': {
        title: 'Play Fish Tales Halloween | 5,000x Max Win | {brand}',
        description: 'Fish Tales Halloween slot at {brand} crypto casino. High volatility, 5,000x max win with Barrel Boost. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/boominggames/fish_tales_monster_bass': {
        title: 'Fish Tales Monster Bass Slot | 5,000x Win | {brand}',
        description: 'Play Fish Tales Monster Bass by Booming Games at {brand}. High volatility, 5,000x max win, Barrel Boost. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/boominggames/flaming_chilies': {
        title: 'Flaming Chilies | 1,200x Max Win Crypto Slot | {brand}',
        description: 'Play Flaming Chilies slot for real money at {brand}. 1,200x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/boominggames/flaming_chillies': {
        title: 'Flaming Chillies | Play Online Slot | {brand}',
        description: 'Flaming Chillies slot by Booming Games. Play with BTC, ETH, USDT at {brand}. Medium volatility. Instant crypto payouts, no fees.'
    },
    '/p/boominggames/forbidden_temple_power_hit': {
        title: 'Forbidden Temple Power Hit Slot | 10,000x Win | {brand}',
        description: 'Play Forbidden Temple Power Hit by Booming Games at {brand}. Medium volatility, 10,000x max win, Power Hit Collection. 9 cryptos accepted.'
    },
    '/p/boominggames/fortune_and_finery': {
        title: 'Play Fortune And Finery Online | {brand}',
        description: 'Fortune And Finery by Booming Games at {brand} crypto casino. Medium volatility. Play with Bitcoin, ETH, USDT. Fast crypto payouts.'
    },
    '/p/boominggames/fruit_heaven_hold_and_win': {
        title: 'Fruit Heaven Hold and WIn | 2,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Fruit Heaven Hold and WIn by Booming Games at {brand}. High volatility, 2,000x max win, Hold and Win. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/boominggames/gamblelicious_hold_and_win': {
        title: 'Gamblelicious Hold and Win | {brand}',
        description: 'Play Gamblelicious Hold and Win by Booming Games at {brand}. Medium volatility, 1,200x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/boominggames/gold_gold_gold': {
        title: 'Gold Gold Gold Slot | Win Up to 0.0x | {brand}',
        description: 'Gold Gold Gold slot at {brand} crypto casino. Medium volatility with 0.0x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/boominggames/gold_gold_gold_5000': {
        title: 'Play Gold Gold Gold 5000 | 5,000x Win | {brand}',
        description: 'Deposit BTC and play Gold Gold Gold 5000 at {brand}. 5,000x max win, medium volatility, Stacked Symbols. 9 cryptos, zero fees.'
    },
    '/p/boominggames/gold_gold_gold_hold_and_win': {
        title: 'Gold Gold Gold Hold and Win Slot | 2,000x Max Win | {brand}',
        description: 'Play Gold Gold Gold Hold and Win by Booming Games. 2,000x max win, Stacked Wilds, high volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/boominggames/greedy_for_gold_power_hit': {
        title: 'Play Greedy for Gold Power Hit Slot | 5,000x Payout | {brand}',
        description: 'Spin Greedy for Gold Power Hit with Bitcoin at {brand}. 5,000x max win, medium volatility, Power Hit Collection. Instant payouts.'
    },
    '/p/boominggames/greek_legends': {
        title: 'Play Greek Legends Slot | 2,000x Payout | {brand}',
        description: 'Play Greek Legends by Booming Games at {brand}. Medium volatility, 2,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/boominggames/holly_jolly_bonanza': {
        title: 'Holly Jolly Bonanza | 6,500x Max Win Bitcoin Slot | {brand}',
        description: 'Play Holly Jolly Bonanza by Booming Games. 6,500x max win, Scatter Pays, high volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/boominggames/holly_jolly_bonanza_2': {
        title: 'Holly Jolly Bonanza 2 Slot | Win Up to 6,500x | {brand}',
        description: 'Holly Jolly Bonanza 2 slot at {brand} crypto casino. High volatility, 6,500x max win with Scatter Pays. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/boominggames/holly_jolly_cash_pig': {
        title: 'Play Holly Jolly Cash Pig | 8,000x Win | {brand}',
        description: 'Holly Jolly Cash Pig at {brand} crypto casino. 8,000x max win with Piggy Bank. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/boominggames/hot_charge': {
        title: 'Hot Charge Slot | Win Up to 4,000x | {brand}',
        description: 'Hot Charge slot at {brand} crypto casino. Medium volatility, 4,000x max win with Charged Free Spins. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/boominggames/howling_for_gold': {
        title: 'Play Howling for Gold Slot | 10,000x Payout | {brand}',
        description: 'Spin Howling for Gold with Bitcoin at {brand}. 10,000x max win, high volatility, Myster Symbols. Instant payouts, zero platform fees.'
    },
    '/p/boominggames/howling_wolves_megaways': {
        title: 'Play Howling Wolves Megaways | 1,200x Max Win | {brand}',
        description: 'Howling Wolves Megaways slot at {brand} crypto casino. Medium volatility with 1,200x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/boominggames/inferno_fortune_power_hit': {
        title: 'Inferno Fortune Power Hit Slot | 5,000x Max Win | {brand}',
        description: 'Play Inferno Fortune Power Hit by Booming Games. 5,000x max win, Inferno Ball collection, high volatility. Bitcoin deposits.'
    },
    '/p/boominggames/jam_bonanza': {
        title: 'Play Jam Bonanza | 5,000x Max Win | {brand}',
        description: 'Play Jam Bonanza at {brand}. Medium volatility, 5,000x max win. Features Scatter Pays. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/boominggames/jesters_bells_bonanza': {
        title: "Jester's Bells Bonanza Slot | 5,000x Win | Play with Bitcoin",
        description: "Jester's Bells Bonanza slot with 5,000x max win and Cascading Reels. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts."
    },
    '/p/boominggames/jesters_riches': {
        title: "Play Jester's Riches Slot | 2,000x Payout | {brand}",
        description: "Play Jester's Riches by Booming Games. 2,000x max win, Jester Payouts, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/boominggames/king_cobra': {
        title: 'King Cobra | 6,500x Max Win Bitcoin Slot | {brand}',
        description: 'King Cobra by Booming Games. Medium volatility slot with 6,500x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/boominggames/legendary_diamonds': {
        title: 'Legendary Diamonds Slot | 1,200x Max Win | {brand}',
        description: 'Play Legendary Diamonds by Booming Games. Medium volatility, 1,200x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/boominggames/let_it_spin': {
        title: 'Play Let it Spin | 2,000x Win | {brand}',
        description: 'Let it Spin at {brand}. Medium volatility, 2,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/boominggames/liberty_and_freedom_hold_and_win_extreme_10000': {
        title: 'Play Liberty and Freedom Hold and Win Extreme 10000 | {brand}',
        description: 'Liberty and Freedom Hold and Win Extreme 10000 at {brand} crypto casino. 12,000x max win with Liberty Bonus with Wheel of. Play with BTC, ETH, USDT.'
    },
    '/p/boominggames/lucky_charms_trio': {
        title: 'Lucky Charms Trio | 5,000x Max Win Crypto Slot | {brand}',
        description: 'Lucky Charms Trio slot at {brand} crypto casino. High volatility, 5,000x max win with Mystery Symbols. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/boominggames/lucky_oasis': {
        title: 'Play Lucky Oasis | 5,000x Max Win | {brand}',
        description: 'Play Lucky Oasis slot for real money. 5,000x max win, Wild Multipliers. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/boominggames/mighty_gorilla': {
        title: 'Mighty Gorilla Slot | 2,000x Win | Play with Bitcoin',
        description: 'Spin Mighty Gorilla with Bitcoin at {brand}. 2,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/boominggames/mr_oinksters_hold_and_win': {
        title: 'Play Mr. Oinksters Hold and Win Slot | 2,000x Payout | {brand}',
        description: 'Mr. Oinksters Hold and Win by Booming Games. Medium volatility slot with 2,000x max win and Hold and Win. Play with Bitcoin at {brand}.'
    },
    '/p/boominggames/paris_nights': {
        title: 'Play Paris Nights Slot | 1,200x Payout | {brand}',
        description: 'Play Paris Nights by Booming Games. Medium volatility, 1,200x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/boominggames/payday_pig': {
        title: 'Payday Pig Slot | 1,500x Max Win | {brand}',
        description: 'Payday Pig slot with 1,500x max win and Piggy Factor Re-Spins. Medium volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/boominggames/power_of_atlantis_trio': {
        title: 'Power of Atlantis Trio Slot | 10,000x Win | {brand}',
        description: 'Spin Power of Atlantis Trio with Bitcoin at {brand}. 10,000x max win, high volatility, Grid Expand. Instant payouts, zero platform fees.'
    },
    '/p/boominggames/power_of_hercules_bonanza': {
        title: 'Play Power of Hercules Bonanza Slot | 5,000x Payout | {brand}',
        description: 'Power of Hercules Bonanza slot with 5,000x max win and Cascading Reels. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/boominggames/power_of_olympus': {
        title: 'Play Power of Olympus Slot | 8,066x Payout | {brand}',
        description: 'Spin Power of Olympus with Bitcoin at {brand}. 8,066x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/boominggames/power_of_rome': {
        title: 'Power of Rome Slot | 2,500x Max Win | {brand}',
        description: 'Power of Rome by Booming Games. Medium volatility slot with 2,500x max win and Wild Multipliers. Play with Bitcoin at {brand}. Fast withdrawals.'
    },
    '/p/boominggames/ras_relics_bonanza': {
        title: "Ra's Relics Bonanza | 6,500x Max Win Bitcoin Slot | {brand}",
        description: "Spin Ra's Relics Bonanza with Bitcoin at {brand}. 6,500x max win, high volatility, Scatter Pays. Instant payouts, zero platform fees."
    },
    '/p/boominggames/reels_paradise': {
        title: 'Reels Paradise Slot | 5,000x Win | Play with Bitcoin',
        description: 'Spin Reels Paradise with Bitcoin at {brand}. 5,000x max win, medium volatility, Value symbols. Instant payouts, zero platform fees.'
    },
    '/p/boominggames/rhino_hold_and_win': {
        title: 'Play Rhino Hold and Win Slot | 1,200x Payout | {brand}',
        description: 'Rhino Hold and Win slot with 1,200x max win. Medium volatility by Booming Games. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/boominggames/roll_the_dice': {
        title: 'Play Roll The Dice Online | {brand}',
        description: 'Roll The Dice by Booming Games at {brand} crypto casino. Medium volatility. Play with Bitcoin, ETH, USDT. Fast crypto payouts.'
    },
    '/p/boominggames/ronaldinho_scores_shoot_and_win': {
        title: 'Ronaldinho Scores Shoot and Win | {brand}',
        description: 'Play Ronaldinho Scores Shoot and Win by Booming Games. 4,500x max win, Fireball multiplier, high volatility. Bitcoin deposits.'
    },
    '/p/boominggames/ronaldinho_spins': {
        title: 'Ronaldinho Spins | 5,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit BTC and play Ronaldinho Spins at {brand}. 5,000x max win, medium volatility, Expanding Wilds. 9 cryptos, zero fees.'
    },
    '/p/boominggames/royal_wins': {
        title: 'Play Royal Wins Slot | 0.0x Payout | {brand}',
        description: 'Play Royal Wins by Booming Games. Medium volatility, 0.0x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/boominggames/santa_in_vegas': {
        title: 'Play Santa in Vegas | 8,000x Max Win | {brand}',
        description: 'Santa in Vegas slot at {brand} crypto casino. High volatility, 8,000x max win with Santa Cash Collect. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/boominggames/santas_snowball_smash_instant_win': {
        title: 'Play Santas Snowball Smash Instant Win Slot with Bitcoin | {brand}',
        description: 'Santas Snowball Smash Instant Win by Booming Games at {brand} crypto casino. Medium volatility. Play with Bitcoin, ETH, USDT. Fast crypto payouts.'
    },
    '/p/boominggames/secret_book_of_amun_ra': {
        title: 'Secret Book of Amun Ra Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit BTC and play Secret Book of Amun Ra at {brand}. 10,000x max win, high volatility, Free Spins with Expanding s. 9 cryptos, zero fees.'
    },
    '/p/boominggames/shields_of_gold_valkyrie_hold_and_win': {
        title: 'Shields of Gold Valkyrie Hold and Win | {brand}',
        description: 'Shields of Gold Valkyrie Hold and Win at {brand} crypto casino. 2,200x max win with Wild Transform with Hold an. Play with BTC, ETH, USDT.'
    },
    '/p/boominggames/smoking_pistols': {
        title: 'Smoking Pistols Slot | 5,000x Win | Play with Bitcoin',
        description: 'Play Smoking Pistols by Booming Games. 5,000x max win, Charged Wilds, medium volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/boominggames/space_cows_to_the_moon': {
        title: "Space Cows to the Moo'n Slot | 5,000x Win | {brand}",
        description: "Space Cows to the Moo'n slot with 5,000x max win and Beaming Wilds. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts."
    },
    '/p/boominggames/space_sam_walk_and_win': {
        title: 'Play Space Sam Walk and Win Slot | 7,500x Payout | {brand}',
        description: 'Spin Space Sam Walk and Win with Bitcoin at {brand}. 7,500x max win, high volatility, Sun Collect (cash Collect). Instant payouts.'
    },
    '/p/boominggames/spooktacular_bonanza': {
        title: 'Spooktacular Bonanza Slot | Win Up to 6,500x | {brand}',
        description: 'Play Spooktacular Bonanza slot for real money. 6,500x max win, Scatter Pays. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/boominggames/stampede_bonanza': {
        title: 'Stampede Bonanza | 7,500x Max Win Bitcoin Slot | {brand}',
        description: 'Stampede Bonanza slot with 7,500x max win and Wild collect. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/boominggames/super_duper': {
        title: 'Super Duper | 0.0x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Super Duper at {brand}. 0.0x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/boominggames/tasty_bonanza': {
        title: 'Tasty Bonanza Slot | 6,500x Win | Play with Bitcoin',
        description: 'Spin Tasty Bonanza with Bitcoin at {brand}. 6,500x max win, high volatility, Cascading Reels. Instant payouts, zero platform fees.'
    },
    '/p/boominggames/tasty_bonanza_1000': {
        title: 'Tasty Bonanza 1,000 Slot | 10,000x Win | Play with Bitcoin',
        description: 'Tasty Bonanza 1,000 slot with 10,000x max win and Cascading Reels. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/boominggames/the_chillies': {
        title: 'The Chillies Slot | 4,000x Win | Play with Bitcoin',
        description: 'Spin The Chillies with Bitcoin at {brand}. 4,000x max win, high volatility, Waling Wild Respins with Mu. Instant payouts, zero platform fees.'
    },
    '/p/boominggames/the_mighty_toro': {
        title: 'Play The Mighty Toro Slot | 6,500x Payout | {brand}',
        description: 'Spin The Mighty Toro with Bitcoin at {brand}. 6,500x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/boominggames/the_wild_wings_of_phoenix': {
        title: 'The Wild Wings of Phoenix | 1,200x Max Win Bitcoin Slot | {brand}',
        description: 'Spin The Wild Wings of Phoenix with Bitcoin at {brand}. 1,200x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/boominggames/the_wild_wings_of_phoenix_deluxe': {
        title: 'The Wild Wings of Phoenix Deluxe | {brand}',
        description: 'Spin The Wild Wings of Phoenix Deluxe with Bitcoin at {brand}. 5,000x max win, medium volatility, Expanding Wilds. Instant payouts.'
    },
    '/p/boominggames/thunder_eagle_hold_and_win_10000': {
        title: 'Play Thunder Eagle Hold and Win 10000 | 12,000x Win | {brand}',
        description: 'Thunder Eagle Hold and Win 10000 at {brand} crypto casino. 12,000x max win with Thunder Eagle Bonus with Wh. Play with BTC, ETH, USDT.'
    },
    '/p/boominggames/tnt_bonanza': {
        title: 'TNT Bonanza | 2,000x Max Win Crypto Slot | {brand}',
        description: 'TNT Bonanza slot at {brand} crypto casino. Medium volatility with 2,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/boominggames/tnt_bonanza_2': {
        title: 'TNT Bonanza 2 Slot | 6,500x Max Win | {brand}',
        description: 'Play TNT Bonanza 2 by Booming Games. 6,500x max win, Scatter Pays, high volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/boominggames/treasure_vault': {
        title: 'Play Treasure Vault | 1,200x Max Win | {brand}',
        description: 'Play Treasure Vault slot for real money at {brand}. 1,200x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/boominggames/trollfufu_bonanza': {
        title: 'Trollfufu Bonanza Slot | 6,500x Win | Play with Bitcoin',
        description: 'Spin Trollfufu Bonanza with Bitcoin at {brand}. 6,500x max win, high volatility, Cascading Reels. Instant payouts, zero platform fees.'
    },
    '/p/boominggames/ultimate_hold_n_win': {
        title: "Ultimate Hold 'N' Win | 5,000x Max Win Bitcoin Slot | {brand}",
        description: "Spin Ultimate Hold 'N' Win with Bitcoin at {brand}. 5,000x max win, high volatility, Bursting Wilds. Instant payouts, zero platform fees."
    },
    '/p/boominggames/vegas_wins': {
        title: 'Play Vegas Wins | 1,200x Max Win | {brand}',
        description: 'Vegas Wins at {brand}. Medium volatility, 1,200x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/boominggames/vip_filthy_riches': {
        title: 'Play Vip Filthy Riches Slot with Bitcoin | {brand}',
        description: 'Play Vip Filthy Riches by Booming Games with Bitcoin at {brand}. Medium volatility. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/boominggames/wild_diamond_7x': {
        title: 'Wild Diamond 7x Slot | 1,200x Win | Play with Bitcoin',
        description: 'Spin Wild Diamond 7x with Bitcoin at {brand}. 1,200x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/boominggames/wild_wild_vegas': {
        title: 'Play Wild Wild Vegas | 2,000x Max Win | {brand}',
        description: 'Wild Wild Vegas slot at {brand} crypto casino. Medium volatility with 2,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/fantasma/alice_in_adventureland': {
        title: 'Alice in Adventureland | 10,006x Max Win Crypto Slot | {brand}',
        description: 'Alice in Adventureland at {brand}. Medium volatility, 10,006x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/fantasma/animal_carnival': {
        title: 'Animal Carnival Slot | 1,642x Win | Play with Bitcoin',
        description: 'Play Animal Carnival by Fantasma Games. Medium volatility, 1,642x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/fantasma/bounty_showdown': {
        title: 'Bounty Showdown Slot | 4,761x Max Win | {brand}',
        description: 'Play Bounty Showdown by Fantasma Games at {brand}. Medium volatility, 4,761x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/fantasma/caravan_of_riches': {
        title: 'Caravan of Riches | 1,312x Max Win Bitcoin Slot | {brand}',
        description: 'Caravan of Riches slot with 1,312x max win. Medium volatility by Fantasma Games. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/fantasma/circle_of_sylvan': {
        title: 'Circle of Sylvan Slot | Win Up to 5,000x | {brand}',
        description: 'Circle of Sylvan at {brand} crypto casino. 5,000x max win with Jackpot Prizes. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/fantasma/desert_shark': {
        title: 'Desert Shark Slot | 16,794x Max Win | {brand}',
        description: 'Play Desert Shark by Fantasma Games at {brand}. Medium volatility, 16,794x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/fantasma/elemento': {
        title: 'Elemento Slot | 17,955x Max Win | {brand}',
        description: 'Elemento by Fantasma Games. Medium volatility slot with 17,955x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/fantasma/flower_fortunes_supreme': {
        title: 'Flower Fortunes Supreme Slot | Win Up to 7,075x | {brand}',
        description: 'Play Flower Fortunes Supreme slot for real money at {brand}. 7,075x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/fantasma/fortune_llama': {
        title: 'Play Fortune Llama Slot with Bitcoin | {brand}',
        description: 'Fortune Llama by Fantasma Games at {brand} crypto casino. Medium volatility. Play with Bitcoin, ETH, USDT. Fast crypto payouts.'
    },
    '/p/fantasma/golden_castle_titanways': {
        title: 'Play Golden Castle TitanWays Slot | 20,000x Payout | {brand}',
        description: 'Play Golden Castle TitanWays by Fantasma Games. Medium volatility, 20,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/fantasma/hades_river_of_souls': {
        title: 'Play Hades River Of Souls Online | {brand}',
        description: 'Spin Hades River Of Souls with crypto at {brand}. Medium volatility by Fantasma Games. Instant withdrawals, no fees. BTC, ETH, USDT accepted.'
    },
    '/p/fantasma/heroes_hunt_2': {
        title: 'Heroes Hunt 2 | 20,000x Max Win Bitcoin Slot | {brand}',
        description: 'Heroes Hunt 2 by Fantasma Games. Medium volatility slot with 20,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/fantasma/heroes_hunt_megaways': {
        title: 'Heroes Hunt MegaWays Slot | 36,274x Max Win | {brand}',
        description: 'Play Heroes Hunt MegaWays by Fantasma Games. Medium volatility, 36,274x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/fantasma/magikspell': {
        title: 'Magikspell Slot | 20,000x Max Win | {brand}',
        description: 'Spin Magikspell with Bitcoin at {brand}. 20,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/fantasma/maze_escape_megaways': {
        title: 'Play Maze Escape MegaWays | 25,000x Win | {brand}',
        description: 'Maze Escape MegaWays slot at {brand} crypto casino. Medium volatility with 25,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/fantasma/medallion_megaways': {
        title: 'Play Medallion MegaWays | 20,000x Win | {brand}',
        description: 'Play Medallion MegaWays slot for real money at {brand}. 20,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/fantasma/mystic_spells': {
        title: 'Mystic Spells Slot | 10,000x Max Win | {brand}',
        description: 'Play Mystic Spells by Fantasma Games at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/fantasma/pirate_multi_coins': {
        title: 'Pirate Multi Coins | 4,999x Max Win Crypto Slot | {brand}',
        description: 'Pirate Multi Coins at {brand} crypto casino. 4,999x max win with Multi Coins Feature. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/fantasma/rich_raptors': {
        title: 'Play Rich Raptors | 8,024x Max Win | {brand}',
        description: 'Play Rich Raptors at {brand} crypto casino. Medium volatility, 8,024x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/fantasma/safari_sun': {
        title: 'Safari Sun Slot | 18,792x Win | Play with Bitcoin',
        description: 'Safari Sun slot with 18,792x max win and Expanding Symbol Feature. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/fantasma/serpent_shrine': {
        title: 'Play Serpent Shrine Slot | 10,013x Payout | {brand}',
        description: 'Serpent Shrine slot with 10,013x max win. Medium volatility by Fantasma Games. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/fantasma/shadow_summoner_elementals': {
        title: 'Shadow Summoner Elementals Slot | Win Up to 5,610x | {brand}',
        description: 'Play Shadow Summoner Elementals slot for real money. 5,610x max win, Multiplier. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/fantasma/twisted_turbine': {
        title: 'Twisted Turbine Slot | Win Up to 9,616x | {brand}',
        description: 'Twisted Turbine at {brand}. Medium volatility, 9,616x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/fantasma/wins_of_mermaid_multi_power': {
        title: 'Wins of Mermaid Multi Power Slot | 10,000x Win | {brand}',
        description: 'Spin Wins of Mermaid Multi Power with Bitcoin at {brand}. 10,000x max win, high volatility, Power Bomb. Instant payouts, zero platform fees.'
    },
    '/p/fantasma/wins_of_winter': {
        title: 'Wins of Winter | 5,000x Max Win Bitcoin Slot | {brand}',
        description: 'Wins of Winter by Fantasma Games. Medium volatility slot with 5,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/apocalypse_super_xnudge': {
        title: 'Play Apocalypse Slot | 20,000x Payout | {brand}',
        description: 'Spin Apocalypse with Bitcoin at {brand}. 20,000x max win, high volatility, xNudge Wild. Instant payouts, zero platform fees.'
    },
    '/p/nolimit-city/bangkok_hilton': {
        title: 'Bangkok Hilton | 44,444x Max Win Crypto Slot | {brand}',
        description: 'Bangkok Hilton at {brand} crypto casino. 44,444x max win with xWays. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/barbarian_fury': {
        title: 'Play Barbarian Fury Slot | 10,000x Payout | {brand}',
        description: 'Play Barbarian Fury by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/beheaded': {
        title: 'Play Beheaded | 15,950x Max Win | {brand}',
        description: 'Beheaded slot at {brand} crypto casino. High volatility, 15,950x max win with Cut Reel. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/benji_killed_in_vegas': {
        title: 'Benji Killed in Vegas Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Benji Killed in Vegas by Nolimit City at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/bizarre': {
        title: 'Play Bizarre Slot | 20,000x Payout | {brand}',
        description: 'Spin Bizarre with Bitcoin at {brand}. 20,000x max win, high volatility, xSplit. Instant payouts, zero platform fees.'
    },
    '/p/nolimit-city/blood_and_shadow': {
        title: 'Blood & Shadow Slot | 6,666x Win | Play with Bitcoin',
        description: 'Blood & Shadow by Nolimit City. Medium volatility slot with 6,666x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/blood_and_shadow_2': {
        title: 'Blood and Shadow 2 | 16,161x Max Win Crypto Slot | {brand}',
        description: 'Blood and Shadow 2 at {brand} crypto casino. 16,161x max win with Reel Area. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/blood_diamond': {
        title: 'Play Blood Diamond Slot | 14,780x Payout | {brand}',
        description: 'Play Blood Diamond by Nolimit City at {brand}. High volatility, 14,780x max win, Stacked Symbols. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/bonus_bunnies': {
        title: 'Play Bonus Bunnies | 6,925x Win | {brand}',
        description: 'Bonus Bunnies at {brand}. Medium volatility, 6,925x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/book_of_shadows': {
        title: 'Book Of Shadows Slot | 30,338x Win | Play with Bitcoin',
        description: 'Book Of Shadows slot with 30,338x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/bounty_hunters': {
        title: 'Play Bounty Hunters Slot | 10,000x Payout | {brand}',
        description: 'Bounty Hunters slot with 10,000x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/breakout': {
        title: 'Play Breakout Slot | 20,000x Payout | {brand}',
        description: 'Breakout by Nolimit City. Medium volatility slot with 20,000x max win and Syndicate Multiplier. Play with Bitcoin at {brand}. Fast withdrawals.'
    },
    '/p/nolimit-city/brick_snake_2000': {
        title: 'Brick Snake 2000 Slot | 10,000x Max Win | {brand}',
        description: 'Spin Brick Snake 2000 with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/nolimit-city/brute_force': {
        title: 'Play Brute Force | 40,000x Max Win | {brand}',
        description: 'Brute Force at {brand} crypto casino. 40,000x max win with xNudge Wilds. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/brute_force_alien_onslaught': {
        title: 'Play Brute Force: Alien Onslaught | 80,000x Max Win | {brand}',
        description: 'Brute Force: Alien Onslaught slot at {brand} crypto casino. High volatility, 80,000x max win with xNudge. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/buffalo_hunter': {
        title: 'Buffalo Hunter Slot | Win Up to 12,647x | {brand}',
        description: 'Deposit Bitcoin and play Buffalo Hunter at {brand}. 12,647x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/bushido_way_xnudge': {
        title: 'Bushido Way xNudge Slot | Win Up to 30,000x | {brand}',
        description: 'Play Bushido Way xNudge slot for real money at {brand}. 30,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/casino_win_spin': {
        title: 'Play Casino Win Spin Slot | 2,000x Payout | {brand}',
        description: 'Play Casino Win Spin by Nolimit City at {brand}. Medium volatility, 2,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/catfish_hunters': {
        title: 'Play Catfish Hunters | 20,000x Max Win | {brand}',
        description: 'Play Catfish Hunters at {brand}. High volatility, 20,000x max win. Features xWays. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/coins_of_fortune': {
        title: 'Coins of Fortune | 2,700x Max Win Crypto Slot | {brand}',
        description: 'Play Coins of Fortune at {brand} crypto casino. Medium volatility, 2,700x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/crazy_ex_girlfriend': {
        title: 'Crazy Ex Girlfriend Slot | Win Up to 9,999x | {brand}',
        description: 'Crazy Ex Girlfriend slot at {brand} crypto casino. High volatility, 9,999x max win with xSplit. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/d_day': {
        title: 'D Day Slot | 10,000x Win | Play with Bitcoin',
        description: 'D Day by Nolimit City. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/das_xboot': {
        title: 'Das XBoot 2 Slot | 59,999x Win | Play with Bitcoin',
        description: 'Play Das XBoot 2 by Nolimit City at {brand}. High volatility, 59,999x max win, xBomb. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/dead_canary': {
        title: 'Dead Canary Slot | 65,000x Max Win | {brand}',
        description: 'Dead Canary slot with 65,000x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/dead_dead_or_deader': {
        title: 'Dead Dead or Deader | 19,349x Max Win Bitcoin Slot | {brand}',
        description: 'Play Dead Dead or Deader by Nolimit City at {brand}. High volatility, 19,349x max win, Wild. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/dead_men_walking': {
        title: 'Dead Men Walking Slot | 25,313x Win | Play with Bitcoin',
        description: 'Dead Men Walking by Nolimit City. High volatility slot with 25,313x max win and xNudge. Play with Bitcoin at {brand}. Fast withdrawals.'
    },
    '/p/nolimit-city/deadwood_rip': {
        title: 'Deadwood RIP Slot | 100,000x Max Win | {brand}',
        description: 'Play Deadwood RIP by Nolimit City. 100,000x max win, Fifth Reel, high volatility. Bitcoin deposits, instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/deadwood_xnudge': {
        title: 'Deadwood xNudge Slot | 13,950x Win | Play with Bitcoin',
        description: 'Spin Deadwood xNudge with Bitcoin at {brand}. 13,950x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/nolimit-city/devils_crossroad': {
        title: 'Play Devils Crossroad | 10,000x Win | {brand}',
        description: 'Devils Crossroad at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/disorder': {
        title: 'Disorder Slot | Win Up to 23,500x | {brand}',
        description: 'Disorder at {brand} crypto casino. 23,500x max win with XBomb. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/disturbed': {
        title: 'Disturbed Slot | Win Up to 10,000x | {brand}',
        description: 'Play Disturbed slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/dj_psycho': {
        title: 'Dj Psycho | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Dj Psycho slot with 10,000x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/dragon_tribe': {
        title: 'Play Dragon Tribe | 27,000x Max Win | {brand}',
        description: 'Play Dragon Tribe slot for real money at {brand}. 27,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/duck_hunters': {
        title: 'Duck Hunters Happy Hour Slot | 33,333x Win | {brand}',
        description: 'Duck Hunters Happy Hour slot with 33,333x max win and xWays. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/nolimit-city/dungeon_quest': {
        title: 'Dungeon Quest | 450x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Dungeon Quest with Bitcoin at {brand}. 450x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/nolimit-city/east_coast_vs_west_coast': {
        title: 'East Coast Vs West Coast | 30,618x Max Win Bitcoin Slot | {brand}',
        description: 'East Coast Vs West Coast by Nolimit City. Medium volatility slot with 30,618x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/el_paso_gunfight_xnudge': {
        title: 'El Paso Gunfight xNudge Slot | Win Up to 44,440x | {brand}',
        description: 'El Paso Gunfight xNudge slot at {brand} crypto casino. Medium volatility with 44,440x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/nolimit-city/evil_goblins_xbomb': {
        title: 'Play Evil Goblins Xbomb | 10,000x Win | {brand}',
        description: 'Evil Goblins Xbomb at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/fire_in_the_hole_2': {
        title: 'Play Fire In The Hole 2 | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Fire In The Hole 2 at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/fire_in_the_hole_3': {
        title: 'Fire in the Hole 3 Slot | 70,000x Max Win | {brand}',
        description: 'Fire in the Hole 3 slot with 70,000x max win and Collapsing Mine. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/nolimit-city/fire_in_the_hole_xbomb': {
        title: 'Play Fire In The Hole xBomb | 60,000x Win | {brand}',
        description: 'Fire In The Hole xBomb at {brand}. Medium volatility, 60,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/flight_mode': {
        title: 'Play Flight Mode | 5,051x Win | {brand}',
        description: 'Play Flight Mode at {brand}. High volatility, 5,051x max win. Features xGod. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/folsom_prison': {
        title: 'Play Folsom Prison | 75,000x Win | {brand}',
        description: 'Folsom Prison slot at {brand} crypto casino. Medium volatility with 75,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/nolimit-city/fruits': {
        title: 'Play Fruits Slot | 2,910x Payout | {brand}',
        description: 'Play Fruits by Nolimit City. Medium volatility, 2,910x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/gaelic_gold': {
        title: 'Play Gaelic Gold | 9,837x Win | {brand}',
        description: 'Gaelic Gold at {brand}. Medium volatility, 9,837x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/gluttony': {
        title: 'Play Gluttony | 10,000x Win | {brand}',
        description: 'Gluttony slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/nolimit-city/golden_genie_and_the_walking_wilds': {
        title: 'Play Golden Genie And The Walking Wilds | 9,583x Win | {brand}',
        description: 'Play Golden Genie And The Walking Wilds slot for real money at {brand}. 9,583x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/golden_shower': {
        title: 'Golden Shower Slot | Win Up to 19,999x | {brand}',
        description: 'Golden Shower at {brand} crypto casino. 19,999x max win with Drain. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/harlequin_carnival': {
        title: 'Harlequin Carnival | 5,861x Max Win Crypto Slot | {brand}',
        description: 'Play Harlequin Carnival slot for real money at {brand}. 5,861x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/highway_to_hell': {
        title: 'Play Highway to Hell Slot | 20,066x Payout | {brand}',
        description: 'Play Highway to Hell by Nolimit City at {brand}. High volatility, 20,066x max win, xBet. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/home_of_the_brave': {
        title: 'Play Home of the Brave | 61,446x Max Win | {brand}',
        description: 'Deposit BTC and play Home of the Brave at {brand}. 61,446x max win, high volatility, Hot Sauce Reels. 9 cryptos, zero fees.'
    },
    '/p/nolimit-city/hot_4_cash': {
        title: 'Hot 4 Cash Slot | Win Up to 2,400x | {brand}',
        description: 'Hot 4 Cash at {brand}. Medium volatility, 2,400x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/hot_nudge': {
        title: 'Hot Nudge Slot | 10,000x Win | Play with Bitcoin',
        description: 'Hot Nudge by Nolimit City. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/ice_ice_yeti': {
        title: 'Ice Ice Yeti | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Ice Ice Yeti by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/immortal_fruits': {
        title: 'Immortal Fruits Slot | 2,787x Max Win | {brand}',
        description: 'Play Immortal Fruits by Nolimit City. Medium volatility, 2,787x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/infectious_5_xways': {
        title: 'Play Infectious 5 xWays | 55,555x Max Win | {brand}',
        description: 'Deposit Bitcoin and play Infectious 5 xWays at {brand}. 55,555x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/jingle_balls': {
        title: 'Jingle Balls | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Jingle Balls at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/karen_maneater': {
        title: 'Karen Maneater Slot | 11,757x Win | Play with Bitcoin',
        description: 'Karen Maneater slot with 11,757x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/kenneth_must_die': {
        title: 'Play Kenneth Must Die | 10,000x Win | {brand}',
        description: 'Play Kenneth Must Die slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/kill_em_all': {
        title: 'Kill Em All Slot | 11,916x Max Win | {brand}',
        description: 'Spin Kill Em All with Bitcoin at {brand}. 11,916x max win, high volatility, Hack and Slash. Instant payouts, zero platform fees.'
    },
    '/p/nolimit-city/kiss_my_chainsaw': {
        title: 'Play Kiss My Chainsaw | 10,000x Max Win | {brand}',
        description: 'Play Kiss My Chainsaw slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/kitchen_drama_bbq_frenzy': {
        title: 'Kitchen Drama Bbq Frenzy | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Kitchen Drama Bbq Frenzy by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/kitchen_drama_sushi_mania': {
        title: 'Play Kitchen Drama Sushi Mania | 10,000x Win | {brand}',
        description: 'Play Kitchen Drama Sushi Mania at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/land_of_the_free': {
        title: 'Land Of The Free Slot | Win Up to 10,000x | {brand}',
        description: 'Play Land Of The Free slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/legion_x': {
        title: 'Legion X Slot | 31,000x Max Win | {brand}',
        description: 'Legion X slot with 31,000x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/little_bighorn': {
        title: 'Play Little Bighorn | 25,676x Win | {brand}',
        description: 'Little Bighorn at {brand}. Medium volatility, 25,676x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/loner': {
        title: 'Loner | 14,999x Max Win Crypto Slot | {brand}',
        description: 'Play Loner slot for real money. 14,999x max win, Monitors. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/nolimit-city/manhattan_goes_wild': {
        title: 'Play Manhattan Goes Wild | 2,025x Win | {brand}',
        description: 'Play Manhattan Goes Wild slot for real money at {brand}. 2,025x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/mayan_magic_wildfire': {
        title: 'Play Mayan Magic Wildfire Slot | 1,264x Payout | {brand}',
        description: 'Mayan Magic Wildfire slot with 1,264x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/mental': {
        title: 'Mental Slot | 66,666x Win | Play with Bitcoin',
        description: 'Mental slot with 66,666x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/mental_2': {
        title: 'Play Mental 2 | 99,999x Win | {brand}',
        description: 'Deposit BTC and play Mental 2 at {brand}. 99,999x max win, high volatility, Fire Frames and Fire Reels. 9 cryptos, zero fees.'
    },
    '/p/nolimit-city/milky_ways': {
        title: 'Milky Ways | 5,664x Max Win Bitcoin Slot | {brand}',
        description: 'Milky Ways slot with 5,664x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/misery_mining': {
        title: 'Play Misery Mining | 70,000x Max Win | {brand}',
        description: 'Play Misery Mining at {brand} crypto casino. Medium volatility, 70,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/monkeys_gold_xpays': {
        title: "Monkey's Gold xPays Slot | 12,683x Max Win | {brand}",
        description: "Spin Monkey's Gold xPays with Bitcoin at {brand}. 12,683x max win, medium volatility. Instant crypto withdrawals, zero platform fees."
    },
    '/p/nolimit-city/nine_to_five': {
        title: 'Nine To Five | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Nine To Five slot with 10,000x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/oktoberfest': {
        title: 'Oktoberfest | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Oktoberfest at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/outsourced_payday': {
        title: 'Outsourced Payday Slot | Win Up to 10,000x | {brand}',
        description: 'Outsourced Payday slot at {brand} crypto casino. Medium volatility, 10,000x max win with Claw Machine. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/outsourced_slash_game': {
        title: 'Outsourced Slash Game Slot | Win Up to 1,500x | {brand}',
        description: 'Outsourced Slash Game slot at {brand} crypto casino. Medium volatility, 1,500x max win with Slash Game. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/owls': {
        title: 'Play Owls Slot | 1,370x Payout | {brand}',
        description: 'Spin Owls with Bitcoin at {brand}. 1,370x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/nolimit-city/pearl_harbor': {
        title: 'Pearl Harbor | 41,127x Max Win Bitcoin Slot | {brand}',
        description: 'Play Pearl Harbor by Nolimit City. Medium volatility, 41,127x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/pixies_vs_pirates': {
        title: 'Play Pixies vs Pirates Slot | 11,907x Payout | {brand}',
        description: 'Play Pixies vs Pirates by Nolimit City at {brand}. Medium volatility, 11,907x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/poison_eve': {
        title: 'Poison Eve | 6,091x Max Win Bitcoin Slot | {brand}',
        description: 'Poison Eve by Nolimit City. Medium volatility slot with 6,091x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/possessed': {
        title: 'Possessed | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Possessed by Nolimit City at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/punk_rocker': {
        title: 'Play Punk Rocker 3 Slot | 19,089x Payout | {brand}',
        description: 'Play Punk Rocker 3 by Nolimit City at {brand}. High volatility, 19,089x max win, xWays. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/punk_rocker_2': {
        title: 'Play Punk Rocker 2 | 30,141x Win | {brand}',
        description: 'Play Punk Rocker 2 at {brand}. High volatility, 30,141x max win. Features Riot Respins. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/punk_toilet': {
        title: 'Play Punk Toilet | 33,333x Win | {brand}',
        description: 'Play Punk Toilet slot for real money at {brand}. 33,333x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/remember_gulag': {
        title: 'Play Remember Gulag | 30,000x Max Win | {brand}',
        description: 'Remember Gulag slot at {brand} crypto casino. Medium volatility with 30,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/nolimit-city/road_kill': {
        title: 'Road Kill | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Play Road Kill by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/road_rage': {
        title: 'Play Road Rage | 36,000x Win | {brand}',
        description: 'Play Road Rage slot for real money at {brand}. 36,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/rock_bottom': {
        title: 'Rock Bottom Slot | 19,690x Win | Play with Bitcoin',
        description: 'Spin Rock Bottom with Bitcoin at {brand}. 19,690x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/nolimit-city/san_quentin_2_death_row': {
        title: 'San Quentin 2 Death Row | 200,000x Max Win Crypto Slot | {brand}',
        description: 'San Quentin 2 Death Row at {brand} crypto casino. 200,000x max win with Enhancer Cells. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/nolimit-city/san_quentin_xways': {
        title: 'Play San Quentin xWays | 150,000x Max Win | {brand}',
        description: 'San Quentin xWays at {brand}. Medium volatility, 150,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/serial': {
        title: 'Play Serial | 10,000x Max Win | {brand}',
        description: 'Serial at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/skate_or_die': {
        title: 'Skate or Die Slot | 30,000x Win | Play with Bitcoin',
        description: 'Play Skate or Die by Nolimit City at {brand}. High volatility, 30,000x max win, Extra Sauce Row. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/space_donkey': {
        title: 'Space Donkey Slot | 10,000x Win | Play with Bitcoin',
        description: 'Play Space Donkey by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/starstruck': {
        title: 'Starstruck Slot | Win Up to 1,636x | {brand}',
        description: 'Starstruck slot at {brand} crypto casino. Medium volatility with 1,636x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/nolimit-city/stockholm_syndrome': {
        title: 'Play Stockholm Syndrome | 28,873x Win | {brand}',
        description: 'Play Stockholm Syndrome at {brand}. High volatility, 28,873x max win. Features Con Man Wild. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/supersized': {
        title: 'Supersized Slot | Win Up to 12,345x | {brand}',
        description: 'Play Supersized at {brand}. High volatility, 12,345x max win. Features Clone. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/tesla_jolt': {
        title: 'Tesla Jolt Slot | 582x Win | Play with Bitcoin',
        description: 'Tesla Jolt by Nolimit City. Medium volatility slot with 582x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/the_border': {
        title: 'Play The Border | 44,288x Win | {brand}',
        description: 'Play The Border slot for real money at {brand}. 44,288x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/the_cage': {
        title: 'Play The Cage | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play The Cage at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/the_creepy_carnival': {
        title: 'The Creepy Carnival Slot | 798x Max Win | {brand}',
        description: 'Play The Creepy Carnival by Nolimit City at {brand}. Medium volatility, 798x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/the_crypt': {
        title: 'The Crypt 2 | 31,248x Max Win Crypto Slot | {brand}',
        description: 'Play The Crypt 2 at {brand}. High volatility, 31,248x max win. Features Reel Area. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/the_rave': {
        title: 'Play The Rave | 41,500x Max Win | {brand}',
        description: 'Play The Rave at {brand} crypto casino. Medium volatility, 41,500x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/thor_hammer_time': {
        title: 'Thor: Hammer Time | 2,328x Max Win Crypto Slot | {brand}',
        description: 'Play Thor: Hammer Time slot for real money at {brand}. 2,328x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/tomb_of_akhenaten': {
        title: 'Play Tomb of Akhenaten | 26,261x Max Win | {brand}',
        description: 'Tomb of Akhenaten at {brand}. Medium volatility, 26,261x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/tomb_of_nefertiti': {
        title: 'Tomb of Nefertiti | 3,768x Max Win Bitcoin Slot | {brand}',
        description: 'Tomb of Nefertiti slot with 3,768x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/tombstone': {
        title: 'Tombstone Slot | 11,456x Win | Play with Bitcoin',
        description: 'Tombstone slot with 11,456x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/tombstone_no_mercy': {
        title: 'Play Tombstone No Mercy | 10,000x Win | {brand}',
        description: 'Tombstone No Mercy at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/nolimit-city/tombstone_rip': {
        title: 'Play Tombstone RIP Slot | 300,000x Payout | {brand}',
        description: 'Tombstone RIP by Nolimit City. Medium volatility slot with 300,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/tombstone_slaughter_el_gordos_revenge': {
        title: "Tombstone Slaughter: El Gordo's Revenge Slot | {brand}",
        description: "Spin Tombstone Slaughter: El Gordo's Revenge with Bitcoin at {brand}. 500,000x max win, high volatility, Reel Setup. Instant payouts, zero platform fees."
    },
    '/p/nolimit-city/tractor_beam': {
        title: 'Play Tractor Beam Slot | 3,408x Payout | {brand}',
        description: 'Play Tractor Beam by Nolimit City. Medium volatility, 3,408x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/true_grit_redemption': {
        title: 'True Grit Redemption Slot | 20,220x Max Win | {brand}',
        description: 'Play True Grit Redemption by Nolimit City at {brand}. Medium volatility, 20,220x max win. 9 cryptos accepted, instant withdrawals, no fees.'
    },
    '/p/nolimit-city/true_kult': {
        title: 'True Kult Slot | 10,000x Max Win | {brand}',
        description: 'Play True Kult by Nolimit City. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}.'
    },
    '/p/nolimit-city/tsar_wars': {
        title: 'Play Tsar Wars | 19,755x Win | {brand}',
        description: 'Tsar Wars slot at {brand} crypto casino. High volatility, 19,755x max win with xBomb. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/nolimit-city/ugliest_catch': {
        title: 'Ugliest Catch Slot | 10,000x Max Win | {brand}',
        description: 'Ugliest Catch by Nolimit City. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals.'
    },
    '/p/nolimit-city/walk_of_shame': {
        title: 'Play Walk of Shame | 9,822x Max Win | {brand}',
        description: 'Deposit Bitcoin and play Walk of Shame at {brand}. 9,822x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/nolimit-city/warrior_graveyard_xnudge': {
        title: 'Warrior Graveyard Xnudge Slot | Win Up to 10,000x | {brand}',
        description: 'Play Warrior Graveyard Xnudge at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/nolimit-city/whacked': {
        title: 'Play Whacked Online | {brand}',
        description: 'Whacked by Nolimit City at {brand} crypto casino. Medium volatility. Play with Bitcoin, ETH, USDT. Fast crypto payouts.'
    },
    '/p/nolimit-city/wixx': {
        title: 'Play WiXX | 1,398x Max Win | {brand}',
        description: 'Play WiXX slot for real money at {brand}. 1,398x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/nolimit-city/xways_hoarder_2': {
        title: 'XWays Hoarder 2 | 25,920x Max Win Bitcoin Slot | {brand}',
        description: 'Play XWays Hoarder 2 by Nolimit City at {brand}. High volatility, 25,920x max win, xWays. 9 cryptos accepted, instant withdrawals.'
    },
    '/p/nolimit-city/xways_hoarder_xsplit': {
        title: 'xWays Hoarder xSplit Slot | 11,030x Max Win | {brand}',
        description: 'xWays Hoarder xSplit slot with 11,030x max win. Medium volatility by Nolimit City. Play with crypto at {brand}. Instant withdrawals.'
    },
    '/p/play-n-go/1001_mystery_genie_fortunes': {
        title: 'Play 1001 Mystery Genie Fortunes | 1,234x Max Win | {brand}',
        description: '1001 Mystery Genie Fortunes at {brand} crypto casino. 1,234x max win with Mystery Symbols. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/play-n-go/13th_trial_hercules_abyssways': {
        title: 'Play 13th Trial Hercules Abyssways | 60,000x Win | {brand}',
        description: 'Play 13th Trial Hercules Abyssways slot for real money. 60,000x max win, Wild of Zeus. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/play-n-go/15_crystal_roses_a_tale_of_love': {
        title: '15 Crystal Roses A Tale Of Love | {brand}',
        description: 'Play 15 Crystal Roses A Tale Of Love slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/24k_dragon': {
        title: '24k Dragon Slot | 10,000x Win | Play with Bitcoin',
        description: "24k Dragon by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/3_blades_and_blessings': {
        title: 'Play 3 Blades and Blessings | 4,000x Win | {brand}',
        description: '3 Blades and Blessings at {brand} crypto casino. 4,000x max win with Perceived Coin Collection. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/play-n-go/3_clown_monty': {
        title: '3 Clown Monty Slot | 10,000x Max Win | {brand}',
        description: "Play 3 Clown Monty by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/3_clown_monty_ii': {
        title: 'Play 3 Clown Monty II | 500x Win | {brand}',
        description: 'Deposit BTC and play 3 Clown Monty II at {brand}. 500x max win, high volatility, Wilds. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/3_hand_casino': {
        title: '3 Hand Casino Slot | 10,000x Win | Play with Bitcoin',
        description: "3 Hand Casino slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/5x_magic': {
        title: '5x Magic | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "5x Magic by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/7_sins': {
        title: '7 Sins Slot | 10,000x Max Win | {brand}',
        description: "7 Sins slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/ace_of_spades': {
        title: 'Play Ace Of Spades | 10,000x Win | {brand}',
        description: 'Ace Of Spades at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/agent_destiny': {
        title: 'Agent Destiny Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit Bitcoin and play Agent Destiny at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/agent_of_hearts': {
        title: 'Agent Of Hearts Slot | 10,000x Max Win | {brand}',
        description: "Play Agent Of Hearts by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/animal_madness': {
        title: 'Play Animal Madness | 10,000x Max Win | {brand}',
        description: 'Animal Madness slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/ankh_of_anubis': {
        title: 'Play Ankh Of Anubis Slot | 10,000x Payout | {brand}',
        description: "Play Ankh Of Anubis by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/ankh_of_anubis_awakening': {
        title: 'Ankh of Anubis Awakening Slot | 10,000x Win | {brand}',
        description: "Ankh of Anubis Awakening by Play'n GO. Medium volatility slot with 10,000x max win and Wild. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/annihilator': {
        title: 'Annihilator | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Annihilator slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/athena_ascending': {
        title: 'Play Athena Ascending | 10,000x Win | {brand}',
        description: 'Athena Ascending at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/aztec_idols': {
        title: 'Aztec Idols Slot | 10,000x Win | Play with Bitcoin',
        description: "Play Aztec Idols by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/aztec_warrior_princess': {
        title: 'Play Aztec Warrior Princess | 10,000x Max Win | {brand}',
        description: 'Play Aztec Warrior Princess slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/bakers_treat': {
        title: 'Bakers Treat Slot | 10,000x Win | Play with Bitcoin',
        description: "Bakers Treat slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/banana_rock': {
        title: 'Play Banana Rock Slot | 10,000x Payout | {brand}',
        description: "Play Banana Rock by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/banana_rush': {
        title: 'Play Banana Rush | 3,000x Win | {brand}',
        description: 'Banana Rush slot at {brand} crypto casino. Medium volatility, 3,000x max win with Wilds and Scatters. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/banquet_of_dead': {
        title: 'Play Banquet of Dead Slot | 10,000x Payout | {brand}',
        description: 'Banquet of Dead slot with 10,000x max win and Scatter Symbol. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/play-n-go/bao_shi': {
        title: 'Bao Shi Slot | 15,000x Win | Play with Bitcoin',
        description: 'Spin Bao Shi with Bitcoin at {brand}. 15,000x max win, medium volatility, Lioras Blessings. Instant payouts, zero platform fees.'
    },
    '/p/play-n-go/barn_busters': {
        title: 'Barn Busters | 7,500x Max Win Crypto Slot | {brand}',
        description: 'Deposit BTC and play Barn Busters at {brand}. 7,500x max win, medium volatility, Double Wheel. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/baron_lord_of_saturday': {
        title: 'Play Baron Lord of Saturday | 10,000x Win | {brand}',
        description: 'Play Baron Lord of Saturday at {brand}. Medium volatility, 10,000x max win. Features Random Wilds. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/battle_royal': {
        title: 'Battle Royal | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Battle Royal slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/beast_of_wealth': {
        title: 'Beast Of Wealth | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Beast Of Wealth by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/beasts_of_fire': {
        title: 'Beasts of Fire Slot | 25,000x Max Win | {brand}',
        description: "Play Beasts of Fire by Play'n GO. Medium volatility, 25,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/beasts_of_fire_maximum': {
        title: 'Play Beasts of Fire Maximum | 50,000x Win | {brand}',
        description: 'Beasts of Fire Maximum slot at {brand} crypto casino. High volatility, 50,000x max win with Charging Fire Beasts. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/big_win_777': {
        title: 'Big Win 777 | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Big Win 777 by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/big_win_cat': {
        title: 'Play Big Win Cat | 10,000x Max Win | {brand}',
        description: 'Deposit Bitcoin and play Big Win Cat at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/big_win_city_pawsperity': {
        title: 'Big Win City Pawsperity Slot | Win Up to 5,000x | {brand}',
        description: 'Deposit BTC and play Big Win City Pawsperity at {brand}. 5,000x max win, medium volatility, Coin Collection. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/black_mamba': {
        title: 'Black Mamba | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Black Mamba at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/blazin_bullfrog': {
        title: 'Blazin Bullfrog | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Blazin Bullfrog at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/blinged': {
        title: 'Play Blinged Slot | 10,000x Payout | {brand}',
        description: "Play Blinged by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/boat_bonanza': {
        title: 'Boat Bonanza Slot | Win Up to 10,000x | {brand}',
        description: 'Boat Bonanza at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/boat_bonanza_christmas': {
        title: 'Boat Bonanza Christmas Slot | 10,000x Win | {brand}',
        description: "Play Boat Bonanza Christmas by Play'n GO. 10,000x max win, Festive Fishing Boats, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/boat_bonanza_colossal_catch': {
        title: 'Play Boat Bonanza Colossal Catch Slot | 10,000x Payout | {brand}',
        description: "Boat Bonanza Colossal Catch slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/boat_bonanza_croconile': {
        title: 'Play Boat Bonanza Croconile Slot | 6,000x Payout | {brand}',
        description: 'Spin Boat Bonanza Croconile with Bitcoin at {brand}. 6,000x max win, medium volatility, Catch Feature. Instant payouts, zero platform fees.'
    },
    '/p/play-n-go/boat_bonanza_down_under': {
        title: 'Play Boat Bonanza Down Under | 10,000x Max Win | {brand}',
        description: 'Play Boat Bonanza Down Under slot for real money. 10,000x max win, Free Spins. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/play-n-go/boat_bonanza_rider': {
        title: 'Boat Bonanza Rider | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Boat Bonanza Rider with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/book_of_dead': {
        title: 'Book of Dead Go Collect | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Book of Dead Go Collect at {brand}. Medium volatility, 10,000x max win. Features Tomb Scatter and Free Spins. 9 cryptos, instant withdrawals.'
    },
    '/p/play-n-go/bubblin_riches': {
        title: 'Bubblin Riches Slot | 10,000x Max Win | {brand}',
        description: "Play Bubblin Riches by Play'n GO. 10,000x max win, Greedy Goldfish Collection, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/bucking_rider': {
        title: 'Play Bucking Rider | 10,000x Win | {brand}',
        description: 'Play Bucking Rider at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/buffalo_of_wealth': {
        title: 'Play Buffalo of Wealth Slot | 7,000x Payout | {brand}',
        description: "Buffalo of Wealth by Play'n GO. Medium volatility slot with 7,000x max win and Stacked Symbols. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/buildin_bucks': {
        title: 'Play Buildin Bucks | 10,000x Win | {brand}',
        description: 'Play Buildin Bucks at {brand}. Medium volatility, 10,000x max win. Features Free Spins. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/buildin_more_bucks': {
        title: 'Play Buildin More Bucks | 7,500x Win | {brand}',
        description: 'Buildin More Bucks slot at {brand} crypto casino. Medium volatility, 7,500x max win with Double Wheel. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/bull_in_a_china_shop': {
        title: 'Play Bull In A China Shop | 10,000x Win | {brand}',
        description: 'Bull In A China Shop slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/bull_in_a_rodeo': {
        title: 'Bull In A Rodeo | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Bull In A Rodeo with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/bullion_express': {
        title: 'Bullion Express | 6,000x Max Win Crypto Slot | {brand}',
        description: 'Bullion Express slot at {brand} crypto casino. Medium volatility, 6,000x max win with The M-Counter. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/candy_island_princess': {
        title: 'Candy Island Princess Slot | 10,000x Win | Play with Bitcoin',
        description: 'Spin Candy Island Princess with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/canine_carnage': {
        title: 'Canine Carnage Slot | Win Up to 3,000x | {brand}',
        description: 'Canine Carnage at {brand}. Medium volatility, 3,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/captain_glum_pirate_hunter': {
        title: 'Play Captain Glum: Pirate Hunter Slot | 9,000x Payout | {brand}',
        description: "Play Captain Glum: Pirate Hunter by Play'n GO at {brand}. Medium volatility, 9,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/captain_xenos_earth_adventure': {
        title: "Captain Xeno's Earth Adventure | {brand}",
        description: "Deposit Bitcoin and play Captain Xeno's Earth Adventure at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees."
    },
    '/p/play-n-go/cash_a_cabana': {
        title: 'Play Cash a Cabana | 10,000x Max Win | {brand}',
        description: 'Play Cash a Cabana at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/cash_of_command': {
        title: 'Play Cash of Command Slot | 5,336x Payout | {brand}',
        description: "Play Cash of Command by Play'n GO at {brand}. Medium volatility, 5,336x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/cash_pump': {
        title: 'Play Cash Pump | 10,000x Max Win | {brand}',
        description: 'Cash Pump slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/cash_vandal': {
        title: 'Cash Vandal Slot | Win Up to 10,000x | {brand}',
        description: 'Play Cash Vandal at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/cashin_joker': {
        title: "Play Cashin' Joker | 10,888x Win | {brand}",
        description: "Play Cashin' Joker slot for real money. 10,888x max win, Respin. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly."
    },
    '/p/play-n-go/cat_wilde_and_the_doom_of_dead': {
        title: 'Cat Wilde And The Doom Of Dead Slot | 10,000x Win | {brand}',
        description: "Play Cat Wilde And The Doom Of Dead by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/cat_wilde_and_the_incan_quest': {
        title: 'Cat Wilde and the Incan Quest Slot | 10,000x Max Win | {brand}',
        description: "Play Cat Wilde and the Incan Quest by Play'n GO. 10,000x max win, Falling Wild Re-Spins, high volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/cat_wilde_and_the_lost_chapter': {
        title: 'Cat Wilde And The Lost Chapter | {brand}',
        description: "Play Cat Wilde And The Lost Chapter by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/cat_wilde_and_the_pyramids_of_dead': {
        title: 'Cat Wilde And The Pyramids Of Dead Slot | {brand}',
        description: "Cat Wilde And The Pyramids Of Dead by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/cat_wilde_in_the_eclipse_of_the_sun_god': {
        title: 'Cat Wilde In The Eclipse Of The Sun God | {brand}',
        description: 'Cat Wilde In The Eclipse Of The Sun God slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more.'
    },
    '/p/play-n-go/cats_and_cash': {
        title: 'Cats And Cash | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Cats And Cash by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/celebration_of_wealth': {
        title: 'Celebration Of Wealth | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Celebration Of Wealth at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/chambers_of_ancients': {
        title: 'Chambers of Ancients | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Chambers of Ancients with Bitcoin at {brand}. 10,000x max win, high volatility, Wilds. Instant payouts, zero platform fees.'
    },
    '/p/play-n-go/champions_of_mithrune': {
        title: 'Champions of Mithrune Slot | 7,500x Win | Play with Bitcoin',
        description: "Champions of Mithrune slot with 7,500x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/charlie_chance': {
        title: 'Charlie Chance Slot | 10,000x Win | Play with Bitcoin',
        description: "Play Charlie Chance by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/charlie_chance_and_the_curse_of_cleopatra': {
        title: 'Charlie Chance and The Curse of Cleopatra Slot | {brand}',
        description: 'Charlie Chance and The Curse of Cleopatra at {brand}. Medium volatility, 5,500x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/charlie_chance_in_hell_to_pay': {
        title: 'Play Charlie Chance In Hell To Pay | 10,000x Win | {brand}',
        description: 'Charlie Chance In Hell To Pay at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/chinese_new_year': {
        title: 'Chinese New Year Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit Bitcoin and play Chinese New Year at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/chronos_joker': {
        title: 'Play Chronos Joker | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Chronos Joker at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/city_of_sound': {
        title: 'City of Sound Slot | 4,000x Max Win | {brand}',
        description: "Play City of Sound by Play'n GO. 4,000x max win, Gold Re-spins, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/clash_of_camelot': {
        title: 'Clash of Camelot | 35,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Clash of Camelot with Bitcoin at {brand}. 35,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/cloud_quest': {
        title: 'Cloud Quest | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Cloud Quest at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/coils_of_cash': {
        title: 'Coils Of Cash | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Coils Of Cash at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/colt_lightning': {
        title: 'Play Colt Lightning Slot | 25,000x Payout | {brand}',
        description: "Play Colt Lightning by Play'n GO. Medium volatility, 25,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/colt_lightning_firestorm': {
        title: 'Colt Lightning Firestorm Slot | 10,000x Max Win | {brand}',
        description: "Play Colt Lightning Firestorm by Play'n GO at {brand}. High volatility, 10,000x max win, Scatters. 9 cryptos accepted, instant withdrawals."
    },
    '/p/play-n-go/contact': {
        title: 'Contact Slot | Win Up to 10,000x | {brand}',
        description: 'Contact slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/copsnrobbers': {
        title: "Play Cops'n'Robbers | 28,961x Max Win | {brand}",
        description: "Cops'n'Robbers slot at {brand} crypto casino. Medium volatility with 28,961x max win. Deposit BTC, ETH, USDT and more. Fast payouts."
    },
    '/p/play-n-go/count_jokula': {
        title: 'Play Count Jokula | 10,000x Win | {brand}',
        description: 'Count Jokula slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/court_of_hearts': {
        title: 'Court of Hearts | 8,500x Max Win Bitcoin Slot | {brand}',
        description: "Play Court of Hearts by Play'n GO at {brand}. Medium volatility, 8,500x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/coywolf_cash': {
        title: 'Coywolf Cash Slot | 10,000x Max Win | {brand}',
        description: 'Spin Coywolf Cash with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/crabbys_gold': {
        title: "Crabby's Gold Slot | 70,000x Max Win | {brand}",
        description: "Play Crabby's Gold by Play'n GO at {brand}. Medium volatility, 70,000x max win, Coin Collect. 9 cryptos accepted, instant withdrawals."
    },
    '/p/play-n-go/crazy_cows': {
        title: 'Crazy Cows | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Crazy Cows slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/crystal_hall': {
        title: 'Play Crystal Hall | 10,000x Win | {brand}',
        description: 'Deposit BTC and play Crystal Hall at {brand}. 10,000x max win, medium volatility, Expanding Wilds. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/crystal_sun': {
        title: 'Crystal Sun Slot | 10,000x Max Win | {brand}',
        description: 'Spin Crystal Sun with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/dansband_pa_turne': {
        title: 'Play Dansband Pa Turne | 10,000x Max Win | {brand}',
        description: 'Play Dansband Pa Turne at {brand}. High volatility, 10,000x max win. Features Win Multiplier. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/dawn_of_egypt': {
        title: 'Dawn Of Egypt Slot | Win Up to 10,000x | {brand}',
        description: 'Dawn Of Egypt slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/demon': {
        title: 'Demon Slot | 10,000x Max Win | {brand}',
        description: "Play Demon by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/derby_wheel': {
        title: 'Play Derby Wheel | 10,000x Max Win | {brand}',
        description: 'Derby Wheel at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/diamond_vortex': {
        title: 'Diamond Vortex Slot | 10,000x Win | Play with Bitcoin',
        description: "Play Diamond Vortex by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/diamonds_of_the_realm': {
        title: 'Diamonds Of The Realm | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Diamonds Of The Realm by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/dio_killing_the_dragon': {
        title: 'Dio Killing The Dragon Slot | 10,000x Win | {brand}',
        description: "Play Dio Killing The Dragon by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/disco_diamonds': {
        title: 'Play Disco Diamonds | 10,000x Win | {brand}',
        description: 'Disco Diamonds at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/divina_commedia_i_nove_cerchi': {
        title: 'Divina Commedia I Nove Cerchi Slot | 3,000x Win | {brand}',
        description: 'Spin Divina Commedia I Nove Cerchi with Bitcoin at {brand}. 3,000x max win, medium volatility, Free Spins. Instant payouts, zero platform fees.'
    },
    '/p/play-n-go/divine_divas': {
        title: 'Divine Divas Slot | 10,000x Max Win | {brand}',
        description: "Play Divine Divas by Play'n GO. 10,000x max win, Free Spins, high volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/divine_showdown': {
        title: 'Play Divine Showdown Slot | 10,000x Payout | {brand}',
        description: "Play Divine Showdown by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/doom_of_egypt': {
        title: 'Doom Of Egypt | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Doom Of Egypt with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/dr_toonz': {
        title: 'Play Dr Toonz Slot | 10,000x Payout | {brand}',
        description: "Dr Toonz slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/dragon_maiden': {
        title: 'Play Dragon Maiden | 10,000x Max Win | {brand}',
        description: 'Deposit Bitcoin and play Dragon Maiden at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/dragon_ship': {
        title: 'Dragon Ship | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Dragon Ship at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/dragonfates_favour': {
        title: "Play Dragonfate's Favour | 30,000x Max Win | {brand}",
        description: "Play Dragonfate's Favour slot for real money. 30,000x max win, Walking WIlds. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly."
    },
    '/p/play-n-go/easter_eggs': {
        title: 'Easter Eggs Slot | 10,000x Max Win | {brand}',
        description: "Play Easter Eggs by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/easter_eggspedition': {
        title: 'Easter Eggspedition Slot | 10,000x Win | Play with Bitcoin',
        description: 'Easter Eggspedition slot with 10,000x max win and Super Bunny Wild. Medium volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/play-n-go/enchanted_crystals': {
        title: 'Play Enchanted Crystals | 10,000x Max Win | {brand}',
        description: 'Enchanted Crystals slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/enchanted_meadow': {
        title: 'Play Enchanted Meadow | 10,000x Max Win | {brand}',
        description: 'Enchanted Meadow at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/energoonz': {
        title: 'Energoonz | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Energoonz by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/eye_of_atum': {
        title: 'Eye of Atum | 2,000x Max Win Bitcoin Slot | {brand}',
        description: "Eye of Atum slot with 2,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/eye_of_the_kraken': {
        title: 'Play Eye Of The Kraken | 10,000x Max Win | {brand}',
        description: 'Play Eye Of The Kraken at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/fangs_and_fire': {
        title: 'Fangs and Fire Slot | Win Up to 60,000x | {brand}',
        description: "Deposit BTC and play Fangs and Fire at {brand}. 60,000x max win, high volatility, Link'n Go. 9 cryptos, zero fees."
    },
    '/p/play-n-go/fat_frankies': {
        title: 'Fat Frankies Slot | 6,000x Max Win | {brand}',
        description: "Fat Frankies slot with 6,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/fate_of_dead_blitzways': {
        title: 'Fate of Dead Blitzways Slot | 20,000x Max Win | {brand}',
        description: 'Fate of Dead Blitzways slot with 20,000x max win and Blitzways Dynamic Reels. Medium volatility. Play with Bitcoin at {brand}.'
    },
    '/p/play-n-go/feline_fury': {
        title: 'Play Feline Fury | 10,000x Max Win | {brand}',
        description: 'Deposit Bitcoin and play Feline Fury at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/fire_joker': {
        title: 'Play Fire Joker | 10,000x Win | {brand}',
        description: 'Fire Joker at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/fire_joker_100': {
        title: 'Play Fire Joker 100 | 5,000x Max Win | {brand}',
        description: 'Fire Joker 100 slot at {brand} crypto casino. Medium volatility, 5,000x max win with Re-spin of Fire. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/fire_joker_blitz': {
        title: 'Fire Joker Blitz Slot | Win Up to 6,000x | {brand}',
        description: 'Play Fire Joker Blitz at {brand}. Medium volatility, 6,000x max win. Features Coin Collect. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/fire_joker_freeze': {
        title: 'Play Fire Joker Freeze | 1,000x Win | {brand}',
        description: 'Play Fire Joker Freeze at {brand} crypto casino. Medium volatility, 1,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/fire_toad': {
        title: 'Play Fire Toad Slot | 10,000x Payout | {brand}',
        description: 'Spin Fire Toad with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/fire_toad_2': {
        title: 'Play Fire Toad 2 | 5,300x Win | {brand}',
        description: 'Play Fire Toad 2 at {brand}. Medium volatility, 5,300x max win. Features Total Upgrade. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/firefly_frenzy': {
        title: 'Firefly Frenzy | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Firefly Frenzy at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/forge_of_fortunes': {
        title: 'Play Forge of Fortunes | 2,500x Win | {brand}',
        description: 'Forge of Fortunes slot at {brand} crypto casino. Medium volatility with 2,500x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/forge_of_gems': {
        title: 'Play Forge Of Gems | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Forge Of Gems at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/fortune_rewind': {
        title: 'Fortune Rewind | 8,500x Max Win Bitcoin Slot | {brand}',
        description: "Fortune Rewind by Play'n GO. Medium volatility slot with 8,500x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/fortune_teller': {
        title: 'Play Fortune Teller | 10,000x Win | {brand}',
        description: 'Play Fortune Teller slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/fortunes_of_ali_baba': {
        title: 'Play Fortunes Of Ali Baba | 10,000x Win | {brand}',
        description: 'Play Fortunes Of Ali Baba at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/fox_mayhem': {
        title: 'Fox Mayhem Slot | 400,000x Max Win | {brand}',
        description: "Fox Mayhem slot with 400,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/free_reelin_joker': {
        title: "Free Reelin' Joker | 1,000x Max Win Crypto Slot | {brand}",
        description: "Free Reelin' Joker slot at {brand} crypto casino. Medium volatility with 1,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts."
    },
    '/p/play-n-go/free_reelin_joker_1000': {
        title: "Free Reelin' Joker 1000 Slot | Win Up to 10,500x | {brand}",
        description: "Play Free Reelin' Joker 1000 slot for real money at {brand}. 10,500x max win, medium volatility. BTC, ETH and 7 more cryptos accepted."
    },
    '/p/play-n-go/frozen_gems': {
        title: 'Frozen Gems Slot | 10,000x Max Win | {brand}',
        description: "Play Frozen Gems by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/fruit_bonanza': {
        title: 'Play Fruit Bonanza | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Fruit Bonanza at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/fu_er_dai': {
        title: 'Play Fu Er Dai | 10,000x Win | {brand}',
        description: 'Fu Er Dai slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/fulong_88': {
        title: 'Play Fulong 88 | 10,000x Win | {brand}',
        description: 'Deposit BTC and play Fulong 88 at {brand}. 10,000x max win, medium volatility, Free Spins. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/game_of_gladiators': {
        title: 'Play Game Of Gladiators Slot | 10,000x Payout | {brand}',
        description: "Play Game Of Gladiators by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/game_of_gladiators_uprising': {
        title: 'Game Of Gladiators Uprising Slot | 10,000x Win | {brand}',
        description: "Play Game Of Gladiators Uprising by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/gargantoonz': {
        title: 'Play Gargantoonz | 10,000x Max Win | {brand}',
        description: 'Gargantoonz at {brand}. High volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/gates_of_troy': {
        title: 'Gates Of Troy | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Gates Of Troy by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/gemix': {
        title: 'Gemix | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Gemix slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/gemix_100': {
        title: 'Gemix 100 Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit BTC and play Gemix 100 at {brand}. 10,000x max win, high volatility, Crystal Charge. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/gemix_2': {
        title: 'Gemix 2 Slot | 10,000x Win | Play with Bitcoin',
        description: "Gemix 2 by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/gerards_gambit': {
        title: "Gerard's Gambit Slot | 300,000x Win | Play with Bitcoin",
        description: "Gerard's Gambit by Play'n GO. Medium volatility slot with 300,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/ghost_of_dead': {
        title: 'Play Ghost Of Dead | 10,000x Max Win | {brand}',
        description: 'Ghost Of Dead at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/gift_shop': {
        title: 'Gift Shop | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Gift Shop by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/gigantoonz': {
        title: 'Gigantoonz | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Gigantoonz at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/go_craps': {
        title: 'Go Craps | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Go Craps at {brand} crypto casino. 10,000x max win with A Classic. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/play-n-go/gold_king': {
        title: 'Gold King | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Gold King slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/gold_of_fortune_god': {
        title: 'Gold of Fortune God | 5,000x Max Win Bitcoin Slot | {brand}',
        description: "Gold of Fortune God by Play'n GO. High volatility slot with 5,000x max win and Wild. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/gold_trophy_2': {
        title: 'Play Gold Trophy 2 | 10,000x Max Win | {brand}',
        description: 'Play Gold Trophy 2 slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/gold_volcano': {
        title: 'Gold Volcano Slot | 10,000x Max Win | {brand}',
        description: "Play Gold Volcano by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/golden_caravan': {
        title: 'Golden Caravan | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Golden Caravan at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/golden_colts': {
        title: 'Golden Colts | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Golden Colts slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/golden_goal': {
        title: 'Golden Goal | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Golden Goal with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/golden_legend': {
        title: 'Golden Legend Slot | 10,000x Max Win | {brand}',
        description: "Golden Legend by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/golden_osiris': {
        title: 'Golden Osiris Slot | 10,000x Win | Play with Bitcoin',
        description: "Play Golden Osiris by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/golden_ticket_2': {
        title: 'Golden Ticket 2 | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Golden Ticket 2 by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/grim_muerto': {
        title: 'Grim Muerto | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Grim Muerto at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/gunslinger_reloaded': {
        title: 'Gunslinger Reloaded | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Gunslinger Reloaded by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/happy_halloween': {
        title: 'Happy Halloween | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Happy Halloween slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/highway_legends': {
        title: 'Play Highway Legends | 62,500x Win | {brand}',
        description: 'Play Highway Legends slot for real money at {brand}. 62,500x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/holiday_season': {
        title: 'Play Holiday Season | 10,000x Win | {brand}',
        description: 'Holiday Season slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/holiday_spirits': {
        title: 'Holiday Spirits Slot | 10,000x Max Win | {brand}',
        description: "Play Holiday Spirits by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/honey_rush': {
        title: 'Play Honey Rush Black and Yellow | 20,000x Max Win | {brand}',
        description: 'Honey Rush Black and Yellow slot at {brand} crypto casino. High volatility, 20,000x max win with Walking Wilds. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/honey_rush_100': {
        title: 'Honey Rush 100 Slot | Win Up to 5,000,000x | {brand}',
        description: 'Play Honey Rush 100 at {brand} crypto casino. High volatility, 5,000,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/hooligan_hustle': {
        title: 'Play Hooligan Hustle Slot | 10,000x Payout | {brand}',
        description: "Play Hooligan Hustle by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/hope_unleashed_fortune_reels': {
        title: 'Play Hope Unleashed Fortune Reels | 1,234x Win | {brand}',
        description: 'Hope Unleashed Fortune Reels slot at {brand} crypto casino. Medium volatility, 1,234x max win with Mystery Symbols. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/hot_dog_heist': {
        title: 'Hot Dog Heist Slot | Win Up to 10,000x | {brand}',
        description: 'Hot Dog Heist slot at {brand} crypto casino. High volatility, 10,000x max win with The Pack Attach and Mega Sy. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/hotel_yetiway': {
        title: 'Hotel Yetiway Slot | 10,000x Max Win | {brand}',
        description: "Play Hotel Yetiway by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/house_of_doom': {
        title: 'Play House Of Doom | 10,000x Max Win | {brand}',
        description: 'House Of Doom at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/house_of_doom_2_the_crypt': {
        title: 'House Of Doom 2 The Crypt Slot | Win Up to 10,000x | {brand}',
        description: 'Play House Of Doom 2 The Crypt at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/ice_joker': {
        title: 'Play Ice Joker Slot | 10,000x Payout | {brand}',
        description: "Play Ice Joker by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/idol_of_fortune': {
        title: 'Idol Of Fortune Slot | Win Up to 10,000x | {brand}',
        description: 'Play Idol Of Fortune at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/immortails_of_egypt': {
        title: 'Immortails Of Egypt Slot | 10,000x Max Win | {brand}',
        description: "Immortails Of Egypt slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/imperial_opera': {
        title: 'Play Imperial Opera Slot | 10,000x Payout | {brand}',
        description: "Imperial Opera slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/inferno_joker': {
        title: 'Inferno Joker Slot | 10,000x Max Win | {brand}',
        description: "Play Inferno Joker by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/inferno_star': {
        title: 'Play Inferno Star | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Inferno Star at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/invading_vegas': {
        title: 'Invading Vegas | 1,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Invading Vegas with Bitcoin at {brand}. 1,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/invading_vegas_las_christmas': {
        title: 'Invading Vegas: Las Christmas Slot | 10,000x Max Win | {brand}',
        description: "Play Invading Vegas: Las Christmas by Play'n GO at {brand}. Medium volatility, 10,000x max win, Free Spins. 9 cryptos accepted, instant withdrawals."
    },
    '/p/play-n-go/invading_vegas_revenge_on_mars': {
        title: 'Play Invading Vegas Revenge on Mars | 2,000x Win | {brand}',
        description: 'Deposit BTC and play Invading Vegas Revenge on Mars at {brand}. 2,000x max win, medium volatility, Free Spins. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/irish_gold': {
        title: 'Play Irish Gold | 10,000x Win | {brand}',
        description: 'Irish Gold at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/iron_girl': {
        title: 'Iron Girl Slot | 10,000x Max Win | {brand}',
        description: 'Spin Iron Girl with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/jade_magician': {
        title: 'Jade Magician Slot | Win Up to 10,000x | {brand}',
        description: 'Play Jade Magician slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/jewel_box': {
        title: 'Play Jewel Box Slot | 10,000x Payout | {brand}',
        description: "Play Jewel Box by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/joker_flip': {
        title: 'Joker Flip | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Joker Flip by Play'n GO. Medium volatility slot with 10,000x max win and Wild. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/jolly_roger': {
        title: 'Play Jolly Roger | 10,000x Win | {brand}',
        description: 'Jolly Roger at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/jolly_roger_2': {
        title: 'Play Jolly Roger 2 Slot | 10,000x Payout | {brand}',
        description: "Jolly Roger 2 slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/jolly_roger_wild_kraken': {
        title: 'Play Jolly Roger Wild Kraken | 10,000x Max Win | {brand}',
        description: 'Jolly Roger Wild Kraken at {brand} crypto casino. 10,000x max win with Instant Treasure Wins. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/play-n-go/journey_to_paris': {
        title: 'Journey to Paris Slot | Win Up to 10,000x | {brand}',
        description: 'Play Journey to Paris at {brand}. Medium volatility, 10,000x max win. Features Wild Symbol. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/king_of_sweets': {
        title: 'King of Sweets Slot | 5,000x Max Win | {brand}',
        description: "Play King of Sweets by Play'n GO. 5,000x max win, Sweet Tiles, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/kingdom_below': {
        title: 'Kingdom Below Slot | 10,000x Win | Play with Bitcoin',
        description: 'Spin Kingdom Below with Bitcoin at {brand}. 10,000x max win, medium volatility, Grab Feature. Instant payouts, zero platform fees.'
    },
    '/p/play-n-go/kings_mask': {
        title: "Play King's Mask Slot | 10,000x Payout | {brand}",
        description: "Play King's Mask by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/kings_mask_eclipse_of_gods': {
        title: "Play King's Mask Eclipse of Gods Slot | 10,000x Payout | {brand}",
        description: "Play King's Mask Eclipse of Gods by Play'n GO. 10,000x max win, Free Spins, high volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/lab_of_madness': {
        title: 'Lab of Madness Slot | 6,000x Win | Play with Bitcoin',
        description: 'Lab of Madness slot with 6,000x max win and Special Wilds. Medium volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/play-n-go/lady_of_fortune': {
        title: 'Lady Of Fortune | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Lady Of Fortune at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/lady_of_fortune_destiny_spins': {
        title: 'Lady of Fortune Destiny Spins Slot | 1,950x Max Win | {brand}',
        description: "Play Lady of Fortune Destiny Spins by Play'n GO at {brand}. Low volatility, 1,950x max win, Pick a Prize. 9 cryptos accepted, instant withdrawals."
    },
    '/p/play-n-go/lady_of_fortune_remastered': {
        title: 'Lady of Fortune Remastered Slot | 1,500x Win | {brand}',
        description: "Lady of Fortune Remastered by Play'n GO. Low volatility slot with 1,500x max win and Multiplier Wilds. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/legacy_of_dead': {
        title: 'Legacy Of Dead Slot | Win Up to 10,000x | {brand}',
        description: 'Play Legacy Of Dead slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/legacy_of_dynasties': {
        title: 'Play Legacy of Dynasties | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Legacy of Dynasties at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/legacy_of_egypt': {
        title: 'Legacy Of Egypt Slot | 10,000x Win | Play with Bitcoin',
        description: "Legacy Of Egypt by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/legacy_of_gems_blitzways': {
        title: 'Legacy of Gems Blitzways Slot | Win Up to 10,000x | {brand}',
        description: 'Play Legacy of Gems Blitzways at {brand}. Medium volatility, 10,000x max win. Features Free Spins. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/legacy_of_inca': {
        title: 'Legacy Of Inca | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Legacy Of Inca slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/legacy_of_undead_dragon_abyssways': {
        title: 'Legacy of Undead Dragon Abyssways | {brand}',
        description: 'Play Legacy of Undead Dragon Abyssways at {brand}. Medium volatility, 20,000x max win. Features Haunted Gold. 9 cryptos, instant withdrawals.'
    },
    '/p/play-n-go/legend_of_the_ice_dragon': {
        title: 'Legend Of The Ice Dragon Slot | 10,000x Max Win | {brand}',
        description: "Legend Of The Ice Dragon by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/legion_gold': {
        title: 'Legion Gold | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Legion Gold by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/legion_gold_and_the_sphinx_of_dead': {
        title: 'Legion Gold and the Sphinx of Dead | {brand}',
        description: 'Legion Gold and the Sphinx of Dead slot with 1,000x max win and Gold Respins. Medium volatility. Play with Bitcoin at {brand}.'
    },
    '/p/play-n-go/legion_gold_unleashed': {
        title: 'Legion Gold Unleashed | 1,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Legion Gold Unleashed by Play'n GO. 1,000x max win, Re-Spins, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/legion_gold_victory': {
        title: 'Legion Gold Victory Slot | Win Up to 4,000x | {brand}',
        description: 'Play Legion Gold Victory at {brand}. Medium volatility, 4,000x max win. Features Gold Respins. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/leprechaun_goes_egypt': {
        title: 'Leprechaun Goes Egypt Slot | Win Up to 10,000x | {brand}',
        description: 'Play Leprechaun Goes Egypt slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/leprechaun_goes_to_hell': {
        title: 'Play Leprechaun Goes To Hell | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Leprechaun Goes To Hell at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/leprechaun_goes_wild': {
        title: 'Play Leprechaun Goes Wild Slot | 10,000x Payout | {brand}',
        description: "Play Leprechaun Goes Wild by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/leprechauns_diamond_dig': {
        title: "Leprechaun's Diamond Dig Slot | Win Up to 3,000x | {brand}",
        description: "Leprechaun's Diamond Dig at {brand} crypto casino. 3,000x max win with Lucky Minecarts. Play with BTC, ETH, USDT. Instant payouts, no fees."
    },
    '/p/play-n-go/leprechauns_vault': {
        title: 'Leprechauns Vault Slot | 10,000x Max Win | {brand}',
        description: "Leprechauns Vault by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/lion_saga_odyssey': {
        title: 'Play Lion Saga Odyssey | 10,000x Win | {brand}',
        description: 'Deposit BTC and play Lion Saga Odyssey at {brand}. 10,000x max win, medium volatility, Free Spins. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/loot_and_labyrinths': {
        title: 'Loot and Labyrinths Slot | 20,000x Max Win | {brand}',
        description: "Loot and Labyrinths by Play'n GO. Medium volatility slot with 20,000x max win and Random Encounter Mini-Games. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/lord_merlin_and_the_lady_of_the_lake': {
        title: 'Play Lord Merlin And The Lady Of The Lake | 10,000x Win | {brand}',
        description: 'Play Lord Merlin And The Lady Of The Lake at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/love_is_in_the_fair': {
        title: 'Play Love is in the Fair | 10,000x Win | {brand}',
        description: 'Love is in the Fair at {brand} crypto casino. 10,000x max win with Free Spins. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/play-n-go/love_joker': {
        title: 'Love Joker Slot | Win Up to 10,000x | {brand}',
        description: 'Love Joker slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/luchamigos': {
        title: 'Play Luchamigos | 1,000,000x Max Win | {brand}',
        description: 'Play Luchamigos slot for real money at {brand}. 1,000,000x max win, high volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/lucky_diamonds': {
        title: 'Lucky Diamonds | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Lucky Diamonds slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/madame_ink': {
        title: 'Madame Ink | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Madame Ink slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/mafia_gold': {
        title: 'Mafia Gold | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Mafia Gold slot with 10,000x max win and Win Multiplier. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/play-n-go/mahjong_88': {
        title: 'Mahjong 88 | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Mahjong 88 with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/matsuri': {
        title: 'Matsuri Slot | 10,000x Win | Play with Bitcoin',
        description: 'Spin Matsuri with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/medusas_madness': {
        title: "Play Medusa's Madness | 2,000x Win | {brand}",
        description: "Medusa's Madness slot at {brand} crypto casino. Medium volatility, 2,000x max win with The Portal. Deposit BTC, ETH, USDT. No fees."
    },
    '/p/play-n-go/mega_don_feeding_frenzy': {
        title: 'Mega Don: Feeding Frenzy | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Mega Don: Feeding Frenzy slot for real money. 10,000x max win, Free Spins. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/play-n-go/mega_don_triple_threat': {
        title: 'Play Mega Don Triple Threat | 25,000x Win | {brand}',
        description: 'Deposit BTC and play Mega Don Triple Threat at {brand}. 25,000x max win, medium volatility, Wild Symbols. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/megadon': {
        title: 'Megadon | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Megadon by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/merlin_and_the_ice_queen_morgana': {
        title: 'Merlin And The Ice Queen Morgana | {brand}',
        description: 'Merlin And The Ice Queen Morgana slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more.'
    },
    '/p/play-n-go/merlin_journey_of_flame': {
        title: 'Play Merlin: Journey of Flame | 750,000x Max Win | {brand}',
        description: 'Deposit Bitcoin and play Merlin: Journey of Flame at {brand}. 750,000x max win, high volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/merlin_realm_of_charm': {
        title: 'Play Merlin Realm of Charm Slot | 10,000x Payout | {brand}',
        description: "Play Merlin Realm of Charm by Play'n GO at {brand}. High volatility, 10,000x max win, Scatter. 9 cryptos accepted, instant withdrawals."
    },
    '/p/play-n-go/merlins_grimoire': {
        title: 'Play Merlins Grimoire Slot | 10,000x Payout | {brand}',
        description: "Play Merlins Grimoire by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/mermaids_diamond': {
        title: 'Play Mermaids Diamond Slot | 10,000x Payout | {brand}',
        description: "Mermaids Diamond slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/merry_xmas': {
        title: 'Merry Xmas | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Merry Xmas by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/midnight_gold': {
        title: 'Play Midnight Gold Slot | 10,000x Payout | {brand}',
        description: "Midnight Gold by Play'n GO. Medium volatility slot with 10,000x max win and Deliver Feature. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/miner_donkey_rider': {
        title: 'Play Miner Donkey Rider Slot | 10,000x Payout | {brand}',
        description: "Miner Donkey Rider by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/miner_donkey_trouble': {
        title: 'Play Miner Donkey Trouble | 10,000x Win | {brand}',
        description: 'Play Miner Donkey Trouble at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/mirror_joker': {
        title: 'Mirror Joker Slot | 10,000x Max Win | {brand}',
        description: "Play Mirror Joker by Play'n GO at {brand}. Medium volatility, 10,000x max win, Mirror Re-Spin. 9 cryptos accepted, instant withdrawals."
    },
    '/p/play-n-go/mission_cash': {
        title: 'Mission Cash Slot | Win Up to 10,000x | {brand}',
        description: 'Mission Cash slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/mole_digger': {
        title: 'Mole Digger Slot | Win Up to 10,000x | {brand}',
        description: 'Play Mole Digger slot for real money. 10,000x max win, Feature Pots. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/play-n-go/money_wheel': {
        title: 'Play Money Wheel | 10,000x Max Win | {brand}',
        description: 'Money Wheel at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/monkey_battle_for_the_scrolls': {
        title: 'Play Monkey Battle for the Scrolls Slot | {brand}',
        description: "Play Monkey Battle for the Scrolls by Play'n GO. 10,000x max win, Free Spins, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/monkey_donkey_rider': {
        title: 'Monkey Donkey Rider Slot | 10,000x Max Win | {brand}',
        description: "Play Monkey Donkey Rider by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/moon_princess': {
        title: 'Play Moon Princess Slot | 10,000x Payout | {brand}',
        description: "Moon Princess slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/moon_princess_christmas_kingdom': {
        title: 'Moon Princess Christmas Kingdom | {brand}',
        description: 'Moon Princess Christmas Kingdom slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more.'
    },
    '/p/play-n-go/moon_princess_origins': {
        title: 'Moon Princess Origins | 20,000x Max Win Bitcoin Slot | {brand}',
        description: "Moon Princess Origins by Play'n GO. Medium volatility slot with 20,000x max win and Girl Powers. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/moon_princess_power_of_love': {
        title: 'Moon Princess Power of Love Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit BTC and play Moon Princess Power of Love at {brand}. 10,000x max win, high volatility, Wild Symbols. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/moon_princess_stargazing': {
        title: 'Play Moon Princess Stargazing | 10,000x Win | {brand}',
        description: 'Play Moon Princess Stargazing slot for real money. 10,000x max win, Girl Powers. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/play-n-go/moon_princess_trinity': {
        title: 'Moon Princess Trinity Slot | 400,000x Max Win | {brand}',
        description: "Moon Princess Trinity by Play'n GO. High volatility slot with 400,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/motley_crue': {
        title: 'Motley Crue Slot | Win Up to 10,000x | {brand}',
        description: 'Play Motley Crue at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/mount_m': {
        title: 'Play Mount M Slot | 10,000x Payout | {brand}',
        description: 'Spin Mount M with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/muerto_en_mictlan': {
        title: 'Muerto En Mictlan Slot | 10,000x Win | Play with Bitcoin',
        description: "Play Muerto En Mictlan by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/multifruit_81': {
        title: 'Multifruit 81 | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Multifruit 81 with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/mystery_egg_surprise': {
        title: 'Mystery Egg Surprise Slot | 6,480x Max Win | {brand}',
        description: "Play Mystery Egg Surprise by Play'n GO. 6,480x max win, Scatter, high volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/mystery_genie_fortunes_of_the_lamp': {
        title: 'Play Mystery Genie Fortunes of the Lamp | 10,000x Win | {brand}',
        description: 'Play Mystery Genie Fortunes of the Lamp at {brand}. High volatility, 10,000x max win. Features Scatter. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/mystery_joker': {
        title: 'Mystery Joker Slot | 10,000x Max Win | {brand}',
        description: "Mystery Joker slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/mystery_joker_6000': {
        title: 'Mystery Joker 6000 Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit Bitcoin and play Mystery Joker 6000 at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/myth': {
        title: 'Myth Slot | Win Up to 10,000x | {brand}',
        description: 'Myth slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/myth_of_dead': {
        title: 'Myth of Dead Slot | 10,000x Win | Play with Bitcoin',
        description: "Play Myth of Dead by Play'n GO at {brand}. Medium volatility, 10,000x max win, Pyramid Power. 9 cryptos accepted, instant withdrawals."
    },
    '/p/play-n-go/naughty_nicks_book': {
        title: 'Play Naughty Nicks Book Slot | 10,000x Payout | {brand}',
        description: "Naughty Nicks Book by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/new_year_riches': {
        title: 'New Year Riches Slot | 10,000x Win | Play with Bitcoin',
        description: "New Year Riches by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/ninja_fruits': {
        title: 'Play Ninja Fruits | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Ninja Fruits at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/oasis_of_dead': {
        title: 'Oasis of Dead | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Oasis of Dead at {brand} crypto casino. 10,000x max win with Scatter. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/play-n-go/octopus_treasure': {
        title: 'Play Octopus Treasure Slot | 10,000x Payout | {brand}',
        description: "Play Octopus Treasure by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/odin_protector_of_realms': {
        title: 'Play Odin: Protector of Realms | 5,000x Win | {brand}',
        description: 'Odin: Protector of Realms at {brand}. Medium volatility, 5,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/pack_and_cash': {
        title: 'Pack and Cash Slot | 10,000x Win | Play with Bitcoin',
        description: "Pack and Cash slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/pandastic_adventure': {
        title: 'Pandastic Adventure Slot | Win Up to 5,000x | {brand}',
        description: 'Pandastic Adventure slot at {brand} crypto casino. High volatility, 5,000x max win with Temple Treasure Bonus. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/pandoras_box_of_evil': {
        title: 'Pandoras Box Of Evil Slot | 10,000x Win | Play with Bitcoin',
        description: 'Spin Pandoras Box Of Evil with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/pearl_lagoon': {
        title: 'Pearl Lagoon | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Pearl Lagoon by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/pearls_of_india': {
        title: 'Pearls Of India Slot | 10,000x Win | Play with Bitcoin',
        description: 'Spin Pearls Of India with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/perfect_gems': {
        title: 'Perfect Gems Slot | Win Up to 10,000x | {brand}',
        description: 'Play Perfect Gems at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/phoenix_reborn': {
        title: 'Play Phoenix Reborn | 10,000x Win | {brand}',
        description: 'Play Phoenix Reborn at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/photo_safari': {
        title: 'Photo Safari | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Photo Safari with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/piggy_bank_farm': {
        title: 'Play Piggy Bank Farm | 5,000x Win | {brand}',
        description: 'Piggy Bank Farm at {brand}. Medium volatility, 5,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/piggy_blitz': {
        title: 'Piggy Blitz Casino Gold Slot | Win Up to 8,000x | {brand}',
        description: 'Deposit BTC and play Piggy Blitz Casino Gold at {brand}. 8,000x max win, medium volatility, Cash Coins and Piggy Banks. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/piggy_blitz_disco_gold': {
        title: 'Piggy Blitz Disco Gold | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Piggy Blitz Disco Gold at {brand} crypto casino. 10,000x max win with Cash Coins. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/play-n-go/piggy_heist': {
        title: 'Piggy Heist Slot | Win Up to 70,000x | {brand}',
        description: 'Deposit BTC and play Piggy Heist at {brand}. 70,000x max win, medium volatility, Safe Box Feature. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/pilgrim_of_dead': {
        title: 'Play Pilgrim Of Dead Slot | 10,000x Payout | {brand}',
        description: 'Spin Pilgrim Of Dead with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/pimped': {
        title: 'Pimped Slot | 10,000x Max Win | {brand}',
        description: "Pimped by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/pirahna_pays': {
        title: 'Play Pirahna Pays Slot | 10,000x Payout | {brand}',
        description: "Play Pirahna Pays by Play'n GO at {brand}. High volatility, 10,000x max win, Win Multiplier. 9 cryptos accepted, instant withdrawals."
    },
    '/p/play-n-go/planet_fortune': {
        title: 'Play Planet Fortune | 10,000x Max Win | {brand}',
        description: 'Play Planet Fortune slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/potion_of_madness': {
        title: 'Potion of Madness Slot | 10,000x Max Win | {brand}',
        description: "Play Potion of Madness by Play'n GO. 10,000x max win, Transformation Feature, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/prism_of_gems': {
        title: 'Prism Of Gems Slot | Win Up to 10,000x | {brand}',
        description: 'Prism Of Gems at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/prissy_princess': {
        title: 'Prissy Princess | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Prissy Princess slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/prosperity_palace': {
        title: 'Prosperity Palace | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Prosperity Palace at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/puebla_parade': {
        title: 'Puebla Parade Slot | 10,000x Win | Play with Bitcoin',
        description: 'Spin Puebla Parade with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/queens_day_tilt': {
        title: 'Queens Day Tilt | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Queens Day Tilt slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/rabbit_hole_riches': {
        title: 'Play Rabbit Hole Riches | 10,000x Max Win | {brand}',
        description: 'Play Rabbit Hole Riches at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/rage_to_riches': {
        title: 'Play Rage To Riches | 10,000x Max Win | {brand}',
        description: 'Rage To Riches at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/raging_rex': {
        title: 'Raging Rex Slot | Win Up to 10,000x | {brand}',
        description: 'Raging Rex at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/raging_rex_2': {
        title: 'Raging Rex 2 Slot | 10,000x Max Win | {brand}',
        description: 'Spin Raging Rex 2 with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/raging_rex_3': {
        title: 'Play Raging Rex 3 | 10,000x Max Win | {brand}',
        description: 'Raging Rex 3 slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/rainforest_magic': {
        title: 'Play Rainforest Magic Slot | 10,000x Payout | {brand}',
        description: "Play Rainforest Magic by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/rainforest_magic_bingo': {
        title: 'Play Rainforest Magic Bingo Slot | 10,000x Payout | {brand}',
        description: 'Spin Rainforest Magic Bingo with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/rally_4_riches': {
        title: 'Play Rally 4 Riches | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Rally 4 Riches at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/ras_reckoning': {
        title: "Ra's Reckoning | 50,000x Max Win Bitcoin Slot | {brand}",
        description: "Play Ra's Reckoning by Play'n GO. 50,000x max win, Cascading Cluster Wins, high volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/rascal_riches': {
        title: 'Play Rascal Riches Slot | 900,000x Payout | {brand}',
        description: "Play Rascal Riches by Play'n GO at {brand}. High volatility, 900,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/reactoonz': {
        title: 'Reactoonz Slot | 10,000x Max Win | {brand}',
        description: "Play Reactoonz by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/reactoonz_100': {
        title: 'Reactoonz 100 | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Reactoonz 100 with Bitcoin at {brand}. 10,000x max win, high volatility, Cascading Cluster Wins. Instant payouts, zero platform fees.'
    },
    '/p/play-n-go/reactoonz_2': {
        title: 'Reactoonz 2 Slot | Win Up to 10,000x | {brand}',
        description: 'Play Reactoonz 2 at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/rich_wilde_and_the_amulet_of_dead': {
        title: 'Play Rich Wilde And The Amulet Of Dead | {brand}',
        description: 'Deposit Bitcoin and play Rich Wilde And The Amulet Of Dead at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/rich_wilde_and_the_pearls_of_vishnu': {
        title: 'Play Rich Wilde and the Pearls of Vishnu | 2,000x Win | {brand}',
        description: 'Rich Wilde and the Pearls of Vishnu slot at {brand} crypto casino. Medium volatility, 2,000x max win with Multiplier. Deposit BTC, ETH, USDT.'
    },
    '/p/play-n-go/rich_wilde_and_the_shield_of_athena': {
        title: 'Play Rich Wilde And The Shield Of Athena | 10,000x Win | {brand}',
        description: 'Play Rich Wilde And The Shield Of Athena slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/rich_wilde_and_the_tome_of_dead': {
        title: 'Rich Wilde and the Tome of Dead | {brand}',
        description: 'Spin Rich Wilde and the Tome of Dead with Bitcoin at {brand}. 5,000x max win, medium volatility, Multiplier Wilds. Instant payouts.'
    },
    '/p/play-n-go/rich_wilde_and_the_tome_of_insanity': {
        title: 'Play Rich Wilde and the Tome of Insanity | 10,000x Win | {brand}',
        description: 'Rich Wilde and the Tome of Insanity slot at {brand} crypto casino. Medium volatility, 10,000x max win with Wilds. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/rich_wilde_and_the_tome_of_madness': {
        title: 'Rich Wilde and the Tome of Madness Slot | {brand}',
        description: 'Rich Wilde and the Tome of Madness at {brand}. Medium volatility, 2,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/rich_wilde_and_the_wandering_city': {
        title: 'Play Rich Wilde And The Wandering City | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Rich Wilde And The Wandering City at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/riches_of_ra': {
        title: 'Play Riches Of Ra | 10,000x Max Win | {brand}',
        description: 'Riches Of Ra at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/riches_of_robin': {
        title: 'Play Riches Of Robin Slot | 10,000x Payout | {brand}',
        description: 'Spin Riches Of Robin with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/riddle_reels_a_case_of_riches': {
        title: 'Riddle Reels A Case Of Riches | {brand}',
        description: 'Deposit Bitcoin and play Riddle Reels A Case Of Riches at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/ring_of_odin': {
        title: 'Ring Of Odin Slot | 10,000x Max Win | {brand}',
        description: "Ring Of Odin slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/rings_of_prosperity': {
        title: 'Rings of Prosperity Slot | 5,000x Max Win | {brand}',
        description: 'Spin Rings of Prosperity with Bitcoin at {brand}. 5,000x max win, medium volatility, The Prosperity Wheel. Instant payouts, zero platform fees.'
    },
    '/p/play-n-go/rise_of_athena': {
        title: 'Rise Of Athena Slot | 10,000x Win | Play with Bitcoin',
        description: "Rise Of Athena by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/rise_of_dead': {
        title: 'Rise Of Dead Slot | Win Up to 10,000x | {brand}',
        description: 'Rise Of Dead at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/rise_of_gods_reckoning': {
        title: 'Play Rise Of Gods Reckoning | 10,000x Max Win | {brand}',
        description: 'Rise Of Gods Reckoning at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/rise_of_merlin': {
        title: 'Rise Of Merlin | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin Rise Of Merlin with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/rise_of_olympus': {
        title: 'Rise Of Olympus Slot | 10,000x Max Win | {brand}',
        description: "Rise Of Olympus by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/rise_of_olympus_100': {
        title: 'Rise Of Olympus 100 Slot | 10,000x Win | Play with Bitcoin',
        description: 'Spin Rise Of Olympus 100 with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/rise_of_olympus_1000': {
        title: 'Rise of Olympus 1000 Slot | 40,000x Max Win | {brand}',
        description: 'Spin Rise of Olympus 1000 with Bitcoin at {brand}. 40,000x max win, high volatility, Scatter Pays and Cascades. Instant payouts, zero platform fees.'
    },
    '/p/play-n-go/rise_of_olympus_extreme': {
        title: 'Rise of Olympus Extreme Slot | Win Up to 50,000x | {brand}',
        description: 'Rise of Olympus Extreme at {brand} crypto casino. 50,000x max win with Hand of God. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/play-n-go/rise_of_olympus_origins': {
        title: 'Rise of Olympus Origins Slot | 10,000x Win | {brand}',
        description: 'Rise of Olympus Origins slot with 10,000x max win and Wild. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/play-n-go/rise_of_orpheus': {
        title: 'Rise of Orpheus Slot | Win Up to 3,000x | {brand}',
        description: 'Rise of Orpheus slot at {brand} crypto casino. Medium volatility, 3,000x max win with The Reunion Feature. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/rocco_gallo': {
        title: 'Rocco Gallo Slot | Win Up to 10,000x | {brand}',
        description: 'Play Rocco Gallo slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/ronins_honour': {
        title: "Play Ronin's Honour Slot | 750,000x Payout | {brand}",
        description: "Ronin's Honour slot with 750,000x max win. High volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/rosy_orbit_treasure_turn': {
        title: 'Play Rosy Orbit Treasure Turn | 6,000x Win | {brand}',
        description: 'Deposit BTC and play Rosy Orbit Treasure Turn at {brand}. 6,000x max win, medium volatility, Treasure Turn. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/rotiki': {
        title: 'Rotiki | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Rotiki at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/royal_masquerade': {
        title: 'Play Royal Masquerade | 10,000x Max Win | {brand}',
        description: 'Play Royal Masquerade at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/ruff_heist': {
        title: 'Ruff Heist | 10,000x Max Win Bitcoin Slot | {brand}',
        description: 'Ruff Heist slot with 10,000x max win and Dog Collect Feature. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/play-n-go/sabaton': {
        title: 'Sabaton Slot | Win Up to 10,000x | {brand}',
        description: 'Play Sabaton slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/safari_of_wealth': {
        title: 'Safari Of Wealth Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit Bitcoin and play Safari Of Wealth at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/sails_of_gold': {
        title: 'Sails Of Gold Slot | 10,000x Max Win | {brand}',
        description: "Play Sails Of Gold by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/sails_of_riches': {
        title: 'Sails of Riches Slot | 10,000x Win | Play with Bitcoin',
        description: 'Spin Sails of Riches with Bitcoin at {brand}. 10,000x max win, medium volatility, Pirate Ship Jackpots. Instant payouts, zero platform fees.'
    },
    '/p/play-n-go/samba_carnival': {
        title: 'Samba Carnival Slot | 10,000x Max Win | {brand}',
        description: "Samba Carnival by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/scales_of_dead': {
        title: 'Scales of Dead Slot | Win Up to 2,000,000x | {brand}',
        description: 'Scales of Dead slot at {brand} crypto casino. High volatility with 2,000,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/scourge_of_rome': {
        title: 'Scourge of Rome Slot | Win Up to 10,000x | {brand}',
        description: 'Play Scourge of Rome at {brand}. High volatility, 10,000x max win. Features Scatters. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/scroll_of_dead': {
        title: 'Play Scroll Of Dead | 10,000x Max Win | {brand}',
        description: 'Scroll Of Dead slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/scroll_of_seth': {
        title: 'Play Scroll of Seth | 500,000x Max Win | {brand}',
        description: 'Play Scroll of Seth at {brand} crypto casino. High volatility, 500,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/sea_hunter': {
        title: 'Sea Hunter Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit Bitcoin and play Sea Hunter at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/secret_of_dead': {
        title: 'Secret Of Dead Slot | 10,000x Win | Play with Bitcoin',
        description: "Play Secret Of Dead by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/shamrock_miner': {
        title: 'Shamrock Miner | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Shamrock Miner slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/sherwood_gold': {
        title: 'Sherwood Gold | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Sherwood Gold slot for real money. 10,000x max win, Cash Bag Scatters. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/play-n-go/shimmering_woods': {
        title: 'Shimmering Woods Slot | Win Up to 25,000x | {brand}',
        description: 'Play Shimmering Woods slot for real money at {brand}. 25,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/sisters_of_the_sun': {
        title: 'Sisters Of The Sun Slot | Win Up to 10,000x | {brand}',
        description: 'Sisters Of The Sun slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/sizzling_spins': {
        title: 'Sizzling Spins Slot | Win Up to 10,000x | {brand}',
        description: 'Play Sizzling Spins at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/slashimi': {
        title: 'Slashimi Slot | Win Up to 500,000x | {brand}',
        description: 'Slashimi slot at {brand} crypto casino. Medium volatility with 500,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/sobeks_godly_spins': {
        title: "Sobek's Godly Spins Slot | 10,000x Max Win | {brand}",
        description: "Sobek's Godly Spins by Play'n GO. Medium volatility slot with 10,000x max win and Free Spins. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/space_race': {
        title: 'Play Space Race | 10,000x Win | {brand}',
        description: 'Space Race at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/spark_of_genius': {
        title: 'Spark of Genius Slot | 10,000x Win | Play with Bitcoin',
        description: "Spark of Genius by Play'n GO. High volatility slot with 10,000x max win and Manifest Energy. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/sparky_and_shortz': {
        title: 'Sparky & Shortz | 10x Max Win Bitcoin Slot | {brand}',
        description: "Sparky & Shortz slot with 10x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/sparky_and_shortz_hidden_joules': {
        title: 'Sparky & Shortz Hidden Joules Slot | 10,000x Win | {brand}',
        description: "Play Sparky & Shortz Hidden Joules by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/speed_cash': {
        title: 'Speed Cash Slot | 10,000x Max Win | {brand}',
        description: 'Spin Speed Cash with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/spin_party': {
        title: 'Spin Party Slot | 10,000x Win | Play with Bitcoin',
        description: "Play Spin Party by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/spinnin_records_into_the_beat': {
        title: 'Spinnin Records into the Beat Slot | Win Up to 4,000x | {brand}',
        description: 'Deposit BTC and play Spinnin Records into the Beat at {brand}. 4,000x max win, medium volatility, Step Up Feature. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/spinnin_records_raving_reels': {
        title: 'Spinnin Records Raving Reels Slot | Win Up to 3,000x | {brand}',
        description: 'Spinnin Records Raving Reels slot at {brand} crypto casino. Medium volatility, 3,000x max win with Level Progression. Deposit BTC, ETH, USDT.'
    },
    '/p/play-n-go/stadium_of_riches': {
        title: 'Stadium of Riches | 5,000x Max Win Crypto Slot | {brand}',
        description: 'Stadium of Riches at {brand} crypto casino. 5,000x max win with Scatter Symbols. Play with BTC, ETH, USDT. Instant payouts, no fees.'
    },
    '/p/play-n-go/star_joker': {
        title: 'Star Joker Slot | Win Up to 10,000x | {brand}',
        description: 'Star Joker at {brand}. Medium volatility, 10,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/static_nightmare': {
        title: 'Static Nightmare | 30,000x Max Win Crypto Slot | {brand}',
        description: 'Play Static Nightmare at {brand}. Medium volatility, 30,000x max win. Features Expanding Reels. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/stepping_diamonds': {
        title: 'Stepping Diamonds | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Stepping Diamonds slot at {brand} crypto casino. Medium volatility, 10,000x max win with Step n Win. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/sticky_joker': {
        title: 'Sticky Joker | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Sticky Joker by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/street_magic': {
        title: 'Street Magic | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Street Magic slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/super_flip': {
        title: 'Super Flip Slot | 10,000x Win | Play with Bitcoin',
        description: "Play Super Flip by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/super_flip_deluxe': {
        title: 'Super Flip Deluxe Slot | 1,200x Win | Play with Bitcoin',
        description: 'Super Flip Deluxe slot with 1,200x max win and Respin Feature. Medium volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/play-n-go/super_wheel': {
        title: 'Play Super Wheel Slot | 10,000x Payout | {brand}',
        description: 'Spin Super Wheel with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/sweet_27': {
        title: 'Play Sweet 27 | 10,000x Max Win | {brand}',
        description: 'Play Sweet 27 slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/sweet_alchemy': {
        title: 'Play Sweet Alchemy | 10,000x Win | {brand}',
        description: 'Play Sweet Alchemy slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/sweet_alchemy_100': {
        title: 'Play Sweet Alchemy 100 | 15,000x Max Win | {brand}',
        description: 'Sweet Alchemy 100 at {brand}. Medium volatility, 15,000x max win. Play with BTC, ETH, USDT, DOGE and more. Instant payouts.'
    },
    '/p/play-n-go/sweet_alchemy_2': {
        title: 'Sweet Alchemy 2 | 1,000,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Sweet Alchemy 2 by Play'n GO at {brand}. High volatility, 1,000,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/sweet_alchemy_bingo': {
        title: 'Play Sweet Alchemy Bingo | 10,000x Win | {brand}',
        description: 'Play Sweet Alchemy Bingo slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/tale_of_kyubiko': {
        title: 'Tale of Kyubiko Slot | 2,250x Max Win | {brand}',
        description: "Tale of Kyubiko by Play'n GO. Medium volatility slot with 2,250x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/tales_of_asgard_freyas_wedding': {
        title: 'Play Tales Of Asgard Freyas Wedding | 10,000x Max Win | {brand}',
        description: 'Play Tales Of Asgard Freyas Wedding at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/tales_of_asgard_lokis_fortune': {
        title: 'Tales Of Asgard Lokis Fortune | {brand}',
        description: "Tales Of Asgard Lokis Fortune by Play'n GO. Medium volatility slot with 10,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/tales_of_mithrune_syns_fortune': {
        title: "Play Tales of Mithrune Syn's Fortune | 10,000x Win | {brand}",
        description: "Deposit BTC and play Tales of Mithrune Syn's Fortune at {brand}. 10,000x max win, medium volatility, Free Spins. 9 cryptos, zero fees."
    },
    '/p/play-n-go/temple_of_prosperity': {
        title: 'Temple of Prosperity Slot | 100,000x Win | Play with Bitcoin',
        description: 'Spin Temple of Prosperity with Bitcoin at {brand}. 100,000x max win, high volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/temple_of_tollan': {
        title: 'Temple of Tollan Slot | Win Up to 10,000x | {brand}',
        description: 'Play Temple of Tollan slot for real money. 10,000x max win, Special Symbols. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/play-n-go/temple_of_wealth': {
        title: 'Temple Of Wealth Slot | 10,000x Max Win | {brand}',
        description: "Play Temple Of Wealth by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/ternion': {
        title: 'Ternion Slot | 10,000x Max Win | {brand}',
        description: "Play Ternion by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/testament': {
        title: 'Testament | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Play Testament by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/thats_rich': {
        title: 'Play Thats Rich Slot | 10,000x Payout | {brand}',
        description: 'Spin Thats Rich with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/the_faces_of_freya': {
        title: 'The Faces Of Freya | 10,000x Max Win Crypto Slot | {brand}',
        description: 'The Faces Of Freya slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/the_green_knight': {
        title: 'Play The Green Knight Slot | 10,000x Payout | {brand}',
        description: "Play The Green Knight by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/the_green_knight_oath_of_thorns': {
        title: 'The Green Knight Oath of Thorns Slot | 14,000x Max Win | {brand}',
        description: "Play The Green Knight Oath of Thorns by Play'n GO. 14,000x max win, Wild Multipliers, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/the_last_sundown': {
        title: 'The Last Sundown Slot | 10,000x Max Win | {brand}',
        description: "Play The Last Sundown by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/the_paying_piano_club': {
        title: 'The Paying Piano Club Slot | 5,000x Max Win | {brand}',
        description: "Play The Paying Piano Club by Play'n GO at {brand}. Medium volatility, 5,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/the_return_of_the_green_knight': {
        title: 'The Return of the Green Knight | {brand}',
        description: 'The Return of the Green Knight slot at {brand} crypto casino. High volatility, 10,000x max win with Wild Multipliers. Deposit BTC, ETH, USDT.'
    },
    '/p/play-n-go/the_sword_and_the_grail': {
        title: 'The Sword And The Grail Slot | 10,000x Max Win | {brand}',
        description: "Play The Sword And The Grail by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/the_sword_and_the_grail_excalibur': {
        title: 'The Sword and the Grail Excalibur Slot | 10,000x Win | {brand}',
        description: 'The Sword and the Grail Excalibur slot with 10,000x max win and Grail Wild. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/play-n-go/the_wild_class': {
        title: 'The Wild Class Slot | 10,000x Win | Play with Bitcoin',
        description: "Play The Wild Class by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/thunderscreech': {
        title: 'Thunderscreech Slot | 5,000x Max Win | {brand}',
        description: "Play Thunderscreech by Play'n GO at {brand}. Medium volatility, 5,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/tomb_of_gold': {
        title: 'Tomb of Gold Reimagined Slot | 10,000x Win | {brand}',
        description: "Play Tomb of Gold Reimagined by Play'n GO. 10,000x max win, Multiplier Wilds, low volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/tomb_of_gold_ii': {
        title: 'Tomb of Gold II Slot | Win Up to 10,000x | {brand}',
        description: 'Play Tomb of Gold II slot for real money. 10,000x max win, 21+3. Deposit with BTC, ETH and 7 more cryptos. Withdraw instantly.'
    },
    '/p/play-n-go/tome_of_madness_bingo': {
        title: 'Tome Of Madness Bingo Slot | 4,250x Max Win | {brand}',
        description: "Play Tome Of Madness Bingo by Play'n GO. 4,250x max win, Extra Ball, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/treasures_of_kongar': {
        title: 'Treasures of Kongar Slot | 10,000x Max Win | {brand}',
        description: "Play Treasures of Kongar by Play'n GO at {brand}. Medium volatility, 10,000x max win, Gemstone Collection. 9 cryptos accepted, instant withdrawals."
    },
    '/p/play-n-go/treats_of_terror': {
        title: 'Treats of Terror Slot | Win Up to 10,000x | {brand}',
        description: 'Treats of Terror slot at {brand} crypto casino. Medium volatility, 10,000x max win with Scatter Pays and Cascades. Deposit BTC, ETH, USDT. No fees.'
    },
    '/p/play-n-go/trinity_impact': {
        title: 'Play Trinity Impact | 1,600x Max Win | {brand}',
        description: 'Play Trinity Impact at {brand}. Medium volatility, 1,600x max win. Features Dynamic Wilds. 9 cryptos, instant withdrawals, no fees.'
    },
    '/p/play-n-go/troll_hunters': {
        title: 'Troll Hunters | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Troll Hunters slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/troll_hunters_2': {
        title: 'Troll Hunters 2 Slot | Win Up to 10,000x | {brand}',
        description: 'Play Troll Hunters 2 slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/undefeated_xerxes': {
        title: 'Undefeated Xerxes | 10,000x Max Win Bitcoin Slot | {brand}',
        description: "Undefeated Xerxes by Play'n GO. High volatility slot with 10,000x max win and Scatter. Play with Bitcoin at {brand}. Fast withdrawals."
    },
    '/p/play-n-go/usa_flip': {
        title: 'USA Flip | 1,000x Max Win Bitcoin Slot | {brand}',
        description: 'Spin USA Flip with Bitcoin at {brand}. 1,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/viking_apocalypse': {
        title: 'Play Viking Apocalypse | 1,000,000x Max Win | {brand}',
        description: 'Play Viking Apocalypse at {brand} crypto casino. High volatility, 1,000,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/viking_runecraft': {
        title: 'Viking Runecraft Slot | 10,000x Win | Play with Bitcoin',
        description: "Viking Runecraft slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/viking_runecraft_100': {
        title: 'Viking Runecraft 100 Slot | 10,000x Max Win | {brand}',
        description: 'Viking Runecraft 100 slot with 10,000x max win and Free Spins. High volatility. Play with Bitcoin at {brand}. Instant crypto payouts.'
    },
    '/p/play-n-go/viking_runecraft_bingo': {
        title: 'Viking Runecraft Bingo Slot | 10,000x Win | {brand}',
        description: "Viking Runecraft Bingo slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/viper_city_heist': {
        title: 'Viper City Heist Slot | Win Up to 15,000x | {brand}',
        description: 'Deposit BTC and play Viper City Heist at {brand}. 15,000x max win, medium volatility, Quick Hit. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/wheel_of_mictlan': {
        title: 'Wheel of Mictlan Slot | Win Up to 40,000x | {brand}',
        description: 'Deposit BTC and play Wheel of Mictlan at {brand}. 40,000x max win, medium volatility, Flip Wilds. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/whispering_winds': {
        title: 'Play Whispering Winds | 2,000x Max Win | {brand}',
        description: 'Deposit BTC and play Whispering Winds at {brand}. 2,000x max win, medium volatility, Gold Re-spins. 9 cryptos, zero fees.'
    },
    '/p/play-n-go/wild_bandolier': {
        title: 'Play Wild Bandolier Slot | 900,000x Payout | {brand}',
        description: 'Spin Wild Bandolier with Bitcoin at {brand}. 900,000x max win, high volatility, Supports free game. Instant payouts, zero platform fees.'
    },
    '/p/play-n-go/wild_blood': {
        title: 'Wild Blood Slot | 10,000x Win | Play with Bitcoin',
        description: "Wild Blood slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/wild_blood_2': {
        title: 'Wild Blood 2 Slot | Win Up to 10,000x | {brand}',
        description: 'Deposit Bitcoin and play Wild Blood 2 at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/wild_falls': {
        title: 'Wild Falls Slot | 10,000x Max Win | {brand}',
        description: "Play Wild Falls by Play'n GO at {brand}. Medium volatility, 10,000x max win. 9 cryptos accepted, instant withdrawals, no fees."
    },
    '/p/play-n-go/wild_falls_2': {
        title: 'Wild Falls 2 Slot | Win Up to 10,000x | {brand}',
        description: 'Wild Falls 2 slot at {brand} crypto casino. Medium volatility with 10,000x max win. Deposit BTC, ETH, USDT and more. Fast payouts.'
    },
    '/p/play-n-go/wild_frames': {
        title: 'Wild Frames Slot | 10,000x Max Win | {brand}',
        description: 'Spin Wild Frames with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    },
    '/p/play-n-go/wild_melon': {
        title: 'Wild Melon | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Play Wild Melon slot for real money at {brand}. 10,000x max win, medium volatility. BTC, ETH and 7 more cryptos accepted.'
    },
    '/p/play-n-go/wild_north': {
        title: 'Wild North Radiant Skies | 2,000x Max Win Crypto Slot | {brand}',
        description: 'Play Wild North Radiant Skies at {brand}. Low volatility, 2,000x max win. Features Footprint Overlay Symbols. 9 cryptos, instant withdrawals.'
    },
    '/p/play-n-go/wild_rails': {
        title: 'Play Wild Rails | 10,000x Win | {brand}',
        description: 'Deposit Bitcoin and play Wild Rails at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/wild_survivor': {
        title: 'Wild Survivor Slot | 10,000x Max Win | {brand}',
        description: "Play Wild Survivor by Play'n GO. 10,000x max win, Scatter, medium volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/wild_trigger': {
        title: 'Wild Trigger Slot | 2,000x Max Win | {brand}',
        description: "Wild Trigger by Play'n GO. Medium volatility slot with 2,000x max win. Play with Bitcoin at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/wildest_gambit': {
        title: 'Wildest Gambit Slot | 10,000x Win | Play with Bitcoin',
        description: "Play Wildest Gambit by Play'n GO. 10,000x max win, Wilds, high volatility. Bitcoin deposits, instant withdrawals at {brand}."
    },
    '/p/play-n-go/wildhound_derby': {
        title: 'Wildhound Derby Slot | 10,000x Max Win | {brand}',
        description: "Play Wildhound Derby by Play'n GO. Medium volatility, 10,000x max win. Crypto deposits and instant withdrawals at {brand}."
    },
    '/p/play-n-go/winabeest': {
        title: 'Winabeest | 10,000x Max Win Crypto Slot | {brand}',
        description: 'Deposit Bitcoin and play Winabeest at {brand}. 10,000x max win, medium volatility. 9 cryptos supported, zero fees.'
    },
    '/p/play-n-go/wizard_of_gems': {
        title: 'Wizard Of Gems Slot | Win Up to 10,000x | {brand}',
        description: 'Play Wizard Of Gems at {brand} crypto casino. Medium volatility, 10,000x max win. Deposit with BTC, ETH, USDT. No fees, fast payouts.'
    },
    '/p/play-n-go/xmas_joker': {
        title: 'Xmas Joker Slot | 10,000x Max Win | {brand}',
        description: "Xmas Joker slot with 10,000x max win. Medium volatility by Play'n GO. Play with crypto at {brand}. Instant withdrawals."
    },
    '/p/play-n-go/xmas_magic': {
        title: 'Xmas Magic Slot | 10,000x Win | Play with Bitcoin',
        description: 'Spin Xmas Magic with Bitcoin at {brand}. 10,000x max win, medium volatility. Instant crypto withdrawals, zero platform fees.'
    }
};
export const gameSeo = {
    ...gameSeoBase,
    ...gameSeoUploaded
};
export function normalizeGameSeoPath(pathname) {
    const clean = pathname.replace(/\/$/, '').split('?')[0] || '';
    const pIdx = clean.indexOf('/p/');
    if (pIdx < 0)
        return null;
    const parts = clean.slice(pIdx).split('/').filter(Boolean);
    if (parts.length < 3 || parts[0] !== 'p')
        return null;
    if (parts.length > 3)
        return null;
    const [, providerSlug, gameSlug] = parts;
    return `/p/${providerSlug}/${gameSlug}`;
}
export function getGameSeo(pathname) {
    const key = normalizeGameSeoPath(pathname);
    if (!key)
        return undefined;
    return gameSeo[key];
}
export function applyGameSeoBrandSubstitution(title, description, companyName) {
    const withBrand = (s) => s.replace(/\{brand\}/g, companyName);
    return {
        title: withBrand(title),
        description: withBrand(description)
    };
}
